
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("3B1VX", function(module, exports) {
"use strict";
var __extends = this && this.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Text = void 0;

var $k6KGm = parcelRequire("k6KGm");

var $6wI3m = parcelRequire("6wI3m");
var Text = /** @class */ function(_super) {
    __extends(Text, _super);
    function Text(ref, transform) {
        if (ref === void 0) ref = new $6wI3m.Ref("");
        var _this = this;
        if (typeof ref === "string") ref = new $6wI3m.Ref(ref);
        _this = _super.call(this, "span", ref) || this;
        _this.transform = transform;
        _this.defaultText = "";
        _this.Refresh();
        return _this;
    }
    Text.prototype.DefaultText = function(text) {
        this.defaultText = text;
        this.SetText();
        return this;
    };
    Text.prototype.SetText = function() {
        var _a, _b;
        var text = (_b = (_a = this.transform) === null || _a === void 0 ? void 0 : _a.call(this, this.ref.value)) !== null && _b !== void 0 ? _b : this.ref.value != null ? String(this.ref.value) : "";
        if (this.defaultText != "" && text === "") text = this.defaultText;
        this.Text(text);
    };
    Text.prototype.Refresh = function() {
        this.SetText();
        if (this.showThatChanged) this.ref.HasChanged ? this.element.classList.add("tf-value-changed") : this.element.classList.remove("tf-value-changed");
    };
    Text.Name = "Text";
    return Text;
}($k6KGm.RefComponentBase);
exports.Text = Text;

});
parcelRegister("k6KGm", function(module, exports) {
"use strict";
var $ea389448cd545331$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RefComponentBase = void 0;

var $aKtiT = parcelRequire("aKtiT");
var $ea389448cd545331$var$RefComponentBase = /** @class */ function(_super) {
    $ea389448cd545331$var$__extends(RefComponentBase, _super);
    function RefComponentBase(baseElement, ref) {
        var _this = _super.call(this, baseElement) || this;
        _this.ref = ref;
        _this.showThatChanged = RefComponentBase.ShowThatChanged;
        _this.IsRefComponent = true;
        if (ref) ref.AddSubscriber(_this);
        return _this;
    }
    Object.defineProperty(RefComponentBase.prototype, "Value", {
        get: function() {
            if (!this.ref) return undefined;
            return this.ref.value;
        },
        set: function(value) {
            if (!this.ref) return;
            this.ref.value = value;
        },
        enumerable: false,
        configurable: true
    });
    RefComponentBase.prototype.SetValue = function(value) {
        if (!value) return this;
        if (!this.ref) return this;
        this.ref.value = value;
        return this;
    };
    Object.defineProperty(RefComponentBase.prototype, "Ref", {
        get: function() {
            return this.ref;
        },
        enumerable: false,
        configurable: true
    });
    RefComponentBase.prototype.ShowThatChanged = function(showOrNot) {
        if (showOrNot === void 0) showOrNot = true;
        this.showThatChanged = showOrNot;
        return this;
    };
    RefComponentBase.prototype.Dispose = function() {
        var _a;
        (_a = this.ref) === null || _a === void 0 || _a.RemoveControl(this);
    };
    RefComponentBase.ShowThatChanged = false;
    return RefComponentBase;
}($aKtiT.ComponentBase);
module.exports.RefComponentBase = $ea389448cd545331$var$RefComponentBase;

});
parcelRegister("aKtiT", function(module, exports) {
"use strict";
var $7d34ee63d945b320$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $7d34ee63d945b320$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ComponentBase = void 0;

var $6wI3m = parcelRequire("6wI3m");
parcelRequire("fg7nO");

var $8lUZH = parcelRequire("8lUZH");

var $5uACL = parcelRequire("5uACL");
var $7d34ee63d945b320$var$ComponentBase = /** @class */ function() {
    function ComponentBase(baseElement) {
        this.baseElement = baseElement;
        this.id = -1;
        this.Name = "";
        this.IsRefComponent = false; // TODO: xxx
        this.Children = new $8lUZH.ChildrenCollection(this);
        this.displayAs = "";
        this.toggableStyles = {};
        this.isVisible = true;
        ComponentBase.Id += 1;
        this.id = ComponentBase.Id;
        this.element = ComponentBase.Create(baseElement);
        this.events = new $5uACL.EventsContainer(this.element);
        if (this.element instanceof HTMLElement) {
            var style = window === null || window === void 0 ? void 0 : window.getComputedStyle(this.element);
            this.displayAs = (style === null || style === void 0 ? void 0 : style.display) || "";
        }
    }
    ComponentBase.prototype.toString = function() {
        var _a;
        return "".concat(this.ID, ": parent=").concat((_a = this.Parent) === null || _a === void 0 ? void 0 : _a.ID, ", children=").concat(this.Children.toString());
    };
    Object.defineProperty(ComponentBase.prototype, "ID", {
        get: function() {
            return "[#".concat(this.id, ":").concat(this.baseElement).concat(this.Name ? ":" + this.Name : "").concat(this.IsRefComponent ? "(REF)" : "", "]");
        },
        enumerable: false,
        configurable: true
    });
    ComponentBase.prototype.LOG = function(str) {
        if (ComponentBase.LogEn) console.log(str);
    };
    ComponentBase.prototype.NameIt = function(name) {
        this.Name = name;
        return this;
    };
    //#endregion
    //#region CORE
    ComponentBase.prototype.React = function(valueOrRef, callback) {
        if (valueOrRef == undefined) return;
        if (!callback) throw new Error("Callback must be provided");
        else if (valueOrRef instanceof $6wI3m.Ref) valueOrRef.OnChange(function(v) {
            callback(v);
        }, true);
        else callback(valueOrRef);
    };
    ComponentBase.prototype.Reacts = function(valueOrRef, callback) {
        if (valueOrRef == undefined) return;
        if (!callback) throw new Error("Callback must be provided");
        if (valueOrRef instanceof Array) {
            var values_1 = [];
            valueOrRef.forEach(function(r, i) {
                values_1.push(r.value);
                r.OnChange(function(v) {
                    values_1[i] = v;
                    callback.apply(void 0, values_1);
                });
            });
            callback.apply(void 0, values_1);
        } else if (valueOrRef instanceof $6wI3m.Ref) valueOrRef.OnChange(function(v) {
            callback(v);
        }, true);
        else callback(valueOrRef);
    };
    ComponentBase.prototype.Clear = function() {
        var _this = this;
        this.Children.Clone.forEach(function(c) {
            _this.Remove(c);
        });
        return this;
    };
    ComponentBase.prototype.Dispose = function() {
    // this.LOG(`💥 Disposing ${this.ID}...`);
    };
    ComponentBase.prototype.Remove = function(component) {
        var _a;
        if (!component) throw new Error("Parameter is mandatory");
        // this.LOG(`➖ Removing ${component.ID} from ${this.ID} (children: ${this.Children.map(x=>"#"+x.Id)})...`);
        this.LOG("\u2796 ".concat(this.ID, " -= ").concat(component.ID));
        if (!this.Children.Has(component)) throw new Error("This is not your (".concat(this.ID, ") kid (").concat(component.ID, ")"));
        (_a = component.OnRemove) === null || _a === void 0 || _a.call(component); // czemu to jest jeszcze przed usunięciem a nie po?
        component.Children.Clone.forEach(function(c) {
            component.Remove(c);
        });
        if (this.Children.Remove(component)) {
            component.Dispose();
            this.element.Remove(component.element);
        }
        return this;
    };
    ComponentBase.prototype.AddComponent = function(component) {
        if (!component) throw new Error("[TRUFFLE] Parameter/component to add is mandatory (Forget return 'this' from your component method?)");
        if (component == this) throw new Error("[TRUFFLE] You can't be child of yourself");
        if (this.Children.Has(component)) throw new Error("[TRUFFLE] ".concat(component.ID, " was already added to ").concat(this.ID));
        component.Parent = this;
        // this.LOG(`➕ ${this.ID} += ${component.ID}`);
        this.Children.Add(component);
    };
    ComponentBase.prototype.Prepend = function() {
        var _this = this;
        var components = [];
        for(var _i = 0; _i < arguments.length; _i++)components[_i] = arguments[_i];
        components.forEach(function(component) {
            var _a;
            if (component == undefined || component == null) ;
            else if (typeof component == "boolean") ;
            else if (typeof component == "number") {
                var num = component;
                var span = new ComponentBase("span");
                span.Text(num.toString());
                _this.AddComponent(span);
                _this.element.Append(span.Element);
            } else if (typeof component == "string") {
                var str = component;
                var splitted_1 = str.split("\n");
                if (splitted_1.length > 1) splitted_1.forEach(function(s, i) {
                    // We can't use Span (<span>) component here (because it derives from this ComponentBase) so we need to create it on the fly
                    var span = new ComponentBase("span");
                    span.Text(s);
                    _this.AddComponent(span);
                    _this.element.Prepend(span.Element);
                    // Put NewLine (<br>) between strings except last one
                    if (i != splitted_1.length - 1) {
                        // We can't use NewLine (<br>) component here (because it derives from this ComponentBase) so we need to create it on the fly
                        var br = new ComponentBase("br");
                        _this.AddComponent(br);
                        _this.element.Prepend(br.Element);
                    }
                });
                else {
                    // We can't use Span (<span>) component here (because it derives from this ComponentBase) so we need to create it on the fly
                    var span = new ComponentBase("span");
                    span.Text(str);
                    _this.AddComponent(span);
                    _this.element.Prepend(span.Element);
                }
            } else {
                _this.AddComponent(component); // AddChild?
                _this.element.Prepend(component.Element);
                (_a = component.OnAppend) === null || _a === void 0 || _a.call(component);
            }
        });
        return this;
    };
    // public Append(...components: (string | boolean | number | undefined | null | ComponentBase<HTMLElement>)[]): this
    ComponentBase.prototype.Append = function() {
        var _this = this;
        var components = [];
        for(var _i = 0; _i < arguments.length; _i++)components[_i] = arguments[_i];
        components.forEach(function(component) {
            var _a;
            if (component == undefined || component == null) ;
            else if (typeof component == "boolean") ;
            else if (typeof component == "number") {
                var num = component;
                var span = new ComponentBase("span");
                span.Text(num.toString());
                _this.AddComponent(span);
                _this.element.Append(span.Element);
            } else if (typeof component == "string") {
                var str = component;
                var splitted_2 = str.split("\n");
                if (splitted_2.length > 1) splitted_2.forEach(function(s, i) {
                    // We can't use Span (<span>) component here (because it derives from this ComponentBase) so we need to create it on the fly
                    var span = new ComponentBase("span");
                    span.Text(s);
                    _this.AddComponent(span);
                    _this.element.Append(span.Element);
                    // Put NewLine between strings except last one
                    if (i != splitted_2.length - 1) {
                        // We can't use NewLine (<br>) component here (because it derives from this ComponentBase) so we need to create it on the fly
                        var br = new ComponentBase("br");
                        _this.AddComponent(br);
                        _this.element.Append(br.Element);
                    }
                });
                else {
                    // We can't use Span (<span>) component here (because it derives from this ComponentBase) so we need to create it on the fly
                    var span = new ComponentBase("span");
                    span.Text(str);
                    _this.AddComponent(span);
                    _this.element.Append(span.Element);
                }
            } else {
                _this.AddComponent(component);
                _this.element.Append(component.Element);
                if (_this.element instanceof HTMLElement) {
                    var style = window === null || window === void 0 ? void 0 : window.getComputedStyle(_this.element);
                    _this.displayAs = (style === null || style === void 0 ? void 0 : style.display) || "";
                }
                (_a = component.OnAppend) === null || _a === void 0 || _a.call(component);
            }
        });
        return this;
    };
    ComponentBase.prototype.LoadContent = function() {
        var _a;
        var content = [];
        for(var _i = 0; _i < arguments.length; _i++)content[_i] = arguments[_i];
        return (_a = this.Clear()).Append.apply(_a, content);
    };
    ComponentBase.prototype.RemoveSelf = function() {
        var _a, _b, _c;
        if ((_b = (_a = this.Parent) === null || _a === void 0 ? void 0 : _a.Children) === null || _b === void 0 ? void 0 : _b.Has(this)) (_c = this.Parent) === null || _c === void 0 || _c.Remove(this);
        return this;
    };
    ComponentBase.prototype.SearchUp = function(predicate) {
        var p = this.Parent;
        if (p == undefined) return undefined;
        while(!predicate(p)){
            p = p === null || p === void 0 ? void 0 : p.Parent;
            if (p == undefined) return undefined;
        }
        return p;
    };
    ComponentBase.prototype.SearchDown = function(predicate) {
        return this.Children.Search(predicate);
    };
    Object.defineProperty(ComponentBase.prototype, "HasAnyChildren", {
        get: function() {
            return this.Children.Count > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ComponentBase.prototype, "Element", {
        get: function() {
            return this.element;
        },
        enumerable: false,
        configurable: true
    });
    ComponentBase.Create = function(htmlElement) {
        return document.createElement(htmlElement);
    };
    ComponentBase.prototype.DisplayAs = function(as) {
        this.displayAs = as;
        return this;
    };
    //#endregion CORE
    //#region STYLING-ATTRIBUTES
    ComponentBase.prototype.Attribute = function(key, value) {
        var _this = this;
        if (!key) return this;
        if (!value) {
            this.element.setAttribute(key, "");
            return this;
        }
        this.React(value, function(v) {
            return _this.element.setAttribute(key, v || "");
        });
        return this;
    };
    ComponentBase.prototype.GetAttribute = function(key) {
        return this.element.getAttribute(key);
    };
    ComponentBase.prototype.RemoveAttribute = function(key) {
        this.element.removeAttribute(key);
        return this;
    };
    ComponentBase.prototype.TestAttr = function(id) {
        return this.Attribute('data-test', id);
    };
    ComponentBase.prototype.SetStyle = function(property, value, postfix) {
        var _this = this;
        if (postfix === void 0) postfix = "";
        this.React(value, function(v) {
            return _this.SetSingleStyle(property, v.toString() + postfix);
        });
        return this;
    };
    //#endregion
    //#region STYLING-CLASS
    ComponentBase.prototype.Class = function(cssClassesToAdd) {
        var _this = this;
        this.React(cssClassesToAdd, function(v) {
            return v.split(" ").filter(function(x) {
                return x.length > 0;
            }).forEach(function(c) {
                return _this.element.classList.add(c);
            });
        });
        return this;
    };
    ComponentBase.prototype.RemoveAllClasses = function() {
        while(this.element.classList.length > 0)this.element.classList.remove(this.element.classList.item(0) || "");
        return this;
    };
    ComponentBase.prototype.RemoveClass = function(cssClassName) {
        if (cssClassName) this.element.classList.remove(cssClassName);
        return this;
    };
    // TODO: remove
    ComponentBase.prototype.AddClass = function(cssClassName) {
        if (cssClassName) this.element.classList.add(cssClassName);
        return this;
    };
    ComponentBase.prototype.ToggleClasses = function(classA, classB) {
        if (this.element.classList.contains(classA)) {
            this.element.classList.remove(classA);
            this.element.classList.add(classB);
        } else {
            this.element.classList.remove(classB);
            this.element.classList.add(classA);
        }
        return this;
    };
    //#endregion
    //#region STYLING-UTILS
    ComponentBase.prototype.Style = function(propertyOrCss, val) {
        var _this = this;
        if (!propertyOrCss) return this;
        else if (propertyOrCss instanceof $6wI3m.Ref) propertyOrCss.OnChange(function(v) {
            v.split(";").map(function(x) {
                return x.trim();
            }).forEach(function(x) {
                return _this.SetSingleStyle(x);
            });
        }, true);
        else if (propertyOrCss.includes(";")) propertyOrCss.split(";").map(function(x) {
            return x.trim();
        }).forEach(function(x) {
            return _this.SetSingleStyle(x);
        });
        else this.SetSingleStyle(propertyOrCss, val);
        return this;
    };
    ComponentBase.prototype.SetSingleStyle = function(propertyOrCss, val) {
        if (val !== undefined) this.element.style[propertyOrCss] = val;
        else {
            var _a = propertyOrCss.split(":").map(function(x) {
                return x.trim();
            }), key = _a[0], value = _a[1];
            this.element.style[key] = value;
        }
        return this;
    };
    ComponentBase.prototype.ApplyStyle = function(val, is, property, value, elseValue, callRightaway) {
        var _this = this;
        if (callRightaway === void 0) callRightaway = true;
        val.OnChange(function(v) {
            v == is ? _this.Style(property, value) : _this.Style(property, elseValue);
        }, callRightaway);
        return this;
    };
    ComponentBase.prototype.ApplyClass = function(val, predicate, className, callRightaway) {
        var _this = this;
        if (callRightaway === void 0) callRightaway = true;
        val.OnChange(function(v) {
            predicate(v, val, _this) ? _this.AddClass(className) : _this.RemoveClass(className);
        }, callRightaway);
        return this;
    };
    ComponentBase.prototype.When = function(ref, predicate, whenTrue, whenFalse, callRightaway) {
        var _this = this;
        if (callRightaway === void 0) callRightaway = true;
        ref.OnChange(function(v) {
            predicate(v, ref, _this) ? whenTrue(_this, ref) : whenFalse === null || whenFalse === void 0 || whenFalse(_this, ref);
        }, callRightaway);
        return this;
    };
    ComponentBase.prototype.ToggleStyle = function(prop, val, elseVal) {
        /* COMPUTED VALUE IS COMPLETELY DIFFERENT FROM SET. THAT'S WHY. */ if (this.toggableStyles[prop] !== val) this.toggableStyles[prop] = val;
        else this.toggableStyles[prop] = elseVal;
        this.element.style[prop] = this.toggableStyles[prop];
        return this;
    };
    //#endregion
    //#region STYLING-MISC
    ComponentBase.prototype.Cursor = function(cursor) {
        this.element.style.cursor = cursor;
        return this;
    };
    ComponentBase.prototype.CursorPointer = function() {
        return this.Cursor("pointer");
    };
    ComponentBase.prototype.CursorDefault = function() {
        return this.Cursor("default");
    };
    ComponentBase.prototype.Focus = function() {
        this.element.Focus();
        return this;
    };
    ComponentBase.prototype.ScrollToBottom = function() {
        this.element.scrollTop = this.element.scrollHeight;
        return this;
    };
    //#endregion
    //#region STYLING-VISUAL
    ComponentBase.prototype.ZIndex = function(index) {
        return this.SetStyle("zIndex", index);
    };
    ComponentBase.prototype.Opacity = function(opacity) {
        return this.SetStyle("opacity", opacity);
    };
    ComponentBase.prototype.Blur = function(value, unit) {
        var _this = this;
        if (unit === void 0) unit = "px";
        this.React(value, function(v) {
            return _this.SetSingleStyle("filter: blur(".concat(value).concat(unit, ")"));
        });
        return this;
    };
    //#endregion
    //#region STYLING-TEXT
    ComponentBase.prototype.Bold = function(enable) {
        var _this = this;
        if (enable === void 0) enable = true;
        this.React(enable, function(v) {
            return v ? _this.SetSingleStyle("font-weight", "bold") : _this.SetSingleStyle("font-weight", "normal");
        });
        return this;
    };
    ComponentBase.prototype.FontBold = function(enable) {
        if (enable === void 0) enable = true;
        return this.Bold(enable);
    };
    ComponentBase.prototype.Normal = function(enable) {
        if (enable === void 0) enable = true;
        return this.Style("font-weight: normal; font-style: normal");
    };
    ComponentBase.prototype.FontNormal = function() {
        return this.Style("font-weight: normal; font-style: normal");
    };
    ComponentBase.prototype.FontWeight = function(value) {
        return this.SetStyle("font-weight", value);
    };
    ComponentBase.prototype.FontWeightNormal = function() {
        return this.Style("font-weight", "normal");
    };
    ComponentBase.prototype.FontWeightBold = function() {
        return this.Style("font-weight", "bold");
    };
    ComponentBase.prototype.Italic = function(enable) {
        var _this = this;
        if (enable === void 0) enable = true;
        this.React(enable, function(v) {
            return v ? _this.SetSingleStyle("font-style", "italic") : _this.SetSingleStyle("font-style", "normal");
        });
        return this;
    };
    ComponentBase.prototype.FontItalic = function(enable) {
        if (enable === void 0) enable = true;
        return this.Italic(enable);
    };
    ComponentBase.prototype.FontSize = function(size, unit) {
        if (unit === void 0) unit = "px";
        return this.SetStyle("font-size", size, unit);
    };
    ComponentBase.prototype.TextAlign = function(align) {
        return this.SetStyle('text-align', align);
    };
    ComponentBase.prototype.TextAlignLeft = function() {
        this.element.style.textAlign = "left";
        return this;
    };
    ComponentBase.prototype.TextAlignRight = function() {
        this.element.style.textAlign = "right";
        return this;
    };
    ComponentBase.prototype.TextAlignCenter = function() {
        this.element.style.textAlign = "center";
        return this;
    };
    //#endregion STYLING-TEXT
    //#region STYLING-POSITION
    ComponentBase.prototype.Position = function(position) {
        this.element.style.position = position;
        return this;
    };
    ComponentBase.prototype.PositionAbsolute = function() {
        this.element.style.position = "absolute";
        return this;
    };
    ComponentBase.prototype.PositionRelative = function() {
        this.element.style.position = "relative";
        return this;
    };
    ComponentBase.prototype.PositionFixed = function() {
        this.element.style.position = "fixed";
        return this;
    };
    ComponentBase.prototype.Left = function(left, unit) {
        var _this = this;
        if (left === void 0) left = 0;
        if (unit === void 0) unit = "px";
        this.React(left, function(v) {
            return _this.element.style.left = v + unit;
        });
        return this;
    };
    ComponentBase.prototype.LeftPercent = function(left) {
        var _this = this;
        if (left === void 0) left = 0;
        this.React(left, function(v) {
            return _this.Left(v, "%");
        });
        return this;
    };
    ComponentBase.prototype.Right = function(right, unit) {
        var _this = this;
        if (right === void 0) right = 0;
        if (unit === void 0) unit = "px";
        this.React(right, function(v) {
            return _this.element.style.right = v + unit;
        });
        return this;
    };
    ComponentBase.prototype.RightPercent = function(right) {
        var _this = this;
        if (right === void 0) right = 0;
        this.React(right, function(v) {
            return _this.Right(v, "%");
        });
        return this;
    };
    ComponentBase.prototype.Top = function(top, unit) {
        var _this = this;
        if (top === void 0) top = 0;
        if (unit === void 0) unit = "px";
        this.React(top, function(v) {
            return _this.element.style.top = v + unit;
        });
        return this;
    };
    ComponentBase.prototype.TopPercent = function(top) {
        var _this = this;
        if (top === void 0) top = 0;
        this.React(top, function(v) {
            return _this.Top(v, "%");
        });
        return this;
    };
    ComponentBase.prototype.Bottom = function(bottom, unit) {
        var _this = this;
        if (bottom === void 0) bottom = 0;
        if (unit === void 0) unit = "px";
        this.React(bottom, function(v) {
            return _this.element.style.bottom = v + unit;
        });
        return this;
    };
    ComponentBase.prototype.BottomPercent = function(bottom) {
        var _this = this;
        if (bottom === void 0) bottom = 0;
        this.React(bottom, function(v) {
            return _this.Bottom(v, "%");
        });
        return this;
    };
    ComponentBase.prototype.FloatLeft = function() {
        this.element.style.float = "left";
        return this;
    };
    ComponentBase.prototype.FloatRight = function() {
        this.element.style.float = "right";
        return this;
    };
    ComponentBase.prototype.ClearBoth = function() {
        this.element.style.clear = "both";
        return this;
    };
    ComponentBase.prototype.ClearLeft = function() {
        this.element.style.clear = "left";
        return this;
    };
    ComponentBase.prototype.ClearRight = function() {
        this.element.style.clear = "right";
        return this;
    };
    //#endregion STYLING-POSITION
    //#region STYLING-DISPLAY
    ComponentBase.prototype.Display = function(as) {
        return this.SetSingleStyle("display: " + as);
    };
    ComponentBase.prototype.Inline = function() {
        return this.SetSingleStyle("display: inline");
    };
    ComponentBase.prototype.DisplayInline = function() {
        return this.SetSingleStyle("display: inline");
    };
    ComponentBase.prototype.Block = function() {
        return this.SetSingleStyle("display: block");
    };
    ComponentBase.prototype.DisplayBlock = function() {
        return this.SetSingleStyle("display: block");
    };
    ComponentBase.prototype.InlineBlock = function() {
        return this.SetSingleStyle("display: inline-block");
    };
    ComponentBase.prototype.DisplayInlineBlock = function() {
        return this.SetSingleStyle("display: inline-block");
    };
    //#endregion STYLING-DISPLAY
    //#region STYLING-BORDER
    ComponentBase.prototype.Border = function(width, color, radius) {
        if (width === void 0) width = 1;
        if (color === void 0) color = "#888";
        if (radius === void 0) radius = 0;
        this.Style("border: ".concat(width, "px solid ").concat(color, "; border-radius: ").concat(radius, "px"));
        return this;
    };
    ComponentBase.prototype.BorderNone = function() {
        this.Style("border: none");
        return this;
    };
    ComponentBase.prototype.BorderStyling = function(edge, width, color, radius, style) {
        if (radius === void 0) radius = 0;
        if (style === void 0) style = "solid";
        this.Style("border-".concat(edge, ": ").concat(width, "px ").concat(style, " ").concat(color, "; border-").concat(edge, "-radius: ").concat(radius, "px"));
        return this;
    };
    ComponentBase.prototype.BorderBottom = function(width, color, style, radius) {
        if (width === void 0) width = 1;
        if (color === void 0) color = "#888";
        if (style === void 0) style = "solid";
        if (radius === void 0) radius = 0;
        return this.BorderStyling("bottom", width, color, radius, style);
    };
    ComponentBase.prototype.BorderTop = function(width, color, style, radius) {
        if (width === void 0) width = 1;
        if (color === void 0) color = "#888";
        if (style === void 0) style = "solid";
        if (radius === void 0) radius = 0;
        return this.BorderStyling("top", width, color, radius, style);
    };
    ComponentBase.prototype.BorderLeft = function(width, color, style, radius) {
        if (width === void 0) width = 1;
        if (color === void 0) color = "#888";
        if (style === void 0) style = "solid";
        if (radius === void 0) radius = 0;
        return this.BorderStyling("left", width, color, radius, style);
    };
    ComponentBase.prototype.BorderRight = function(width, color, style, radius) {
        if (width === void 0) width = 1;
        if (color === void 0) color = "#888";
        if (style === void 0) style = "solid";
        if (radius === void 0) radius = 0;
        return this.BorderStyling("right", width, color, radius, style);
    };
    ComponentBase.prototype.BorderWidth = function(width, unit) {
        var _this = this;
        if (unit === void 0) unit = "px";
        this.React(width, function(v) {
            return _this.Style("border-width: ".concat(v).concat(unit));
        });
        return this;
    };
    ComponentBase.prototype.BorderColor = function(color) {
        var _this = this;
        this.React(color, function(v) {
            return _this.Style("border-color: ".concat(v));
        });
        return this;
    };
    ComponentBase.prototype.BorderStyle = function(style) {
        var _this = this;
        this.React(style, function(v) {
            return _this.Style("border-style: ".concat(v));
        });
        return this;
    };
    ComponentBase.prototype.BorderStyleSolid = function() {
        return this.BorderStyle("solid");
    };
    ComponentBase.prototype.BorderStyleDotted = function() {
        return this.BorderStyle("dotted");
    };
    ComponentBase.prototype.BorderStyleDashed = function() {
        return this.BorderStyle("dashed");
    };
    ComponentBase.prototype.BorderRadius = function(radius, unit) {
        if (unit === void 0) unit = "px";
        return this.SetStyle('borderRadius', radius, unit);
    };
    //#endregion STYLING-BORDER
    //#region STYLING-SIZE
    ComponentBase.prototype.Width = function(val, unit) {
        if (unit === void 0) unit = "px";
        return this.SetStyle("width", val, unit);
    };
    ComponentBase.prototype.WidthPercent = function(val) {
        return this.SetStyle("width", val, "%");
    };
    ComponentBase.prototype.WidthAuto = function() {
        this.element.style.width = "auto";
        return this;
    };
    ComponentBase.prototype.HalfWidth = function() {
        this.element.style.width = "50%";
        return this;
    };
    ComponentBase.prototype.FullWidth = function() {
        this.element.style.width = "100%";
        return this;
    };
    ComponentBase.prototype.Height = function(val, unit) {
        if (unit === void 0) unit = "px";
        return this.SetStyle("height", val, unit);
    };
    ComponentBase.prototype.HeightPercent = function(val) {
        return this.SetStyle("height", val, "%");
    };
    ComponentBase.prototype.HeightAuto = function() {
        this.element.style.height = "auto";
        return this;
    };
    ComponentBase.prototype.MaxWidth = function(val, unit) {
        if (unit === void 0) unit = "px";
        this.element.style.maxWidth = val + unit;
        return this;
    };
    ComponentBase.prototype.MinWidth = function(val, unit) {
        if (unit === void 0) unit = "px";
        this.element.style.minWidth = val + unit;
        return this;
    };
    ComponentBase.prototype.MaxHeight = function(val, unit) {
        if (unit === void 0) unit = "px";
        this.element.style.maxHeight = val + unit;
        return this;
    };
    ComponentBase.prototype.MinHeight = function(val, unit) {
        if (unit === void 0) unit = "px";
        this.element.style.minHeight = val + unit;
        return this;
    };
    //#endregion STYLING-SIZE
    //#region STYLING-MARGIN
    ComponentBase.prototype.Margin = function(val, unit) {
        if (unit === void 0) unit = "px";
        return this.SetStyle("margin", val, unit);
    };
    ComponentBase.prototype.MarginAuto = function() {
        this.element.style.margin = "auto";
        return this;
    };
    ComponentBase.prototype.MarginTop = function(val, unit) {
        if (unit === void 0) unit = "px";
        return this.SetStyle("marginTop", val, unit);
    };
    ComponentBase.prototype.MarginBottom = function(val, unit) {
        if (unit === void 0) unit = "px";
        return this.SetStyle("marginBottom", val, unit);
    };
    ComponentBase.prototype.MarginTopBottom = function(val, unit) {
        if (unit === void 0) unit = "px";
        this.element.style.marginTop = val + unit;
        this.element.style.marginBottom = val + unit;
        return this;
    };
    ComponentBase.prototype.MarginLeft = function(val, unit) {
        if (unit === void 0) unit = "px";
        return this.SetStyle("marginLeft", val, unit);
    };
    ComponentBase.prototype.MarginRight = function(val, unit) {
        if (unit === void 0) unit = "px";
        return this.SetStyle("marginRight", val, unit);
    };
    ComponentBase.prototype.MarginLeftRight = function(val, unit) {
        if (unit === void 0) unit = "px";
        this.element.style.marginLeft = val + unit;
        this.element.style.marginRight = val + unit;
        return this;
    };
    //#endregion STYLING-MARGIN
    //#region STYLING-COLORS
    ComponentBase.prototype.Color = function(color) {
        return this.SetStyle("color", color);
    };
    ComponentBase.prototype.Background = function(color) {
        return this.SetStyle("background", color);
    };
    //#endregion STYLING-COLORS
    //#region STYLING-PADDING
    ComponentBase.prototype.Padding = function(val, secondVal) {
        if (!secondVal) this.SetStyle("padding", val, "px");
        else this.element.style.padding = "".concat(val, "px ").concat(secondVal, "px");
        return this;
    };
    ComponentBase.prototype.PaddingLeft = function(val, unit) {
        if (unit === void 0) unit = "px";
        return this.SetStyle("paddingLeft", val, unit);
    };
    ComponentBase.prototype.PaddingRight = function(val, unit) {
        if (unit === void 0) unit = "px";
        return this.SetStyle("paddingRight", val, unit);
    };
    ComponentBase.prototype.PaddingTop = function(val, unit) {
        if (unit === void 0) unit = "px";
        return this.SetStyle("paddingTop", val, unit);
    };
    ComponentBase.prototype.PaddingBottom = function(val, unit) {
        if (unit === void 0) unit = "px";
        return this.SetStyle("paddingBottom", val, unit);
    };
    //#endregion STYLING-PADDING
    //#region STYLING-OVERFLOW
    ComponentBase.prototype.OverflowX = function(val) {
        this.element.style.overflowX = val;
        return this;
    };
    ComponentBase.prototype.OverflowY = function(val) {
        this.element.style.overflowY = val;
        return this;
    };
    ComponentBase.prototype.OverflowYScroll = function() {
        return this.OverflowY("scroll");
    };
    //#endregion STYLING-OVERFLOW
    //#region PROPS
    ComponentBase.prototype.Id = function(id) {
        return this.Attribute("id", id);
    };
    ComponentBase.prototype.Text = function(text) {
        var _this = this;
        this.React(text, function(v) {
            return _this.element.innerText = v;
        });
        return this;
    };
    ComponentBase.prototype.GetText = function() {
        return this.element.innerText;
    };
    ComponentBase.prototype.Html = function(html) {
        var _this = this;
        this.React(html, function(v) {
            return _this.element.innerHTML = v;
        });
        return this;
    };
    ComponentBase.prototype.GetHtml = function() {
        return this.element.innerHTML;
    };
    ComponentBase.prototype.Enable = function(isEnabled) {
        var _this = this;
        this.React(isEnabled, function(v) {
            return v ? _this.RemoveAttribute("disabled") : _this.Attribute("disabled");
        });
        return this;
    };
    ComponentBase.prototype.EnableWhen = function(toWatch, predicate) {
        var _this = this;
        if (predicate === void 0) predicate = function(v) {
            return !!v;
        };
        this.Reacts(toWatch, function() {
            var vals = [];
            for(var _i = 0; _i < arguments.length; _i++)vals[_i] = arguments[_i];
            return _this.Enable(predicate.apply(void 0, vals));
        });
        return this;
    };
    ComponentBase.prototype.DisableWhen = function(toWatch, predicate) {
        var _this = this;
        if (predicate === void 0) predicate = function(v) {
            return !!v;
        };
        this.Reacts(toWatch, function() {
            var vals = [];
            for(var _i = 0; _i < arguments.length; _i++)vals[_i] = arguments[_i];
            return _this.Disable(predicate.apply(void 0, vals));
        });
        return this;
    };
    ComponentBase.prototype.Disable = function(isDisabled) {
        var _this = this;
        this.React(isDisabled, function(v) {
            return v ? _this.Attribute("disabled") : _this.RemoveAttribute("disabled");
        });
        return this;
    };
    ComponentBase.prototype.Enabled = function() {
        return this.Enable(true);
    };
    ComponentBase.prototype.Disabled = function() {
        return this.Enable(false);
    };
    Object.defineProperty(ComponentBase.prototype, "Events", {
        get: function() {
            return this.events;
        },
        enumerable: false,
        configurable: true
    });
    ComponentBase.prototype.On = function(event, handler) {
        this.events.Add(event, handler);
        return this;
    };
    ComponentBase.prototype.Off = function(event) {
        this.events.Off(event);
        return this;
    };
    ComponentBase.prototype.CallEvent = function(event) {
        this.events.Call(event);
        return this;
    };
    ComponentBase.prototype.OnClick = function(handler, preventDefault, stopPropagation) {
        var _this = this;
        if (preventDefault === void 0) preventDefault = true;
        if (stopPropagation === void 0) stopPropagation = true;
        this.On('click', function(e) {
            if (e) {
                if (preventDefault) e.preventDefault();
                if (stopPropagation) e.stopPropagation();
            }
            handler(_this, e);
        });
        return this;
    };
    ComponentBase.prototype.OffClick = function() {
        this.Off('click');
        return this;
    };
    ComponentBase.prototype.Click = function() {
        this.events.Call('click');
        return this;
    };
    ComponentBase.prototype.ClickAsync = function() {
        return $7d34ee63d945b320$var$__awaiter(this, void 0, void 0, function() {
            return $7d34ee63d945b320$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.events.CallAsync('click')
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    ComponentBase.prototype.OnHover = function(handler) {
        var _this = this;
        return this.On('mouseover', function() {
            return handler(_this);
        });
    };
    ComponentBase.prototype.OnMouseOut = function(handler) {
        var _this = this;
        return this.On('mouseout', function() {
            return handler(_this);
        });
    };
    ComponentBase.prototype.OnRightClick = function(handler) {
        var _this = this;
        this.On('contextmenu', function(e) {
            e.preventDefault();
            handler(_this);
        });
        return this;
    };
    ComponentBase.prototype.OnFocus = function(handler) {
        var _this = this;
        return this.On('focus', function() {
            return handler(_this);
        });
    };
    ComponentBase.prototype.OnBlur = function(handler) {
        var _this = this;
        return this.On('blur', function() {
            return handler(_this);
        });
    };
    ComponentBase.prototype.OnEnterKeyPressed = function(handler) {
        var _this = this;
        return this.On('keyup', function(ke) {
            if (ke.key === "Enter") handler(_this, ke);
        });
    };
    ComponentBase.prototype.OnKeyUp = function(handler) {
        var _this = this;
        return this.On('keyup', function(ke) {
            return handler(_this, ke);
        });
    };
    ComponentBase.prototype.OnKeyDown = function(handler) {
        var _this = this;
        return this.On('keydown', function(ke) {
            return handler(_this, ke);
        });
    };
    ComponentBase.prototype.OnKeyPress = function(handler) {
        var _this = this;
        return this.On('keypress', function(ke) {
            return handler(_this, ke);
        });
    };
    //#endregion EVENTS
    //#region VISIBILITY
    ComponentBase.prototype.Exist = function(component) {
        return this.element.Exist(component.Element);
    };
    ComponentBase.prototype.Visible = function(toWatch, showAs) {
        var _this = this;
        if (showAs === void 0) showAs = "inline-block";
        this.Reacts(toWatch, function() {
            var vals = [];
            for(var _i = 0; _i < arguments.length; _i++)vals[_i] = arguments[_i];
            return vals.every(function(v) {
                return v == true;
            }) ? _this.Show(showAs) : _this.Hide();
        });
        return this;
    };
    ComponentBase.prototype.Invisible = function(toWatch, showAs) {
        var _this = this;
        if (showAs === void 0) showAs = "inline-block";
        this.Reacts(toWatch, function() {
            var vals = [];
            for(var _i = 0; _i < arguments.length; _i++)vals[_i] = arguments[_i];
            return vals.every(function(v) {
                return v == true;
            }) ? _this.Hide() : _this.Show(showAs);
        });
        return this;
    };
    ComponentBase.prototype.VisibleWhen = function(toWatch, predicate, showAs) {
        var _this = this;
        if (predicate === void 0) predicate = function(v) {
            return !!v;
        };
        if (showAs === void 0) showAs = "inline-block";
        this.Reacts(toWatch, function() {
            var vals = [];
            for(var _i = 0; _i < arguments.length; _i++)vals[_i] = arguments[_i];
            return predicate.apply(void 0, vals) ? _this.Show(showAs) : _this.Hide();
        });
        return this;
    };
    ComponentBase.prototype.InvisibleWhen = function(toWatch, predicate, showAs) {
        var _this = this;
        if (predicate === void 0) predicate = function(v) {
            return !!v;
        };
        if (showAs === void 0) showAs = "inline-block";
        this.Reacts(toWatch, function() {
            var vals = [];
            for(var _i = 0; _i < arguments.length; _i++)vals[_i] = arguments[_i];
            return predicate.apply(void 0, vals) ? _this.Hide() : _this.Show(showAs);
        });
        return this;
    };
    ComponentBase.prototype.Hide = function() {
        var _a;
        if (this.element instanceof HTMLElement) {
            var style = window === null || window === void 0 ? void 0 : window.getComputedStyle(this.element);
            if ((style === null || style === void 0 ? void 0 : style.display) && (style === null || style === void 0 ? void 0 : style.display) != "none") this.displayAs = (style === null || style === void 0 ? void 0 : style.display) || "";
        }
        (_a = this.OnHide) === null || _a === void 0 || _a.call(this);
        this.element.Hide();
        this.isVisible = false;
        return this;
    };
    ComponentBase.prototype.IsVisible = function() {
        return this.isVisible;
    // return this.element.IsVisible();
    };
    // private showAs;
    ComponentBase.prototype.Show = function(as) {
        var _a;
        if (as === void 0) as = this.displayAs || "block";
        // this.showAs = as;
        // console.log(as, ' on show');
        this.isVisible = true;
        // this.element.Show(as);
        this.element.Show(as);
        (_a = this.OnShow) === null || _a === void 0 || _a.call(this);
        return this;
    };
    ComponentBase.prototype.Toggle = function(as) {
        // if (as)
        //     this.showAs = as;
        // this.isVisible = !this.isVisible;
        this.isVisible ? this.Hide() : this.Show();
        // this.isVisible ? this.Hide() : this.Show(this.showAs)
        // this.element.Toggle();
        return this;
    };
    //#region LOGS
    ComponentBase.LogEn = false;
    ComponentBase.Id = 0;
    return ComponentBase;
}();
module.exports.ComponentBase = $7d34ee63d945b320$var$ComponentBase;

});
parcelRegister("6wI3m", function(module, exports) {
"use strict";
var $4c07e745af36d0f8$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Ref = void 0;
parcelRequire("fg7nO");

var $22Wrn = parcelRequire("22Wrn");
var $4c07e745af36d0f8$var$Ref = /** @class */ function(_super) {
    $4c07e745af36d0f8$var$__extends(Ref, _super);
    function Ref(_value) {
        var _this = _super.call(this) || this;
        _this._value = _value;
        _this.initialValue = _value;
        return _this;
    }
    Ref.prototype.Storable = function(key, storage) {
        if (storage === void 0) storage = "local";
        if (!key) return this;
        var stor;
        switch(storage){
            case "local":
                stor = window.localStorage;
                break;
            case "session":
                stor = window.sessionStorage;
                break;
        }
        this.OnChange(function(v) {
            return stor.setItem(key, v.toString());
        });
        var valueInStorage = stor.getItem(key);
        if (!valueInStorage) return this;
        if (this._value instanceof Date) this.Set(new Date(valueInStorage || this._value || 0));
        else if (typeof this._value == "string") this.Set(valueInStorage || this._value || "");
        else if (typeof this._value == "number") this.Set(+(valueInStorage || 0) || +this._value || 0);
        else if (typeof this._value == "boolean") switch(valueInStorage){
            case "true":
                this.Set(true);
                break;
            default:
            case null:
            case "":
            case "false":
                this.Set(false);
                break;
        }
        return this;
    };
    Ref.prototype.Compare = function(ref, valueOrRef, op) {
        if (valueOrRef instanceof Ref) return op(ref.value, valueOrRef.value);
        return op(ref.value, valueOrRef);
    };
    Ref.prototype.Is = function(toCompare) {
        return this.Compare(this, toCompare, function(a, b) {
            return a == b;
        });
    };
    Ref.prototype.IsNot = function(toCompare) {
        return this.Compare(this, toCompare, function(a, b) {
            return a != b;
        });
    };
    Object.defineProperty(Ref.prototype, "IsSet", {
        get: function() {
            if (this._value instanceof Date) return +this._value !== +this.ZeroValue;
            return this._value !== this.ZeroValue;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Ref.prototype, "IsNotSet", {
        get: function() {
            return !this.IsSet;
        },
        enumerable: false,
        configurable: true
    });
    Ref.prototype.IsInitial = function() {
        return this.value == this.initialValue;
    };
    Ref.prototype.IsNotInitial = function() {
        return this.value != this.initialValue;
    };
    Object.defineProperty(Ref.prototype, "HasChanged", {
        get: function() {
            return this._value !== this.initialValue;
        },
        enumerable: false,
        configurable: true
    });
    Ref.prototype.IsEqual = function(toCompare) {
        return this.Compare(this, toCompare, function(a, b) {
            return a === b;
        });
    };
    Ref.prototype.IsIn = function(values) {
        return values.includes(this.value);
    };
    Ref.prototype.IsNotEqual = function(value) {
        return this.value !== value;
    };
    Ref.prototype.Set = function(val, excludeControlForRefresh) {
        if (this.value === val) return false;
        this._value = val;
        this.RefreshSubscribers(excludeControlForRefresh);
        this.onChangeHandler.Call(this._value);
        return true;
    };
    Ref.prototype.SetValue = function(val) {
        if (val === undefined) return this;
        if (this.value === val) return this;
        this._value = val;
        this.RefreshSubscribers();
        // NOTICE: no onChangeHandler call
        return this;
    };
    Ref.prototype.SetTo = function(valueOrRef) {
        if (valueOrRef instanceof Ref) this.value = valueOrRef.value;
        else this.value = valueOrRef;
        return this;
    };
    Ref.prototype.ForceOnChange = function() {
        this.RefreshSubscribers();
        this.onChangeHandler.Call(this._value);
        return this;
    };
    Object.defineProperty(Ref.prototype, "value", {
        get: function() {
            return this._value;
        },
        set: function(val) {
            this.Set(val);
        },
        enumerable: false,
        configurable: true
    });
    Ref.prototype.Restore = function() {
        this.value = this.initialValue;
        return this;
    };
    Ref.prototype.OverrideInitialValue = function(val) {
        this.initialValue = val;
        return this;
    };
    Ref.prototype.Initialize = function(val) {
        this.initialValue = val;
        this._value = val;
        return this;
    };
    Object.defineProperty(Ref.prototype, "ZeroValue", {
        get: function() {
            if (this._value instanceof Date) return new Date(0);
            else if (typeof this._value == "string") return "";
            else if (typeof this._value == "number") return 0; // TODO: 0? not infinity or something?
            else if (typeof this._value == "boolean") return false;
            throw new Error("No zero value for given type");
        },
        enumerable: false,
        configurable: true
    });
    Ref.prototype.Clear = function() {
        if (typeof this._value == "string") this.Set("");
        else if (typeof this._value == "number") this.Set(0);
        else if (typeof this._value == "boolean") this.Set(false);
        else if (this._value instanceof Date) this.Set(new Date(0));
        return this;
    };
    Ref.prototype.ToString = function() {
        var _a, _b;
        // console.log('ttt');
        // return `${this._value?.toString()} [${this.watchers?.map(w=>w.Id)?.join(", ")}]`;
        // if (typeof this._value === "string")
        //     return `Ref<${typeof this._value}>#${this.Id}${this.Name ? ":" + this.Name : ""} = "${this._value}" [${this.watchers?.map(w => w.Id)?.join(", ")}]`;
        // else
        // if (typeof this._value === "Date")
        // return `Ref<${typeof this._value}> = "${this._value?.toString()}" [${this.watchers?.map(w => w.Id)?.join(", ")}]`;
        // else
        // if (typeof this._value === "boolean")
        //     return `Ref<${typeof this._value}> = ${this._value?.toString() ? "true" : "false"} [${this.watchers?.map(w => w.Id)?.join(", ")}]`;
        // else
        return "Ref<".concat(typeof this._value, ">#").concat(this.Id).concat(this.Name ? ":" + this.Name : "", " = ").concat(this._value != null ? String(this._value) : "null", " [watchers: ").concat(((_b = (_a = this.Watchers) === null || _a === void 0 ? void 0 : _a.map(function(w) {
            return w.Id;
        })) === null || _b === void 0 ? void 0 : _b.join(", ")) || "none", "][").concat(this.onChangeHandler.Count, " subs]");
    };
    Ref.prototype.Combine = function(anotherRef, operation) {
        var _this = this;
        var result = new Ref(operation(this.value, anotherRef.value));
        this.OnChange(function(v) {
            return result.value = operation(_this.value, anotherRef.value);
        });
        anotherRef.OnChange(function(v) {
            return result.value = operation(_this.value, anotherRef.value);
        });
        return result;
    };
    Ref.prototype.CombineValue = function(anotherValue, operation) {
        var result = new Ref(operation(this.value, anotherValue));
        this.OnChange(function(v) {
            return result.value = operation(v, anotherValue);
        }, true);
        return result;
    };
    Ref.prototype.Mix = function(x, operation) {
        if (x instanceof Ref) return this.Combine(x, operation);
        else return this.CombineValue(x, operation);
    };
    return Ref;
}($22Wrn.RefBase);
module.exports.Ref = $4c07e745af36d0f8$var$Ref;

});
parcelRegister("fg7nO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Array.prototype.ToString = function() {
    var _a;
    return (_a = this.join(", ")) !== null && _a !== void 0 ? _a : "(empty)";
};
Array.prototype.Remove = function(item) {
    var index = this.indexOf(item);
    if (index >= 0) {
        this.splice(index, 1);
        return true;
    }
    return false;
};

});

parcelRegister("22Wrn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RefBase = void 0;

var $6wI3m = parcelRequire("6wI3m");

var $8PO3e = parcelRequire("8PO3e");
var $17d919bca1bb95f0$var$RefBase = /** @class */ function() {
    function RefBase() {
        this.Id = -1;
        this.Name = "";
        this.onChangeHandler = new $8PO3e.HandlersCollection();
        this.watchers = new Set();
        $6wI3m.Ref.Id += 1;
        this.Id = $6wI3m.Ref.Id;
    }
    Object.defineProperty(RefBase.prototype, "OnChangeHandler", {
        get: function() {
            return this.onChangeHandler;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RefBase.prototype, "Watchers", {
        get: function() {
            return Array.from(this.watchers);
        },
        enumerable: false,
        configurable: true
    });
    RefBase.prototype.NameIt = function(name) {
        this.Name = name;
        return this;
    };
    RefBase.prototype.AddSubscriber = function(control) {
        this.watchers.add(control);
    };
    RefBase.prototype.RemoveControl = function(control) {
        this.watchers.delete(control);
    };
    RefBase.prototype.RefreshSubscribers = function(except) {
        for(var _i = 0, _a = this.Watchers; _i < _a.length; _i++){
            var watcher = _a[_i];
            if (watcher !== except) watcher.Refresh();
        }
    };
    RefBase.prototype.ClearHandlers = function() {
        this.onChangeHandler.Reset();
        return this;
    };
    RefBase.prototype.OnChange = function(handler, callThisCallbackRightAway) {
        if (callThisCallbackRightAway === void 0) callThisCallbackRightAway = false;
        this.onChangeHandler.Add(handler);
        if (callThisCallbackRightAway == true) handler(this._value, true);
        return this;
    };
    RefBase.Id = 0;
    return RefBase;
}();
module.exports.RefBase = $17d919bca1bb95f0$var$RefBase;

});
parcelRegister("8PO3e", function(module, exports) {
"use strict";
var $66e9e94085efdd7b$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $66e9e94085efdd7b$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HandlersCollection = void 0;
function $66e9e94085efdd7b$var$UniqueId() {
    return 'id-' + Math.floor(Math.random() * 1e16).toString(36);
}
var $66e9e94085efdd7b$var$HandlersCollection = /** @class */ function() {
    function HandlersCollection() {
        this.handlers = new Map();
        this.serializedHandlers = [];
        this.inOnHold = false;
    }
    HandlersCollection.prototype.Add = function(handler, handlerId) {
        if (handlerId === void 0) handlerId = $66e9e94085efdd7b$var$UniqueId();
        if (this.handlers.has(handlerId)) {
            console.warn("Handler with this id (".concat(handlerId, ") was already added"));
            return this;
        }
        if (handler) this.handlers.set(handlerId, handler);
        if (HandlersCollection.MANY_HANDLERS_WARNING && this.Count > HandlersCollection.MANY_HANDLERS_LIMIT) {
            console.warn("Many handlers is not recommended, they might be set by mistake. Warning limit is ".concat(HandlersCollection.MANY_HANDLERS_LIMIT, ". You can change it or turn this message off by setting MANY_HANDLERS_WARNING to false. Remember to clear handlers when not needed anymore."));
            if (HandlersCollection.THROW_ON_MANY_HANDLERS_WARNING) throw new Error("Too many handlers! @ Add(handler, id=".concat(handlerId, ")"));
        }
        return this;
    };
    HandlersCollection.prototype.Subscribe = function(handler, handlerId) {
        if (handlerId === void 0) handlerId = $66e9e94085efdd7b$var$UniqueId();
        this.Add(handler, handlerId);
        return handlerId;
    };
    HandlersCollection.prototype.Unsubscribe = function(handlerId) {
        this.handlers.delete(handlerId);
        return this;
    };
    HandlersCollection.prototype.AddUnique = function(handler) {
        var serializedHandler = handler.toString();
        if (this.serializedHandlers.includes(serializedHandler)) return this;
        this.serializedHandlers.push(serializedHandler);
        this.Add(handler);
        return this;
    };
    HandlersCollection.prototype.Reset = function() {
        this.handlers.clear();
        return this;
    };
    Object.defineProperty(HandlersCollection.prototype, "AreAny", {
        get: function() {
            return this.handlers.size > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HandlersCollection.prototype, "Count", {
        get: function() {
            return this.handlers.size;
        },
        enumerable: false,
        configurable: true
    });
    HandlersCollection.prototype.Hold = function() {
        this.inOnHold = true;
        return this;
    };
    HandlersCollection.prototype.Release = function() {
        this.inOnHold = false;
        return this;
    };
    Object.defineProperty(HandlersCollection.prototype, "IsOnHold", {
        get: function() {
            return this.inOnHold;
        },
        enumerable: false,
        configurable: true
    });
    HandlersCollection.prototype.Call = function() {
        var params = [];
        for(var _i = 0; _i < arguments.length; _i++)params[_i] = arguments[_i];
        if (this.inOnHold) return this;
        this.handlers.forEach(function(h) {
            return h.apply(void 0, params);
        });
        return this;
    };
    HandlersCollection.prototype.CallAsync = function() {
        var params = [];
        for(var _i = 0; _i < arguments.length; _i++)params[_i] = arguments[_i];
        return $66e9e94085efdd7b$var$__awaiter(this, void 0, void 0, function() {
            var _a, _b, handlerId, handler;
            return $66e9e94085efdd7b$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        if (this.inOnHold) return [
                            2 /*return*/ 
                        ];
                        _a = 0, _b = Array.from(this.handlers.keys());
                        _c.label = 1;
                    case 1:
                        if (!(_a < _b.length)) return [
                            3 /*break*/ ,
                            4
                        ];
                        handlerId = _b[_a];
                        handler = this.handlers.get(handlerId);
                        if (!handler) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            handler.apply(void 0, params)
                        ];
                    case 2:
                        _c.sent();
                        _c.label = 3;
                    case 3:
                        _a++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    HandlersCollection.prototype.CallAndGatherReturnValue = function() {
        var params = [];
        for(var _i = 0; _i < arguments.length; _i++)params[_i] = arguments[_i];
        if (this.inOnHold) return [];
        var returnValues = [];
        this.handlers.forEach(function(h) {
            var result = h.apply(void 0, params);
            returnValues.push(result);
        });
        return returnValues;
    };
    HandlersCollection.MANY_HANDLERS_WARNING = true;
    HandlersCollection.THROW_ON_MANY_HANDLERS_WARNING = false;
    HandlersCollection.MANY_HANDLERS_LIMIT = 10;
    return HandlersCollection;
}();
module.exports.HandlersCollection = $66e9e94085efdd7b$var$HandlersCollection;

});



parcelRegister("8lUZH", function(module, exports) {
"use strict";
var $614c7eb942e95d4e$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChildrenCollection = void 0;
var $614c7eb942e95d4e$var$ChildrenCollection = /** @class */ function() {
    function ChildrenCollection(Parent) {
        this.Parent = Parent;
        this.components = [];
        this.found = undefined;
        this.allFound = [];
    }
    ChildrenCollection.prototype.GetByTestAttr = function(id) {
        return this.All.find(function(x) {
            return x.GetAttribute("data-test") == id;
        });
    };
    ChildrenCollection.prototype.SearchByTestAttr = function(id) {
        var _this = this;
        this.found = undefined;
        this.components.forEach(function(c) {
            return _this.FindInComponentByTestAttr(c, id);
        });
        return this.found;
    };
    ChildrenCollection.prototype.SearchByPredicate = function(c, predicate) {
        var _this = this;
        if (predicate(c)) {
            this.found = c;
            return this.found;
        } else c.Children.All.forEach(function(c) {
            if (predicate(c)) {
                _this.found = c;
                return _this.found;
            } else _this.SearchByPredicate(c, predicate);
        });
    };
    ChildrenCollection.prototype.Search = function(predicate) {
        var _this = this;
        this.found = undefined;
        if (predicate(this.Parent)) return this.Parent;
        this.components.forEach(function(c) {
            return _this.SearchByPredicate(c, predicate);
        });
        return this.found;
    };
    ChildrenCollection.prototype.SearchByText = function(text, exact) {
        if (exact === void 0) exact = false;
        if (exact) return this.Search(function(x) {
            return x.GetText() == text;
        });
        else return this.Search(function(x) {
            var _a, _b;
            return (_b = (_a = x.GetText()) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.includes(text.toLowerCase());
        });
    };
    Object.defineProperty(ChildrenCollection.prototype, "All", {
        get: function() {
            return this.components;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ChildrenCollection.prototype, "Count", {
        get: function() {
            return this.components.length;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ChildrenCollection.prototype, "Clone", {
        get: function() {
            return $614c7eb942e95d4e$var$__spreadArray([], this.components, true);
        },
        enumerable: false,
        configurable: true
    });
    ChildrenCollection.prototype.Add = function(component) {
        this.components.push(component);
    };
    ChildrenCollection.prototype.Has = function(component) {
        return this.components.includes(component);
    };
    ChildrenCollection.prototype.Remove = function(component) {
        return this.components.Remove(component);
    };
    ChildrenCollection.prototype.FindInObj = function(component, type) {
        var _this = this;
        if (component instanceof type) {
            this.found = component;
            return this.found;
        } else component.Children.All.forEach(function(c) {
            if (c instanceof type) {
                _this.found = c;
                return _this.found;
            } else _this.FindInObj(c, type);
        });
    };
    ChildrenCollection.prototype.FindInComponentByTestAttr = function(component, id) {
        var _this = this;
        if (component.GetAttribute("data-test") == id) {
            this.found = component;
            return this.found;
        } else component.Children.All.forEach(function(c) {
            if (c.GetAttribute("data-test") == id) {
                _this.found = c;
                return _this.found;
            } else _this.FindInComponentByTestAttr(c, id);
        });
    };
    ChildrenCollection.prototype.FindFirstOfType = function(type) {
        var _this = this;
        this.found = undefined;
        this.components.forEach(function(c) {
            return _this.FindInObj(c, type);
        });
        return this.found;
    };
    ChildrenCollection.prototype.FindAllInObj = function(component, type) {
        var _this = this;
        if (component instanceof type) this.allFound.push(component);
        else component.Children.All.forEach(function(c) {
            if (c instanceof type) _this.allFound.push(c);
            else _this.FindAllInObj(c, type);
        });
    };
    ChildrenCollection.prototype.FindAllOfType = function(type) {
        var _this = this;
        this.allFound = [];
        this.components.forEach(function(c) {
            return _this.FindAllInObj(c, type);
        });
        return this.allFound;
    };
    ChildrenCollection.prototype.toString = function() {
        return this.components.map(function(x) {
            return "".concat(x.ID);
        });
    };
    return ChildrenCollection;
}();
module.exports.ChildrenCollection = $614c7eb942e95d4e$var$ChildrenCollection;

});

parcelRegister("5uACL", function(module, exports) {
"use strict";
var $3ffc29ebf0907b8e$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $3ffc29ebf0907b8e$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventsContainer = void 0;

var $8PO3e = parcelRequire("8PO3e");
var $3ffc29ebf0907b8e$var$EventsContainer = /** @class */ function() {
    function EventsContainer(element) {
        this.element = element;
        this.events = {}; // string because TS does not allow GlobalEventHandlersEventMap as type
        this.listeners = {};
    }
    EventsContainer.prototype.Add = function(event, handler) {
        var _this = this;
        if (!handler) return;
        if (Array.isArray(event)) event.forEach(function(ev) {
            return _this.AddOne(ev, handler);
        });
        else this.AddOne(event, handler);
    };
    EventsContainer.prototype.AddOne = function(event, handler) {
        var _this = this;
        if (!this.events[event]) this.events[event] = new $8PO3e.HandlersCollection();
        this.events[event].Add(handler);
        if (this.listeners[event]) return;
        this.listeners[event] = function(e) {
            _this.Call(event, e);
        };
        this.element.addEventListener(event, function(e) {
            return _this.listeners[event](e);
        });
    };
    EventsContainer.prototype.Call = function(event) {
        var _a;
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        (_a = this.events[event]) === null || _a === void 0 || _a.Call.apply(_a, args);
    };
    EventsContainer.prototype.CallAsync = function(event) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        return $3ffc29ebf0907b8e$var$__awaiter(this, void 0, void 0, function() {
            var _a;
            return $3ffc29ebf0907b8e$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            (_a = this.events[event]) === null || _a === void 0 ? void 0 : _a.CallAsync.apply(_a, args)
                        ];
                    case 1:
                        _b.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    EventsContainer.prototype.Off = function(event) {
        var _a;
        if (!this.events.Keys().includes(event)) return;
        (_a = this.events[event]) === null || _a === void 0 || _a.Reset();
        this.element.addEventListener(event, this.listeners[event]);
    };
    Object.defineProperty(EventsContainer.prototype, "Info", {
        get: function() {
            var _this = this;
            var t = "";
            this.listeners.Keys().forEach(function(k) {
                t += "- " + k + ": " + _this.events[k].Count + " handlers\n";
            });
            return t;
        },
        enumerable: false,
        configurable: true
    });
    return EventsContainer;
}();
module.exports.EventsContainer = $3ffc29ebf0907b8e$var$EventsContainer;

});




parcelRegister("bOiUu", function(module, exports) {
"use strict";
var __extends = this && this.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Radio = exports.RadioConfig = exports.RadioOption = exports.RadioInput = void 0;

var $6wI3m = parcelRequire("6wI3m");

var $joGvE = parcelRequire("joGvE");

var $k6KGm = parcelRequire("k6KGm");

var $fAOYH = parcelRequire("fAOYH");
var RadioInput = /** @class */ function(_super) {
    __extends(RadioInput, _super);
    function RadioInput(ref, value, uniqueId) {
        var _this = _super.call(this, "input", ref) || this;
        _this.value = value;
        _this.Attribute("type", "radio");
        _this.Attribute("name", uniqueId);
        _this.Attribute("value", value != null ? String(value) : "");
        _this.Refresh();
        return _this;
    }
    RadioInput.prototype.Refresh = function() {
        this.element.checked = this.ref.value == this.value;
    };
    return RadioInput;
}($k6KGm.RefComponentBase);
exports.RadioInput = RadioInput;
var RadioOption = /** @class */ function(_super) {
    __extends(RadioOption, _super);
    function RadioOption(ref, value, label, uniqueId, config) {
        var _a;
        var _this = _super.call(this, "radio-item") || this;
        _this.ref = ref;
        _this.value = value;
        _this.label = label;
        _this.uniqueId = uniqueId;
        _this.config = config;
        _this.isEnabled = true;
        _this.RadioInput = new RadioInput(_this.ref, _this.value, _this.uniqueId).Style(_this.config.RadioStyle);
        _this.Label = new $fAOYH.Label().Style(_this.config.LabelStyleWhenEnabled);
        var bondId = "input-label-bond-id-" + Math.random().toString().substring(2);
        _this.RadioInput.Id(bondId);
        _this.Label.Id(bondId);
        _this.Append(_this.RadioInput, _this.Label);
        if (Array.isArray(_this.label)) (_a = _this.Label).Append.apply(_a, _this.label);
        else _this.Label.Append(_this.label);
        _this.RadioInput.On('input', function(e) {
            if (_this.isEnabled) _this.ref.value = value;
        });
        _this.Label.OnClick(function() {
            if (_this.isEnabled) _this.ref.value = value;
        });
        return _this;
    }
    RadioOption.prototype.Enable = function(isEnabled) {
        var _this = this;
        this.React(isEnabled, function(v) {
            return v ? _this.Enabled() : _this.Disabled();
        });
        return this;
    };
    RadioOption.prototype.Disable = function(isDisabled) {
        var _this = this;
        this.React(isDisabled, function(v) {
            return v ? _this.Disabled() : _this.Enabled();
        });
        return this;
    };
    RadioOption.prototype.EnableWhen = function(watch, predicate) {
        var _this = this;
        if (predicate === void 0) predicate = function(value) {
            return !!value;
        };
        this.React(watch, function(v) {
            return _this.Enable(predicate(v));
        });
        return this;
    };
    RadioOption.prototype.DisableWhen = function(watch, predicate) {
        var _this = this;
        if (predicate === void 0) predicate = function(value) {
            return !!value;
        };
        this.React(watch, function(v) {
            return _this.Disable(predicate(v));
        });
        return this;
    };
    RadioOption.prototype.Disabled = function() {
        this.isEnabled = false;
        this.RadioInput.Disabled();
        this.Label.CursorDefault().Style(this.config.LabelStyleWhenDisabled);
        return this;
    };
    RadioOption.prototype.Enabled = function() {
        this.isEnabled = true;
        this.RadioInput.Enabled();
        this.Label.CursorPointer().Style(this.config.LabelStyleWhenEnabled);
        return this;
    };
    return RadioOption;
}($joGvE.Div);
exports.RadioOption = RadioOption;
var RadioConfig = /** @class */ function() {
    function RadioConfig() {
        this.RadioStyle = "";
        this.LabelStyleWhenEnabled = "color: #222";
        this.LabelStyleWhenDisabled = "color: #ccc";
    }
    return RadioConfig;
}();
exports.RadioConfig = RadioConfig;
var Radio = /** @class */ function(_super) {
    __extends(Radio, _super);
    function Radio(ref, config) {
        if (ref === void 0) ref = new $6wI3m.Ref(0);
        var _this = _super.call(this) || this;
        _this.ref = ref;
        _this.Config = new RadioConfig();
        _this.uniqueName = "radio-id-" + Math.random().toString().substring(2);
        if (config) {
            var keys = Object.keys(config);
            keys.forEach(function(k) {
                _this.Add(config[k], k);
            });
        }
        return _this;
    }
    Radio.prototype.Add = function(value, label, thisOption) {
        var item = new RadioOption(this.ref, value, label, this.uniqueName, this.Config);
        thisOption === null || thisOption === void 0 || thisOption(item);
        this.Append(item);
        return this;
    };
    // public Add(value: primitive, content: appendable | appendable[], thisOption?: (input: RadioInput, label: Label) => void): this
    // {
    //     const uniqueId = "input-label-bond-id-" + Math.random().toString().substring(2);
    //     const input = new RadioInput(this.ref, value, this.uniqueName).Id(uniqueId)
    //     const label = new Label(content, uniqueId)
    //     input.On('input',e =>
    //     {
    //     //     // console.log("input")
    //     //     // e.element.preventDefault();
    //     //     // console.log("input clicked", this.ref.value, value)
    //     //     // e.element.checked = true;
    //         this.ref.value = value;
    //     })
    //     label.OnClick(e =>
    //     {
    //         // console.log("label clicked", this.ref.value, value)
    //         // input.element.checked = true;
    //         this.ref.value = value;
    //     })
    //     thisOption?.(input, label);
    //     this.Append(
    //         new Div().Class("radio-item").Append(
    //             input,
    //             label
    //         )
    //     )
    //     return this;
    // }
    Radio.prototype.Configure = function(callback) {
        callback(this.Config);
        return this;
    };
    Radio.Name = "Radio";
    return Radio;
}($joGvE.Div);
exports.Radio = Radio;

});
parcelRegister("joGvE", function(module, exports) {
"use strict";
var $e1f13bb48051effb$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Div = void 0;

var $aKtiT = parcelRequire("aKtiT");
var $e1f13bb48051effb$var$Div = /** @class */ function(_super) {
    $e1f13bb48051effb$var$__extends(Div, _super);
    function Div(classes) {
        var _this = _super.call(this, "div") || this;
        if (classes) _this.Class(classes);
        return _this;
    }
    Div.Name = "Div";
    return Div;
}($aKtiT.ComponentBase);
module.exports.Div = $e1f13bb48051effb$var$Div;

});

parcelRegister("fAOYH", function(module, exports) {
"use strict";
var $b5a1c2f6e538199d$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Label = void 0;

var $2s69t = parcelRequire("2s69t");
var $b5a1c2f6e538199d$var$Label = /** @class */ function(_super) {
    $b5a1c2f6e538199d$var$__extends(Label, _super);
    function Label(content, forId) {
        var _this = _super.call(this, "label") || this;
        if (forId) _this.Attribute("for", forId);
        if (Array.isArray(content)) _this.Append.apply(_this, content);
        else _this.Append(content);
        return _this;
    }
    Label.Name = "Label";
    return Label;
}($2s69t.ComponentBase);
module.exports.Label = $b5a1c2f6e538199d$var$Label;

});
parcelRegister("2s69t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CollectionPrinter = module.exports.CollectionViewer = module.exports.ListItem = module.exports.OrderedList = module.exports.UnorderedList = module.exports.Paragraph = module.exports.Line = module.exports.NewLine = module.exports.ClickableImage = module.exports.Canvas = module.exports.ImageSource = module.exports.ImageInfo = module.exports.Image = module.exports.Link = module.exports.Button = module.exports.TwoFloatingColumns = module.exports.TwinColumns = module.exports.AutoWidthTwoColumns = module.exports.Pre = module.exports.Span = module.exports.Label = module.exports.Div = module.exports.Root = module.exports.RefWatcher = module.exports.ValidationResult = module.exports.Validator = module.exports.PatternExtractor = module.exports.RegexExtractor = module.exports.HandlersCollection = module.exports.Filters = module.exports.CollectionTemplate = module.exports.ArrayTemplate = module.exports.RefSerializer = module.exports.RefReflector = module.exports.Sorter = module.exports.Dumper = module.exports.ComponentBase = module.exports.RefComponentBase = module.exports.CollectionView = module.exports.Collection = module.exports.HashRef = module.exports.RefObject = module.exports.RefNumber = module.exports.RefString = module.exports.RefBool = module.exports.RefDate = module.exports.RV = module.exports.RefBase = module.exports.Ref = module.exports.$ = void 0;
module.exports.TableHeaderCell = module.exports.TableHeaderV2 = module.exports.TableHeader = module.exports.TableCell = module.exports.TableBody = module.exports.Table = module.exports.TableBuilder = module.exports.ProgressBar = module.exports.BlinkMode = module.exports.Led = module.exports.VerticalButtonTabs = module.exports.ButtonTabs = module.exports.HidingContentSwitcher = module.exports.DestroyingPatternContentSwitcher = module.exports.DestroyingContentSwitcher = module.exports.RadioSwitchesBuilder = module.exports.ModalWindow = module.exports.SearchableItem = module.exports.ClearableTextInput = module.exports.TextCombo = module.exports.PopupMenu = module.exports.Menu = module.exports.MultipleFilesInput = module.exports.FileInput = module.exports.LabeledSelect = module.exports.LabeledNumberInput = module.exports.LabeledTextInput = module.exports.MultilineInput = module.exports.EditableTextarea = module.exports.EditableDateLabel = module.exports.DateTimeInput = module.exports.TimeInput = module.exports.DateInput = module.exports.RateStar = module.exports.RateConfig = module.exports.Rate = module.exports.Radio = module.exports.Checkbox = module.exports.SelectOption = module.exports.Select = module.exports.Range = module.exports.NumericRange = module.exports.NumberInput = module.exports.PasswordInput = module.exports.TextInput = module.exports.EditableLabel = module.exports.Text = module.exports.TabsSwitcher = module.exports.Tabs = module.exports.CopyIcon = void 0;
module.exports.Switch = module.exports.UploadResult = module.exports.OnlineStorage = module.exports.Pie = module.exports.Spinner = module.exports.CollectionPaginatorOptions = module.exports.CollectionPaginator = module.exports.PaginatorBrainOptions = module.exports.PaginatorBrain = module.exports.SimplePaginator = module.exports.BasicPaginator = module.exports.Snack = module.exports.RefJsonViewer = module.exports.JsonViewer = module.exports.JsonViewerConfig = module.exports.TableColumn = module.exports.TableRow = module.exports.TableHeaderRow = void 0;

var $iqyiC = parcelRequire("iqyiC");
Object.defineProperty(module.exports, "$", {
    enumerable: true,
    get: function() {
        return $iqyiC.$;
    }
});

var $6wI3m = parcelRequire("6wI3m");
Object.defineProperty(module.exports, "Ref", {
    enumerable: true,
    get: function() {
        return $6wI3m.Ref;
    }
});

var $22Wrn = parcelRequire("22Wrn");
Object.defineProperty(module.exports, "RefBase", {
    enumerable: true,
    get: function() {
        return $22Wrn.RefBase;
    }
});

var $afOau = parcelRequire("afOau");
Object.defineProperty(module.exports, "RV", {
    enumerable: true,
    get: function() {
        return $afOau.RV;
    }
});

var $2Vdhf = parcelRequire("2Vdhf");
Object.defineProperty(module.exports, "RefDate", {
    enumerable: true,
    get: function() {
        return $2Vdhf.RefDate;
    }
});

var $dzlP0 = parcelRequire("dzlP0");
Object.defineProperty(module.exports, "RefBool", {
    enumerable: true,
    get: function() {
        return $dzlP0.RefBool;
    }
});

var $brAEr = parcelRequire("brAEr");
Object.defineProperty(module.exports, "RefString", {
    enumerable: true,
    get: function() {
        return $brAEr.RefString;
    }
});

var $epBKP = parcelRequire("epBKP");
Object.defineProperty(module.exports, "RefNumber", {
    enumerable: true,
    get: function() {
        return $epBKP.RefNumber;
    }
});

var $9JbVp = parcelRequire("9JbVp");
Object.defineProperty(module.exports, "RefObject", {
    enumerable: true,
    get: function() {
        return $9JbVp.RefObject;
    }
});

var $8OWnY = parcelRequire("8OWnY");
Object.defineProperty(module.exports, "HashRef", {
    enumerable: true,
    get: function() {
        return $8OWnY.HashRef;
    }
});

var $6IcxB = parcelRequire("6IcxB");
Object.defineProperty(module.exports, "Collection", {
    enumerable: true,
    get: function() {
        return $6IcxB.Collection;
    }
});

var $8y6Fd = parcelRequire("8y6Fd");
Object.defineProperty(module.exports, "CollectionView", {
    enumerable: true,
    get: function() {
        return $8y6Fd.CollectionView;
    }
});

var $k6KGm = parcelRequire("k6KGm");
Object.defineProperty(module.exports, "RefComponentBase", {
    enumerable: true,
    get: function() {
        return $k6KGm.RefComponentBase;
    }
});

var $aKtiT = parcelRequire("aKtiT");
Object.defineProperty(module.exports, "ComponentBase", {
    enumerable: true,
    get: function() {
        return $aKtiT.ComponentBase;
    }
});

var $hiDht = parcelRequire("hiDht");
Object.defineProperty(module.exports, "Dumper", {
    enumerable: true,
    get: function() {
        return $hiDht.Dumper;
    }
});

var $4Og3n = parcelRequire("4Og3n");
Object.defineProperty(module.exports, "Sorter", {
    enumerable: true,
    get: function() {
        return $4Og3n.Sorter;
    }
});

var $6krno = parcelRequire("6krno");
Object.defineProperty(module.exports, "RefReflector", {
    enumerable: true,
    get: function() {
        return $6krno.RefReflector;
    }
});

var $9Fnts = parcelRequire("9Fnts");
Object.defineProperty(module.exports, "RefSerializer", {
    enumerable: true,
    get: function() {
        return $9Fnts.RefSerializer;
    }
});

var $9ngW8 = parcelRequire("9ngW8");
Object.defineProperty(module.exports, "ArrayTemplate", {
    enumerable: true,
    get: function() {
        return $9ngW8.ArrayTemplate;
    }
});

var $k4rJZ = parcelRequire("k4rJZ");
Object.defineProperty(module.exports, "CollectionTemplate", {
    enumerable: true,
    get: function() {
        return $k4rJZ.CollectionTemplate;
    }
});

var $3Z5yA = parcelRequire("3Z5yA");
Object.defineProperty(module.exports, "Filters", {
    enumerable: true,
    get: function() {
        return $3Z5yA.Filters;
    }
});

var $8PO3e = parcelRequire("8PO3e");
Object.defineProperty(module.exports, "HandlersCollection", {
    enumerable: true,
    get: function() {
        return $8PO3e.HandlersCollection;
    }
});

var $2UVc2 = parcelRequire("2UVc2");
Object.defineProperty(module.exports, "RegexExtractor", {
    enumerable: true,
    get: function() {
        return $2UVc2.RegexExtractor;
    }
});

var $3CTSE = parcelRequire("3CTSE");
Object.defineProperty(module.exports, "PatternExtractor", {
    enumerable: true,
    get: function() {
        return $3CTSE.PatternExtractor;
    }
});

var $8B6cm = parcelRequire("8B6cm");
Object.defineProperty(module.exports, "Validator", {
    enumerable: true,
    get: function() {
        return $8B6cm.Validator;
    }
});
Object.defineProperty(module.exports, "ValidationResult", {
    enumerable: true,
    get: function() {
        return $8B6cm.ValidationResult;
    }
});

var $iwAjC = parcelRequire("iwAjC");
Object.defineProperty(module.exports, "RefWatcher", {
    enumerable: true,
    get: function() {
        return $iwAjC.RefWatcher;
    }
});

var $7mcBr = parcelRequire("7mcBr");
Object.defineProperty(module.exports, "Root", {
    enumerable: true,
    get: function() {
        return $7mcBr.Root;
    }
});

var $joGvE = parcelRequire("joGvE");
Object.defineProperty(module.exports, "Div", {
    enumerable: true,
    get: function() {
        return $joGvE.Div;
    }
});

var $fAOYH = parcelRequire("fAOYH");
Object.defineProperty(module.exports, "Label", {
    enumerable: true,
    get: function() {
        return $fAOYH.Label;
    }
});

var $gkD0R = parcelRequire("gkD0R");
Object.defineProperty(module.exports, "Span", {
    enumerable: true,
    get: function() {
        return $gkD0R.Span;
    }
});

var $aUfnT = parcelRequire("aUfnT");
Object.defineProperty(module.exports, "Pre", {
    enumerable: true,
    get: function() {
        return $aUfnT.Pre;
    }
});

var $1h8RE = parcelRequire("1h8RE");
Object.defineProperty(module.exports, "AutoWidthTwoColumns", {
    enumerable: true,
    get: function() {
        return $1h8RE.AutoWidthTwoColumns;
    }
});

var $gOMMX = parcelRequire("gOMMX");
Object.defineProperty(module.exports, "TwinColumns", {
    enumerable: true,
    get: function() {
        return $gOMMX.TwinColumns;
    }
});

var $hPtm1 = parcelRequire("hPtm1");
Object.defineProperty(module.exports, "TwoFloatingColumns", {
    enumerable: true,
    get: function() {
        return $hPtm1.TwoFloatingColumns;
    }
});

var $2S24U = parcelRequire("2S24U");
Object.defineProperty(module.exports, "Button", {
    enumerable: true,
    get: function() {
        return $2S24U.Button;
    }
});

var $5PIlt = parcelRequire("5PIlt");
Object.defineProperty(module.exports, "Link", {
    enumerable: true,
    get: function() {
        return $5PIlt.Link;
    }
});

var $eONQW = parcelRequire("eONQW");
Object.defineProperty(module.exports, "Image", {
    enumerable: true,
    get: function() {
        return $eONQW.Image;
    }
});

var $d5iKF = parcelRequire("d5iKF");
Object.defineProperty(module.exports, "ImageInfo", {
    enumerable: true,
    get: function() {
        return $d5iKF.ImageInfo;
    }
});

var $CJCrq = parcelRequire("CJCrq");
Object.defineProperty(module.exports, "ImageSource", {
    enumerable: true,
    get: function() {
        return $CJCrq.ImageSource;
    }
});

var $iuQir = parcelRequire("iuQir");
Object.defineProperty(module.exports, "Canvas", {
    enumerable: true,
    get: function() {
        return $iuQir.Canvas;
    }
});

var $8a2qt = parcelRequire("8a2qt");
Object.defineProperty(module.exports, "ClickableImage", {
    enumerable: true,
    get: function() {
        return $8a2qt.ClickableImage;
    }
});

var $gyVEa = parcelRequire("gyVEa");
Object.defineProperty(module.exports, "NewLine", {
    enumerable: true,
    get: function() {
        return $gyVEa.NewLine;
    }
});

var $gwSD4 = parcelRequire("gwSD4");
Object.defineProperty(module.exports, "Line", {
    enumerable: true,
    get: function() {
        return $gwSD4.Line;
    }
});

var $bQA5y = parcelRequire("bQA5y");
Object.defineProperty(module.exports, "Paragraph", {
    enumerable: true,
    get: function() {
        return $bQA5y.Paragraph;
    }
});

var $8fPhC = parcelRequire("8fPhC");
Object.defineProperty(module.exports, "UnorderedList", {
    enumerable: true,
    get: function() {
        return $8fPhC.UnorderedList;
    }
});

var $2yjo2 = parcelRequire("2yjo2");
Object.defineProperty(module.exports, "OrderedList", {
    enumerable: true,
    get: function() {
        return $2yjo2.OrderedList;
    }
});

var $2MZa4 = parcelRequire("2MZa4");
Object.defineProperty(module.exports, "ListItem", {
    enumerable: true,
    get: function() {
        return $2MZa4.ListItem;
    }
});

var $9ewxt = parcelRequire("9ewxt");
Object.defineProperty(module.exports, "CollectionViewer", {
    enumerable: true,
    get: function() {
        return $9ewxt.CollectionViewer;
    }
});

var $4TgXd = parcelRequire("4TgXd");
Object.defineProperty(module.exports, "CollectionPrinter", {
    enumerable: true,
    get: function() {
        return $4TgXd.CollectionPrinter;
    }
});

var $8UMl5 = parcelRequire("8UMl5");
Object.defineProperty(module.exports, "CopyIcon", {
    enumerable: true,
    get: function() {
        return $8UMl5.CopyIcon;
    }
});

var $7LfyP = parcelRequire("7LfyP");
Object.defineProperty(module.exports, "Tabs", {
    enumerable: true,
    get: function() {
        return $7LfyP.Tabs;
    }
});

var $gYRyj = parcelRequire("gYRyj");
Object.defineProperty(module.exports, "TabsSwitcher", {
    enumerable: true,
    get: function() {
        return $gYRyj.TabsSwitcher;
    }
});

var $3B1VX = parcelRequire("3B1VX");
Object.defineProperty(module.exports, "Text", {
    enumerable: true,
    get: function() {
        return $3B1VX.Text;
    }
});

var $hIO35 = parcelRequire("hIO35");
Object.defineProperty(module.exports, "EditableLabel", {
    enumerable: true,
    get: function() {
        return $hIO35.EditableLabel;
    }
});

var $etGN3 = parcelRequire("etGN3");
Object.defineProperty(module.exports, "TextInput", {
    enumerable: true,
    get: function() {
        return $etGN3.TextInput;
    }
});

var $jCElc = parcelRequire("jCElc");
Object.defineProperty(module.exports, "PasswordInput", {
    enumerable: true,
    get: function() {
        return $jCElc.PasswordInput;
    }
});

var $4ytZ3 = parcelRequire("4ytZ3");
Object.defineProperty(module.exports, "NumberInput", {
    enumerable: true,
    get: function() {
        return $4ytZ3.NumberInput;
    }
});

var $2Q6Ax = parcelRequire("2Q6Ax");
Object.defineProperty(module.exports, "NumericRange", {
    enumerable: true,
    get: function() {
        return $2Q6Ax.NumericRange;
    }
});

var $2OnCU = parcelRequire("2OnCU");
Object.defineProperty(module.exports, "Range", {
    enumerable: true,
    get: function() {
        return $2OnCU.Range;
    }
});

var $bGQX2 = parcelRequire("bGQX2");
Object.defineProperty(module.exports, "Select", {
    enumerable: true,
    get: function() {
        return $bGQX2.Select;
    }
});

var $eBSeP = parcelRequire("eBSeP");
Object.defineProperty(module.exports, "SelectOption", {
    enumerable: true,
    get: function() {
        return $eBSeP.SelectOption;
    }
});

var $7fnxp = parcelRequire("7fnxp");
Object.defineProperty(module.exports, "Checkbox", {
    enumerable: true,
    get: function() {
        return $7fnxp.Checkbox;
    }
});

var $bOiUu = parcelRequire("bOiUu");
Object.defineProperty(module.exports, "Radio", {
    enumerable: true,
    get: function() {
        return $bOiUu.Radio;
    }
});

var $5duNI = parcelRequire("5duNI");
Object.defineProperty(module.exports, "Rate", {
    enumerable: true,
    get: function() {
        return $5duNI.Rate;
    }
});

var $85QoO = parcelRequire("85QoO");
Object.defineProperty(module.exports, "RateConfig", {
    enumerable: true,
    get: function() {
        return $85QoO.RateConfig;
    }
});

var $1gg6H = parcelRequire("1gg6H");
Object.defineProperty(module.exports, "RateStar", {
    enumerable: true,
    get: function() {
        return $1gg6H.RateStar;
    }
});

var $8Q6S6 = parcelRequire("8Q6S6");
Object.defineProperty(module.exports, "DateInput", {
    enumerable: true,
    get: function() {
        return $8Q6S6.DateInput;
    }
});

var $5ACZp = parcelRequire("5ACZp");
Object.defineProperty(module.exports, "TimeInput", {
    enumerable: true,
    get: function() {
        return $5ACZp.TimeInput;
    }
});

var $3UiF9 = parcelRequire("3UiF9");
Object.defineProperty(module.exports, "DateTimeInput", {
    enumerable: true,
    get: function() {
        return $3UiF9.DateTimeInput;
    }
});

var $2Tv9C = parcelRequire("2Tv9C");
Object.defineProperty(module.exports, "EditableDateLabel", {
    enumerable: true,
    get: function() {
        return $2Tv9C.EditableDateLabel;
    }
});

var $fGn1O = parcelRequire("fGn1O");
Object.defineProperty(module.exports, "EditableTextarea", {
    enumerable: true,
    get: function() {
        return $fGn1O.EditableTextarea;
    }
});

var $37QPp = parcelRequire("37QPp");
Object.defineProperty(module.exports, "MultilineInput", {
    enumerable: true,
    get: function() {
        return $37QPp.MultilineInput;
    }
});

var $hEMp0 = parcelRequire("hEMp0");
Object.defineProperty(module.exports, "LabeledTextInput", {
    enumerable: true,
    get: function() {
        return $hEMp0.LabeledTextInput;
    }
});

var $kUDwd = parcelRequire("kUDwd");
Object.defineProperty(module.exports, "LabeledNumberInput", {
    enumerable: true,
    get: function() {
        return $kUDwd.LabeledNumberInput;
    }
});

var $iBXy5 = parcelRequire("iBXy5");
Object.defineProperty(module.exports, "LabeledSelect", {
    enumerable: true,
    get: function() {
        return $iBXy5.LabeledSelect;
    }
});

var $6dx9g = parcelRequire("6dx9g");
Object.defineProperty(module.exports, "FileInput", {
    enumerable: true,
    get: function() {
        return $6dx9g.FileInput;
    }
});
Object.defineProperty(module.exports, "MultipleFilesInput", {
    enumerable: true,
    get: function() {
        return $6dx9g.MultipleFilesInput;
    }
});

var $bL1Ff = parcelRequire("bL1Ff");
Object.defineProperty(module.exports, "Menu", {
    enumerable: true,
    get: function() {
        return $bL1Ff.Menu;
    }
});
Object.defineProperty(module.exports, "PopupMenu", {
    enumerable: true,
    get: function() {
        return $bL1Ff.PopupMenu;
    }
});

var $5BSVz = parcelRequire("5BSVz");
Object.defineProperty(module.exports, "TextCombo", {
    enumerable: true,
    get: function() {
        return $5BSVz.TextCombo;
    }
});

var $azQFq = parcelRequire("azQFq");
Object.defineProperty(module.exports, "ClearableTextInput", {
    enumerable: true,
    get: function() {
        return $azQFq.ClearableTextInput;
    }
});

var $7Kd03 = parcelRequire("7Kd03");
Object.defineProperty(module.exports, "SearchableItem", {
    enumerable: true,
    get: function() {
        return $7Kd03.SearchableItem;
    }
});

var $bEnZu = parcelRequire("bEnZu");
Object.defineProperty(module.exports, "ModalWindow", {
    enumerable: true,
    get: function() {
        return $bEnZu.ModalWindow;
    }
});

var $fMKT6 = parcelRequire("fMKT6");
Object.defineProperty(module.exports, "RadioSwitchesBuilder", {
    enumerable: true,
    get: function() {
        return $fMKT6.RadioSwitchesBuilder;
    }
});

var $a9HcF = parcelRequire("a9HcF");
Object.defineProperty(module.exports, "DestroyingContentSwitcher", {
    enumerable: true,
    get: function() {
        return $a9HcF.DestroyingContentSwitcher;
    }
});

var $3slAG = parcelRequire("3slAG");
Object.defineProperty(module.exports, "DestroyingPatternContentSwitcher", {
    enumerable: true,
    get: function() {
        return $3slAG.DestroyingPatternContentSwitcher;
    }
});

var $4yfSX = parcelRequire("4yfSX");
Object.defineProperty(module.exports, "HidingContentSwitcher", {
    enumerable: true,
    get: function() {
        return $4yfSX.HidingContentSwitcher;
    }
});

var $3700g = parcelRequire("3700g");
Object.defineProperty(module.exports, "ButtonTabs", {
    enumerable: true,
    get: function() {
        return $3700g.ButtonTabs;
    }
});

var $fhrT0 = parcelRequire("fhrT0");
Object.defineProperty(module.exports, "VerticalButtonTabs", {
    enumerable: true,
    get: function() {
        return $fhrT0.VerticalButtonTabs;
    }
});

var $4YE9f = parcelRequire("4YE9f");
Object.defineProperty(module.exports, "Led", {
    enumerable: true,
    get: function() {
        return $4YE9f.Led;
    }
});
Object.defineProperty(module.exports, "BlinkMode", {
    enumerable: true,
    get: function() {
        return $4YE9f.BlinkMode;
    }
});

var $1bL1j = parcelRequire("1bL1j");
Object.defineProperty(module.exports, "ProgressBar", {
    enumerable: true,
    get: function() {
        return $1bL1j.ProgressBar;
    }
});

var $8BrJA = parcelRequire("8BrJA");
Object.defineProperty(module.exports, "TableBuilder", {
    enumerable: true,
    get: function() {
        return $8BrJA.TableBuilder;
    }
});

var $1lG8E = parcelRequire("1lG8E");
Object.defineProperty(module.exports, "Table", {
    enumerable: true,
    get: function() {
        return $1lG8E.Table;
    }
});

var $1lIsG = parcelRequire("1lIsG");
Object.defineProperty(module.exports, "TableBody", {
    enumerable: true,
    get: function() {
        return $1lIsG.TableBody;
    }
});

var $pCapU = parcelRequire("pCapU");
Object.defineProperty(module.exports, "TableCell", {
    enumerable: true,
    get: function() {
        return $pCapU.TableCell;
    }
});

var $bdjAM = parcelRequire("bdjAM");
Object.defineProperty(module.exports, "TableHeader", {
    enumerable: true,
    get: function() {
        return $bdjAM.TableHeader;
    }
});

var $3lnvs = parcelRequire("3lnvs");
Object.defineProperty(module.exports, "TableHeaderV2", {
    enumerable: true,
    get: function() {
        return $3lnvs.TableHeaderV2;
    }
});

var $kWKxK = parcelRequire("kWKxK");
Object.defineProperty(module.exports, "TableHeaderCell", {
    enumerable: true,
    get: function() {
        return $kWKxK.TableHeaderCell;
    }
});

var $dLmKH = parcelRequire("dLmKH");
Object.defineProperty(module.exports, "TableHeaderRow", {
    enumerable: true,
    get: function() {
        return $dLmKH.TableHeaderRow;
    }
});

var $cUBMo = parcelRequire("cUBMo");
Object.defineProperty(module.exports, "TableRow", {
    enumerable: true,
    get: function() {
        return $cUBMo.TableRow;
    }
});

var $7Fc9Q = parcelRequire("7Fc9Q");
Object.defineProperty(module.exports, "TableColumn", {
    enumerable: true,
    get: function() {
        return $7Fc9Q.TableColumn;
    }
});

var $2ZZKK = parcelRequire("2ZZKK");
Object.defineProperty(module.exports, "JsonViewerConfig", {
    enumerable: true,
    get: function() {
        return $2ZZKK.JsonViewerConfig;
    }
});

var $eBKPc = parcelRequire("eBKPc");
Object.defineProperty(module.exports, "JsonViewer", {
    enumerable: true,
    get: function() {
        return $eBKPc.JsonViewer;
    }
});
Object.defineProperty(module.exports, "RefJsonViewer", {
    enumerable: true,
    get: function() {
        return $eBKPc.RefJsonViewer;
    }
});

var $e6E17 = parcelRequire("e6E17");
Object.defineProperty(module.exports, "Snack", {
    enumerable: true,
    get: function() {
        return $e6E17.Snack;
    }
});

var $50yqK = parcelRequire("50yqK");
Object.defineProperty(module.exports, "BasicPaginator", {
    enumerable: true,
    get: function() {
        return $50yqK.BasicPaginator;
    }
});

var $et3h1 = parcelRequire("et3h1");
Object.defineProperty(module.exports, "SimplePaginator", {
    enumerable: true,
    get: function() {
        return $et3h1.SimplePaginator;
    }
});

var $kanmU = parcelRequire("kanmU");
Object.defineProperty(module.exports, "PaginatorBrain", {
    enumerable: true,
    get: function() {
        return $kanmU.PaginatorBrain;
    }
});
Object.defineProperty(module.exports, "PaginatorBrainOptions", {
    enumerable: true,
    get: function() {
        return $kanmU.PaginatorBrainOptions;
    }
});

var $5snGY = parcelRequire("5snGY");
Object.defineProperty(module.exports, "CollectionPaginator", {
    enumerable: true,
    get: function() {
        return $5snGY.CollectionPaginator;
    }
});
Object.defineProperty(module.exports, "CollectionPaginatorOptions", {
    enumerable: true,
    get: function() {
        return $5snGY.CollectionPaginatorOptions;
    }
});

var $bjWq6 = parcelRequire("bjWq6");
Object.defineProperty(module.exports, "Spinner", {
    enumerable: true,
    get: function() {
        return $bjWq6.Spinner;
    }
});

var $ckMZV = parcelRequire("ckMZV");
Object.defineProperty(module.exports, "Pie", {
    enumerable: true,
    get: function() {
        return $ckMZV.Pie;
    }
});

var $djLWA = parcelRequire("djLWA");
Object.defineProperty(module.exports, "OnlineStorage", {
    enumerable: true,
    get: function() {
        return $djLWA.OnlineStorage;
    }
});

var $cOIL8 = parcelRequire("cOIL8");
Object.defineProperty(module.exports, "UploadResult", {
    enumerable: true,
    get: function() {
        return $cOIL8.UploadResult;
    }
});

var $aq9Em = parcelRequire("aq9Em");
Object.defineProperty(module.exports, "Switch", {
    enumerable: true,
    get: function() {
        return $aq9Em.Switch;
    }
});

});
parcelRegister("iqyiC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.$ = void 0;
function $d6a542d33b147c1c$var$$(query) {
    return document.querySelector(query);
}
module.exports.$ = $d6a542d33b147c1c$var$$;
Object.prototype.Keys = function() {
    if (this === undefined) return [];
    return Object.keys(this);
};
Object.prototype.Values = function() {
    if (this === undefined) return [];
    return Object.values(this);
};
HTMLElement.prototype.Hide = function() {
    this.style.display = "none";
};
HTMLElement.prototype.Show = function(as) {
    if (as === void 0) as = "inline-block";
    this.style.display = as;
};
HTMLElement.prototype.Visibility = function(show, as) {
    if (as === void 0) as = "inline-block";
    if (show) this.Show(as);
    else this.Hide();
};
HTMLElement.prototype.IsVisible = function() {
    var bounding = this.getBoundingClientRect();
    return bounding.top >= 0 && bounding.left >= 0 && bounding.bottom <= window.innerHeight && bounding.right <= window.innerWidth;
};
HTMLElement.prototype.Toggle = function() {
    this.IsVisible() ? this.Hide() : this.Show();
};
HTMLElement.prototype.Append = function(child) {
    this.appendChild(child);
    return this;
};
HTMLElement.prototype.Prepend = function(child) {
    this.prepend(child);
    return this;
};
HTMLElement.prototype.Exist = function(child) {
    var ch = Array.from(this.children);
    return !!ch.find(function(c) {
        return c === child;
    });
};
HTMLElement.prototype.Remove = function(child) {
    this.removeChild(child);
    return this;
};
HTMLElement.prototype.Clear = function() {
    this.innerHTML = "";
    return this;
};
HTMLInputElement.prototype.Enabled = function() {
    this.disabled = false;
    return this;
};
HTMLInputElement.prototype.Disabled = function() {
    this.disabled = true;
    return this;
};
HTMLButtonElement.prototype.Enabled = function() {
    this.disabled = false;
    return this;
};
HTMLButtonElement.prototype.Disabled = function() {
    this.disabled = true;
    return this;
};
HTMLElement.prototype.Text = function(text) {
    this.innerText = text;
    return this;
};
HTMLElement.prototype.GetText = function() {
    return this.innerText;
};
HTMLInputElement.prototype.Value = function(text) {
    this.value = text;
};
HTMLInputElement.prototype.Focus = function() {
    this.focus();
    return this;
};

});

parcelRegister("afOau", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RV = void 0;

var $6wI3m = parcelRequire("6wI3m");
/*
    Ref or Value

    DLACZEGO TO NIE JEST ZASZYTE W KLASACH BAZOWYCH?????????????
*/ var $7772386e437c2b55$var$RV = /** @class */ function() {
    function RV() {}
    RV.Use = function(valueOrRef, callback) {
        if (valueOrRef == undefined) // throw new Error("Value or Ref must be provided");
        return;
        if (!callback) throw new Error("Callback must be provided");
        if (valueOrRef instanceof $6wI3m.Ref) valueOrRef.OnChange(function(v) {
            callback(v);
        }, true);
        else callback(valueOrRef);
    };
    return RV;
}();
module.exports.RV = $7772386e437c2b55$var$RV;

});

parcelRegister("2Vdhf", function(module, exports) {
"use strict";
var $220b34358cb60465$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RefDate = void 0;

var $6wI3m = parcelRequire("6wI3m");
var $220b34358cb60465$var$RefDate = /** @class */ function(_super) {
    $220b34358cb60465$var$__extends(RefDate, _super);
    function RefDate(initialDate) {
        if (initialDate === void 0) initialDate = new Date(0);
        var _this = this;
        if (initialDate instanceof Date) _this = _super.call(this, initialDate) || this;
        else if (typeof initialDate === "number") _this = _super.call(this, new Date(initialDate)) || this;
        else if (typeof initialDate === "string") _this = _super.call(this, new Date(initialDate)) || this;
        return _this;
    }
    Object.defineProperty(RefDate.prototype, "IsToday", {
        get: function() {
            var now = new Date();
            return this.value.getFullYear() === now.getFullYear() && this.value.getMonth() === now.getMonth() && this.value.getDate() === now.getDate();
        },
        enumerable: false,
        configurable: true
    });
    return RefDate;
}($6wI3m.Ref);
module.exports.RefDate = $220b34358cb60465$var$RefDate;

});

parcelRegister("dzlP0", function(module, exports) {
"use strict";
var $9e0f7898db26d6f1$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RefBool = void 0;

var $6wI3m = parcelRequire("6wI3m");
var $9e0f7898db26d6f1$var$RefBool = /** @class */ function(_super) {
    $9e0f7898db26d6f1$var$__extends(RefBool, _super);
    function RefBool(initialBool) {
        if (initialBool === void 0) initialBool = false;
        return _super.call(this, initialBool) || this;
    }
    RefBool.prototype.CombineRefBool = function(anotherRef, operation) {
        var _this = this;
        var result = new RefBool(operation(this.value, anotherRef.value));
        this.OnChange(function(v) {
            return result.value = operation(_this.value, anotherRef.value);
        });
        anotherRef.OnChange(function(v) {
            return result.value = operation(_this.value, anotherRef.value);
        });
        return result;
    };
    RefBool.prototype.CombineRefBoolValue = function(anotherValue, operation) {
        var result = new RefBool(operation(this.value, anotherValue));
        this.OnChange(function(v) {
            return result.value = operation(v, anotherValue);
        }, true);
        return result;
    };
    RefBool.prototype.MixRefBool = function(x, operation) {
        if (x instanceof $6wI3m.Ref) return this.CombineRefBool(x, operation);
        else return this.CombineRefBoolValue(x, operation);
    };
    RefBool.prototype.And = function(anotherRef) {
        return this.MixRefBool(anotherRef, function(a, b) {
            return a && b;
        });
    };
    RefBool.prototype.Or = function(anotherRef) {
        return this.MixRefBool(anotherRef, function(a, b) {
            return a || b;
        });
    };
    RefBool.prototype.Toggle = function() {
        this.value = !this.value;
        return this;
    };
    RefBool.prototype.True = function() {
        this.value = true;
        return this;
    };
    RefBool.prototype.IsTrue = function() {
        return this.value == true;
    };
    RefBool.prototype.IsFalse = function() {
        return this.value == false;
    };
    RefBool.prototype.False = function() {
        this.value = false;
        return this;
    };
    return RefBool;
}($6wI3m.Ref);
module.exports.RefBool = $9e0f7898db26d6f1$var$RefBool;

});

parcelRegister("brAEr", function(module, exports) {
"use strict";
var $854ea58599fdd688$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RefString = void 0;

var $6wI3m = parcelRequire("6wI3m");
var $854ea58599fdd688$var$RefString = /** @class */ function(_super) {
    $854ea58599fdd688$var$__extends(RefString, _super);
    function RefString(initialString) {
        if (initialString === void 0) initialString = "";
        return _super.call(this, initialString) || this;
    }
    RefString.prototype.Includes = function(toCompare) {
        // return value.includes(this.value as string);
        return this.Compare(this, toCompare, function(a, b) {
            return a.includes(b);
        });
    };
    return RefString;
}($6wI3m.Ref);
module.exports.RefString = $854ea58599fdd688$var$RefString;

});

parcelRegister("epBKP", function(module, exports) {
"use strict";
var $a7e0afb408ba02ac$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RefNumber = void 0;

var $6wI3m = parcelRequire("6wI3m");
var $a7e0afb408ba02ac$var$RefNumber = /** @class */ function(_super) {
    $a7e0afb408ba02ac$var$__extends(RefNumber, _super);
    function RefNumber(initialNumber) {
        if (initialNumber === void 0) initialNumber = 0;
        return _super.call(this, initialNumber) || this;
    }
    RefNumber.prototype.IsBigger = function(toCompare) {
        return this.Compare(this, toCompare, function(a, b) {
            return a > b;
        });
    };
    RefNumber.prototype.IsBiggerOrEqual = function(toCompare) {
        return this.Compare(this, toCompare, function(a, b) {
            return a >= b;
        });
    };
    RefNumber.prototype.IsSmaller = function(toCompare) {
        return this.Compare(this, toCompare, function(a, b) {
            return a < b;
        });
    };
    RefNumber.prototype.IsSmallerrOrEqual = function(toCompare) {
        return this.Compare(this, toCompare, function(a, b) {
            return a <= b;
        });
    };
    RefNumber.prototype.Plus = function(x) {
        return this.Mix(x, function(a, b) {
            return a + b;
        });
    };
    RefNumber.prototype.Minus = function(x) {
        return this.Mix(x, function(a, b) {
            return a - b;
        });
    };
    RefNumber.prototype.Multiply = function(x) {
        return this.Mix(x, function(a, b) {
            return a * b;
        });
    };
    RefNumber.prototype.Divide = function(x) {
        return this.Mix(x, function(a, b) {
            return a / b;
        });
    };
    return RefNumber;
}($6wI3m.Ref);
module.exports.RefNumber = $a7e0afb408ba02ac$var$RefNumber;

});

parcelRegister("9JbVp", function(module, exports) {
"use strict";
var $7151910ed7a0ffae$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RefObject = void 0;

var $22Wrn = parcelRequire("22Wrn");
var $7151910ed7a0ffae$var$RefObject = /** @class */ function(_super) {
    $7151910ed7a0ffae$var$__extends(RefObject, _super);
    function RefObject(_obj) {
        var _this = _super.call(this) || this;
        _this._obj = _obj;
        return _this;
    }
    RefObject.prototype.Set = function(obj, excludeControlForRefresh) {
        this._obj = obj;
        this.RefreshSubscribers(excludeControlForRefresh);
        this.onChangeHandler.Call(this._obj);
    };
    RefObject.prototype.ForceOnChange = function() {
        this.RefreshSubscribers();
        this.onChangeHandler.Call(this._obj);
    };
    Object.defineProperty(RefObject.prototype, "object", {
        get: function() {
            return this._obj;
        },
        set: function(object) {
            this.Set(object);
        },
        enumerable: false,
        configurable: true
    });
    RefObject.prototype.Call = function(fn) {
        fn(this._obj);
        this.onChangeHandler.Call(this._obj);
        this.RefreshSubscribers();
        return this;
    };
    RefObject.prototype.OnChange = function(handler, callThisCallbackRightAway) {
        if (callThisCallbackRightAway === void 0) callThisCallbackRightAway = false;
        this.onChangeHandler.Add(handler);
        if (callThisCallbackRightAway == true) handler(this._obj, true);
        return this;
    };
    RefObject.prototype.toString = function() {
        if (this.Name) return "RefObject named ".concat(this.Name);
        else return "RefObject";
    };
    RefObject.prototype.Storable = function(key, storage) {
        if (storage === void 0) storage = "local";
        if (!key) return this;
        var stor;
        switch(storage){
            case "local":
                stor = window.localStorage;
                break;
            case "session":
                stor = window.sessionStorage;
                break;
        }
        var value = JSON.parse(stor.getItem(key));
        this.Set(value);
        this.OnChange(function(v) {
            return stor.setItem(key, JSON.stringify(v));
        });
        return this;
    };
    return RefObject;
}($22Wrn.RefBase);
module.exports.RefObject = $7151910ed7a0ffae$var$RefObject;

});

parcelRegister("8OWnY", function(module, exports) {
"use strict";
var $66c04871e0226872$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HashRef = void 0;

var $6wI3m = parcelRequire("6wI3m");
var $66c04871e0226872$var$HashRef = /** @class */ function(_super) {
    $66c04871e0226872$var$__extends(HashRef, _super);
    function HashRef() {
        var _this = _super.call(this, window.location.hash.slice(1)) || this;
        _this.preventOnChange = false;
        window.onpopstate = function(e) {
            var hash = window.location.hash.split("#")[1];
            _this.Set(hash, _this);
        };
        window.onhashchange = function(e) {
            _this.preventOnChange = true;
            var hash = e.newURL.split("#")[1];
            _this.Set(hash, _this);
            _this.preventOnChange = false;
        };
        _this.OnChange(function(v) {
            if (_this.preventOnChange) return;
            window.location.hash = v;
        });
        return _this;
    }
    return HashRef;
}($6wI3m.Ref);
module.exports.HashRef = $66c04871e0226872$var$HashRef;

});

parcelRegister("6IcxB", function(module, exports) {
"use strict";
var $4e309485f53641b8$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Collection = void 0;

var $6wI3m = parcelRequire("6wI3m");

var $22Wrn = parcelRequire("22Wrn");

var $8PO3e = parcelRequire("8PO3e");
var $4e309485f53641b8$var$Collection = /** @class */ function(_super) {
    $4e309485f53641b8$var$__extends(Collection, _super);
    function Collection(items) {
        if (items === void 0) items = [];
        var _this = _super.call(this) || this;
        _this.items = items;
        _this.onAddHandlers = new $8PO3e.HandlersCollection();
        _this.onRemoveHandlers = new $8PO3e.HandlersCollection();
        _this.CountRef = new $6wI3m.Ref(_this.items.length);
        return _this;
    }
    Collection.prototype.Storable = function(key, storage, serialize, deserialize) {
        if (storage === void 0) storage = "local";
        if (!key) return this;
        var stor;
        switch(storage){
            case "local":
                stor = window.localStorage;
                break;
            case "session":
                stor = window.sessionStorage;
                break;
        }
        var valueFromStorage = stor.getItem(key);
        if (valueFromStorage) this.items = deserialize(valueFromStorage);
        this.OnChange(function(items) {
            var serialized = serialize(items);
            stor.setItem(key, serialized);
        });
        return this;
    };
    Object.defineProperty(Collection.prototype, "IsEmpty", {
        get: function() {
            return this.Count == 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Collection.prototype, "IsNotEmpty", {
        get: function() {
            return this.Count > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Collection.prototype, "Items", {
        get: function() {
            return this.items;
        },
        enumerable: false,
        configurable: true
    });
    Collection.prototype.OnAdd = function(handler) {
        this.onAddHandlers.Add(handler);
        return this;
    };
    Collection.prototype.Add = function() {
        var _this = this;
        var newItems = [];
        for(var _i = 0; _i < arguments.length; _i++)newItems[_i] = arguments[_i];
        newItems.forEach(function(x) {
            _this.items.push(x);
        });
        this.CountRef.value = this.items.length;
        this.onChangeHandler.Call(this.items);
        this.RefreshSubscribers();
        this.onAddHandlers.Call(newItems);
        return this;
    };
    Collection.prototype.Load = function() {
        // TODO: jeśli pierwszy argument jest tablicą to traktuj jak tablice, tylko co z tablicą tablic wtedy?
        var items = [];
        for(var _i = 0; _i < arguments.length; _i++)items[_i] = arguments[_i];
        this.items = [];
        return this.Add.apply(this, items);
    };
    Collection.prototype.OnRemove = function(handler) {
        this.onRemoveHandlers.Add(handler);
        return this;
    };
    Collection.prototype.Remove = function(item) {
        if (item == undefined) return this;
        this.onRemoveHandlers.Call(item);
        return this.Call(function(items) {
            return items.Remove(item);
        });
    };
    Collection.prototype.RemoveAll = function() {
        var _this = this;
        this.items.forEach(function(item) {
            return _this.onRemoveHandlers.Call(item);
        });
        return this.Modify(function(items) {
            return [];
        });
    };
    Collection.prototype.Clear = function() {
        return this.RemoveAll();
    };
    Collection.prototype.Contains = function(item) {
        return this.items.includes(item);
    };
    Collection.prototype.Modify = function(fn) {
        this.items = fn(this.items);
        this.CountRef.value = this.items.length;
        this.onChangeHandler.Call(this.items);
        this.RefreshSubscribers();
        // TODO: a co z onRemoveHandlers?????
        return this;
    };
    Collection.prototype.ModifyOne = function(predicate, modify) {
        var found = this.items.find(predicate);
        if (!found) return this;
        modify(found);
        this.CountRef.value = this.items.length;
        this.onChangeHandler.Call(this.items);
        this.RefreshSubscribers();
        return this;
    };
    Collection.prototype.Call = function(fn) {
        fn(this.items);
        this.CountRef.value = this.items.length;
        this.onChangeHandler.Call(this.items);
        this.RefreshSubscribers();
        return this;
    };
    Collection.prototype.ForceOnChange = function() {
        this.CountRef.value = this.items.length;
        this.onChangeHandler.Call(this.items);
        this.RefreshSubscribers();
        return this;
    };
    Collection.prototype.ForEach = function(callback) {
        this.items.forEach(function(x, i, a) {
            callback(x, i, a);
        });
        return this;
    };
    Collection.prototype.Filter = function(callback) {
        return this.items.filter(callback);
    };
    Collection.prototype.Find = function(callback) {
        return this.items.find(callback);
    };
    Collection.prototype.Map = function(callback) {
        return this.items.map(callback);
    };
    Collection.prototype.Reduce = function(callback, initialValue) {
        return this.items.reduce(callback, initialValue);
    };
    Collection.prototype.First = function() {
        return this.items[0];
    };
    Collection.prototype.Last = function() {
        return this.items[this.Count - 1];
    };
    Collection.prototype.RemoveMany = function(items) {
        var _this = this;
        items.forEach(function(x) {
            _this.onRemoveHandlers.Call(x);
            _this.items.Remove(x);
        });
        this.CountRef.value = this.items.length;
        this.onChangeHandler.Call(this.items);
        this.RefreshSubscribers();
        return this;
    };
    Object.defineProperty(Collection.prototype, "Count", {
        get: function() {
            return this.items.length;
        },
        enumerable: false,
        configurable: true
    });
    Collection.prototype.Take = function(start, count) {
        if (count > 0) return this.items.slice(start, start + count);
        else return this.items.slice(start);
    };
    Collection.prototype.Swap = function(a, b) {
        var _a;
        if (a < 0 || b >= this.items.length) return this;
        _a = [
            this.items[b],
            this.items[a]
        ], this.items[a] = _a[0], this.items[b] = _a[1];
        this.CountRef.value = this.items.length;
        this.onChangeHandler.Call(this.items);
        this.RefreshSubscribers();
        return this;
    };
    Collection.prototype.SwapUp = function(item) {
        var itemIndex = this.items.findIndex(function(x) {
            return x == item;
        });
        if (itemIndex == -1) return this;
        var itemAbove = itemIndex - 1;
        if (itemAbove < 0) return this;
        this.Swap(itemIndex, itemAbove);
        return this;
    };
    Collection.prototype.SwapDown = function(item) {
        var itemIndex = this.items.findIndex(function(x) {
            return x == item;
        });
        if (itemIndex == -1) return this;
        var itemBelow = itemIndex + 1;
        if (itemBelow >= this.Count) return this;
        this.Swap(itemIndex, itemBelow);
        return this;
    };
    Collection.prototype.CanSwapUp = function(item) {
        return !this.IsFirst(item);
    };
    Collection.prototype.CanSwapDown = function(item) {
        return !this.IsLast(item);
    };
    Collection.prototype.IsFirst = function(item) {
        var itemIndex = this.items.findIndex(function(x) {
            return x == item;
        });
        return itemIndex == 0;
    };
    Collection.prototype.IsLast = function(item) {
        var itemIndex = this.items.findIndex(function(x) {
            return x == item;
        });
        return itemIndex == this.Count - 1;
    };
    Object.defineProperty(Collection.prototype, "FirstItem", {
        get: function() {
            return this.items[0];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Collection.prototype, "LastItem", {
        get: function() {
            return this.items[this.Count - 1];
        },
        enumerable: false,
        configurable: true
    });
    Collection.prototype.OnChange = function(handler, callThisCallbackRightAway) {
        if (callThisCallbackRightAway === void 0) callThisCallbackRightAway = false;
        this.onChangeHandler.Add(handler);
        if (callThisCallbackRightAway == true) handler(this.items, true);
        return this;
    };
    Collection.prototype.toString = function() {
        if (this.Name) return "Collection of ".concat(this.Name, " (").concat(this.Count, " items)");
        else return "Collection (".concat(this.Count, " items)");
    };
    return Collection;
}($22Wrn.RefBase);
module.exports.Collection = $4e309485f53641b8$var$Collection;

});

parcelRegister("8y6Fd", function(module, exports) {
"use strict";
var $6396aaf96491eb4a$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CollectionView = void 0;

var $6wI3m = parcelRequire("6wI3m");

var $22Wrn = parcelRequire("22Wrn");

var $6IcxB = parcelRequire("6IcxB");
var $6396aaf96491eb4a$var$CollectionView = /** @class */ function(_super) {
    $6396aaf96491eb4a$var$__extends(CollectionView, _super);
    function CollectionView(data) {
        var _this = _super.call(this) || this;
        _this.Items = [];
        _this.filtersRefs = [];
        _this.filters = [];
        _this.FilteredCount = new $6wI3m.Ref(0);
        _this.collection = new $6IcxB.Collection();
        if (Array.isArray(data)) _this.collection = new $6IcxB.Collection(data);
        else if (data instanceof $6IcxB.Collection) _this.collection = data;
        _this.collection.AddSubscriber(_this);
        return _this;
    }
    Object.defineProperty(CollectionView.prototype, "Collection", {
        get: function() {
            return this.collection;
        },
        enumerable: false,
        configurable: true
    });
    CollectionView.prototype.OnChange = function(handler, callThisCallbackRightAway) {
        this.onChangeHandler.Add(handler);
        if (callThisCallbackRightAway == true) handler(this.Items, true);
        return this;
    };
    CollectionView.prototype.ForEach = function(fn) {
        this.onRefresh = fn; //???????
        return this;
    };
    CollectionView.prototype.Refresh = function() {
        var _this = this;
        this.Items = this.collection.Items;
        this.filters.forEach(function(filterPredicate, index) {
            var filterRef = _this.filtersRefs[index];
            var refValue = filterRef instanceof $6wI3m.Ref ? filterRef.value : filterRef.Items;
            _this.Items = _this.Items.filter(function(item) {
                return filterPredicate(item, refValue);
            });
        });
        this.FilteredCount.value = this.Items.length;
        if (this.start && this.count) this.Items = this.Items.slice(this.start.value, this.start.value + this.count.value);
        if (this.onRefresh) this.Items.forEach(function(record, index, array) {
            return _this.onRefresh(record, index, array);
        });
        this.onChangeHandler.Call(this.Items);
        this.RefreshSubscribers();
        return this;
    };
    CollectionView.prototype.Filter = function(ref, predicate) {
        ref.AddSubscriber(this);
        this.filtersRefs.push(ref);
        this.filters.push(predicate);
        return this;
    };
    CollectionView.prototype.Take = function(predicate) {
        this.Items = this.Items.filter(predicate);
        return this;
    };
    CollectionView.prototype.See = function(start, count) {
        start.AddSubscriber(this);
        count.AddSubscriber(this);
        this.start = start;
        this.count = count;
        return this;
    };
    return CollectionView;
}($22Wrn.RefBase);
module.exports.CollectionView = $6396aaf96491eb4a$var$CollectionView;

});

parcelRegister("hiDht", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Dumper = void 0;

var $6IcxB = parcelRequire("6IcxB");

var $6wI3m = parcelRequire("6wI3m");
var $c982967191c09fe2$var$Dumper = /** @class */ function() {
    function Dumper() {}
    Dumper.Dump = function(obj) {
        var out = "";
        // obj.forEach(o=>  DumpObj(obj, o));
        out = Dumper.DumpObj2(obj, out);
        // console.log(out);
        return out;
    };
    Dumper.DumpObj2 = function(obj, out, prefix) {
        // console.log('DumpObj2');
        // if (prefix)
        //     out += prefix
        // out += `\n[[[[[${typeof obj}]]]]]\n`
        switch(typeof obj){
            case "string":
                out += ":string";
                break;
            case "number":
                out += ":number";
                break;
            case "boolean":
                out += ":boolean";
                break;
            case "object":
                if (obj instanceof $6wI3m.Ref) out += obj === null || obj === void 0 ? void 0 : obj.ToString();
                else if (obj instanceof $6IcxB.Collection) {
                    out += obj === null || obj === void 0 ? void 0 : obj.toString();
                    obj.Items.forEach(function(e, i) {
                        out += "\n[".concat(i, "]\n");
                        var cc = "";
                        cc = Dumper.DumpObj2(e, cc);
                        out += cc;
                    });
                } else Object.keys(obj).forEach(function(k, i) {
                    out += "__ ".concat(k);
                    var v = obj[k];
                    // switch (typeof v)
                    // {
                    //     case "string": out += `:string = "${v}"`; break;
                    //     case "number": out += `:number = ${v}`; break;
                    //     case "boolean": out += `:boolean = ${v ? "true" : "false"}`; break;
                    // default: out += `:unknown-type = ${v}`; break;
                    // }
                    out += ": ".concat(v);
                    out += "\n";
                // out += DumpObj2(obj[k], out)
                });
                break;
            default:
                out += "unknown type: " + typeof obj;
        }
        // console.log('DumpObj2 end');
        return out;
    };
    Dumper.DumpObj = function(obj, out) {
        // console.log(obj);
        // if ((typeof obj === "string") || (typeof obj === "number")
        // || (typeof obj === "boolean"))
        // {
        //     out += `${k}: ${v || "(empty)"}\n`;
        // }
        // else
        // out+=typeof(obj) + ": "
        var _this = this;
        Object.keys(obj).forEach(function(k, i) {
            var v = obj[k];
            // console.log(k, typeof v);
            out += "\uD83D\uDD38 ";
            // console.log(`#${i} k=${k} v=${v}`, 'isarr', Array.isArray(v));
            if (typeof v === "string" || typeof v === "number") out += "".concat(k, ": ").concat(v || "(empty)", "\n");
            else if (v instanceof $6wI3m.Ref) {
                // console.log(`REF ${k}: ${v.value}`);
                if (typeof v.value === "boolean") // console.log('V IS BOOL');
                out += "".concat(k, ":bool : ").concat(v.value ? "true" : "false", " ").concat(v.HasChanged ? "*" : "", " [").concat(_this.WatchersInfo(v), "]\n");
                else if (typeof v.value === "string") out += "".concat(k, ":string : \"").concat(v.value, "\" ").concat(v.HasChanged ? "*" : "", " [").concat(_this.WatchersInfo(v), "]\n");
                else if (typeof v.value === "number") out += "".concat(k, ":number : ").concat(v.value, " ").concat(v.HasChanged ? "*" : "", " [").concat(_this.WatchersInfo(v), "]\n");
                else // console.log('V IS NOT BOOL', typeof(v.value));
                out += "".concat(k, " (").concat(typeof v.value, "): ").concat(v.value || "(empty)", " ").concat(v.HasChanged ? "*" : "", " [").concat(_this.WatchersInfo(v), "]\n");
            } else if (v instanceof $6wI3m.Ref) // console.log(`REF ${k}: ${v.value}`);
            out += "".concat(k, ": ").concat(v.value || "(empty)", " ").concat(v.HasChanged ? "*" : "", " [").concat(_this.WatchersInfo(v), "]\n");
            else if (v instanceof $6IcxB.Collection) {
                // console.log('ARRAY');
                // out += "" + k + ": " + this.Dump(v)+"\n";
                out += "" + k + ":collection(" + v.Count + ")\n";
                out += "___" + _this.DumpObj(v.Items, out);
            } else if (Array.isArray(v)) {
                // console.log('ARRAY');
                // out += "" + k + ": " + this.Dump(v)+"\n";
                // out += "" + k + ": " + Dump(v);
                out += "" + k + ":array(" + v.length + ")\n";
                v.forEach(function(e, i) {
                    out += "___ [" + i + "]: " + _this.DumpObj(e, out);
                });
            } else if (Object.keys(v).length > 0) ;
            else // console.log('?????', k);  
            out += "" + k + ":" + typeof v + "\n";
        });
        out += "\n";
        // console.log(out);
        return out;
    };
    Dumper.WatchersInfo = function(v) {
        var _a, _b;
        return ((_b = (_a = v.Watchers) === null || _a === void 0 ? void 0 : _a.map(function(c) {
            return c.Id;
        })) === null || _b === void 0 ? void 0 : _b.join(", ")) || "no watchers";
    };
    return Dumper;
}();
module.exports.Dumper = $c982967191c09fe2$var$Dumper;

});

parcelRegister("4Og3n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Sorter = void 0;

var $6wI3m = parcelRequire("6wI3m");
var $380848d711c07323$var$Sorter = /** @class */ function() {
    function Sorter(collection, selected) {
        if (selected === void 0) selected = new $6wI3m.Ref("");
        var _this = this;
        this.collection = collection;
        this.selected = selected;
        this.sorts = [];
        this.selected.OnChange(function(_) {
            _this.Refresh();
        }); // second parameter of OnChange will not take action here cause sort functions are not registered (with Add) at this point yet
    }
    Sorter.prototype.Refresh = function() {
        var _this = this;
        this.collection.Call(function(items) {
            return _this.SortBySelectedFunction(items);
        });
        return this;
    };
    Sorter.prototype.Add = function(label, sortFunction) {
        this.sorts.push({
            label: label,
            sortFunction: sortFunction
        });
        return this;
    };
    Sorter.prototype.Reset = function() {
        this.selected.Restore();
        return this;
    };
    Object.defineProperty(Sorter.prototype, "SelectedValue", {
        get: function() {
            return this.selected;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Sorter.prototype, "Labels", {
        get: function() {
            return this.sorts.map(function(x) {
                return x.label;
            });
        },
        enumerable: false,
        configurable: true
    });
    Sorter.prototype.SortBySelectedFunction = function(items) {
        var _this = this;
        var _a;
        var sortingFunction = (_a = this.sorts.find(function(x) {
            return x.label === _this.selected.value;
        })) === null || _a === void 0 ? void 0 : _a.sortFunction;
        if (sortingFunction) return items.sort(sortingFunction);
        else return items;
    };
    return Sorter;
}();
module.exports.Sorter = $380848d711c07323$var$Sorter;

});

parcelRegister("6krno", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RefReflector = void 0;

var $6IcxB = parcelRequire("6IcxB");

var $6wI3m = parcelRequire("6wI3m");
var $49b9d8b12639cf1e$var$RefReflector = /** @class */ function() {
    function RefReflector() {}
    RefReflector.FindAllRefs = function(record) {
        this.refs = [];
        this.FindAllRefsInObject(record);
        return this.refs;
    };
    RefReflector.FindAllRefsInObject = function(obj) {
        var _this = this;
        obj.Keys().forEach(function(k) {
            var v = obj[k];
            if (v instanceof $6wI3m.Ref) _this.refs.push(v);
            else if (v instanceof Object) _this.FindAllRefsInObject(v);
            else if (v instanceof Array) v.forEach(function(item) {
                return _this.FindAllRefsInObject(item);
            });
            else if (v instanceof $6IcxB.Collection) v.Items.forEach(function(item) {
                return _this.FindAllRefsInObject(item);
            });
        });
    };
    RefReflector.refs = [];
    return RefReflector;
}();
module.exports.RefReflector = $49b9d8b12639cf1e$var$RefReflector;

});

parcelRegister("9Fnts", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RefSerializer = void 0;

var $1uOZx = parcelRequire("1uOZx");

var $gSLVI = parcelRequire("gSLVI");
var $709a26e2709195f3$var$RefSerializer = /** @class */ function() {
    function RefSerializer() {}
    RefSerializer.Serialize = function(source) {
        var flat = $gSLVI.RefFlattener.Flat(source);
        return JSON.stringify(flat);
    };
    RefSerializer.Deserialize = function(source, template) {
        var sourceAsObject = JSON.parse(source);
        var target = $1uOZx.RefDeflattener.Deflat(sourceAsObject, template);
        return target;
    };
    RefSerializer.Flatenize = function(source) {
        var flat = $gSLVI.RefFlattener.Flat(source);
        return flat;
    };
    RefSerializer.Deflatenize = function(source, template) {
        var target = $1uOZx.RefDeflattener.Deflat(source, template);
        return target;
    };
    return RefSerializer;
}();
module.exports.RefSerializer = $709a26e2709195f3$var$RefSerializer;

});
parcelRegister("1uOZx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RefDeflattener = void 0;

var $6wI3m = parcelRequire("6wI3m");

var $6IcxB = parcelRequire("6IcxB");

var $k4rJZ = parcelRequire("k4rJZ");

var $9ngW8 = parcelRequire("9ngW8");
var $117025a935c433a7$var$RefDeflattener = /** @class */ function() {
    function RefDeflattener() {}
    RefDeflattener.Deflat = function(source, target, options) {
        if (options === void 0) options = {
            throw: true
        };
        if (target instanceof $6wI3m.Ref) {
            if (target.value instanceof Date) target.value = new Date(source);
            else target.value = source;
        } else if (target instanceof Date) target = new Date(source);
        else if (target instanceof $9ngW8.ArrayTemplate) target = source.map(function(x) {
            return RefDeflattener.Deflat(x, target.CreateFn(), options);
        });
        else if (target instanceof Array) {
            if (target.length != 1) {
                if (options === null || options === void 0 ? void 0 : options.throw) throw new Error("You need to define array type by putting one item into array template (otherwise it won't know to what type deserialize). You can disable this message by setting third parameter of this method to { options.throw: false }");
            }
            if (target[0] instanceof Date) target = source.map(function(x) {
                return new Date(x);
            });
            else if (target[0] instanceof $6wI3m.Ref) {
                if (target[0].value instanceof Date) target = source.map(function(x) {
                    return new $6wI3m.Ref(x);
                });
                else if (typeof target[0].value == "string") target = source.map(function(x) {
                    return new $6wI3m.Ref(x);
                });
                else if (typeof target[0].value == "number") target = source.map(function(x) {
                    return new $6wI3m.Ref(x);
                });
                else if (typeof target[0].value == "boolean") target = source.map(function(x) {
                    return new $6wI3m.Ref(x);
                });
            } else if (target[0] instanceof Object) target = source.map(function(x) {
                return RefDeflattener.Deflat(x, target[0], options);
            });
            else target = source;
        } else if (target instanceof $k4rJZ.CollectionTemplate) target = new $6IcxB.Collection(source.map(function(x) {
            return RefDeflattener.Deflat(x, target.CreateFn(), options);
        }));
        else if (target instanceof $6IcxB.Collection) {
            if (options === null || options === void 0 ? void 0 : options.throw) throw new Error("PLEASE USE CollectionTemplate INSTEAD! This approach will work only for Collection<Ref> or Collection<primitive>, not for Collection<Object>!");
            if (target.Items.length != 1) {
                if (options === null || options === void 0 ? void 0 : options.throw) throw new Error("You need to define collection type by putting one item into collection (otherwise it won't know to what type deserialize). You can disable this message by setting third parameter of this method to { options.throw: false }");
            }
            if (target.Items[0] instanceof $6wI3m.Ref) {
                if (target.Items[0].value instanceof Date) {
                    var items = source.map(function(x) {
                        return new $6wI3m.Ref(x);
                    });
                    target.Load.apply(target, items);
                } else if (typeof target.Items[0].value == "string") {
                    var items = source.map(function(x) {
                        return new $6wI3m.Ref(x);
                    });
                    target.Load.apply(target, items);
                } else if (typeof target.Items[0].value == "number") {
                    var items = source.map(function(x) {
                        return new $6wI3m.Ref(x);
                    });
                    target.Load.apply(target, items);
                } else if (typeof target.Items[0].value == "boolean") {
                    var items = source.map(function(x) {
                        return new $6wI3m.Ref(x);
                    });
                    target.Load.apply(target, items);
                }
            } else if (target.Items[0] instanceof Object) {
                if (options === null || options === void 0 ? void 0 : options.throw) throw new Error("Sorry, but deserializing to Collection<Object> is not possible now. This is due to limitation of Javascript. Target like new Collection([new Foo()]) will always reference to the same Foo for every item of collection. You don't wanna this. You can disable this message by setting third parameter of this method to { options.throw: false }");
            } else {
                var items = source.map(function(x) {
                    if (x instanceof $6wI3m.Ref) return x.value;
                    else return x;
                });
                target.Load.apply(target, items);
            }
        } else if (target instanceof Object) Object.keys(target).forEach(function(k) {
            if (target[k] instanceof Date) target[k] = new Date(source[k]);
            else if (target[k] instanceof $6wI3m.Ref) {
                if (target[k].value instanceof Date) target[k].value = new Date(source[k]);
                else target[k].value = source[k];
            } else if (target[k] instanceof Object) target[k] = RefDeflattener.Deflat(source[k], target[k], options);
            else target[k] = source[k];
        });
        else target = source;
        return target;
    };
    return RefDeflattener;
}();
module.exports.RefDeflattener = $117025a935c433a7$var$RefDeflattener;

});
parcelRegister("k4rJZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CollectionTemplate = void 0;
var $03c55157358e0895$var$CollectionTemplate = /** @class */ function() {
    function CollectionTemplate(CreateFn) {
        this.CreateFn = CreateFn;
    }
    return CollectionTemplate;
}();
module.exports.CollectionTemplate = $03c55157358e0895$var$CollectionTemplate;

});

parcelRegister("9ngW8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ArrayTemplate = void 0;
var $6d33665475ad970d$var$ArrayTemplate = /** @class */ function() {
    function ArrayTemplate(CreateFn) {
        this.CreateFn = CreateFn;
    }
    return ArrayTemplate;
}();
module.exports.ArrayTemplate = $6d33665475ad970d$var$ArrayTemplate;

});


parcelRegister("gSLVI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RefFlattener = void 0;

var $6IcxB = parcelRequire("6IcxB");

var $6wI3m = parcelRequire("6wI3m");

var $9JbVp = parcelRequire("9JbVp");
var $c4a6de63480f73c4$var$RefFlattener = /** @class */ function() {
    function RefFlattener() {}
    RefFlattener.Flat = function(obj) {
        if (obj instanceof $6IcxB.Collection) return this.FlatCollection(obj);
        else if (obj instanceof Array) return this.FlatArray(obj);
        else return this.FlatObject(obj);
    };
    RefFlattener.FlatArray = function(array) {
        var _this = this;
        var flat = [];
        if (array instanceof Array) flat = array.map(function(i) {
            return _this.FlatObject(i);
        });
        return flat;
    };
    RefFlattener.FlatCollection = function(collection) {
        var _this = this;
        var flat = [];
        if (collection instanceof $6IcxB.Collection) flat = collection.Items.map(function(i) {
            return _this.FlatObject(i);
        });
        return flat;
    };
    RefFlattener.IsDateValid = function(date) {
        return !isNaN(date.getTime());
    };
    RefFlattener.FlatObject = function(obj) {
        var _this = this;
        if (obj instanceof $6IcxB.Collection) return this.FlatCollection(obj);
        else if (obj instanceof Array) return this.FlatArray(obj);
        else if (obj instanceof Object) {
            var flat_1 = {};
            obj.Keys().forEach(function(k) {
                var v = obj[k];
                if (v instanceof $6wI3m.Ref && v.value instanceof Date) {
                    if (!_this.IsDateValid(v.value)) throw new Error("Date \"".concat(v.value, "\" is invalid"));
                    flat_1[k] = v.value.toISOString();
                } else if (v instanceof Date) {
                    if (!_this.IsDateValid(v)) throw new Error("Date \"".concat(v, "\" is invalid"));
                    flat_1[k] = v.toISOString();
                } else if (v instanceof $6wI3m.Ref) flat_1[k] = v.value;
                else if (v instanceof $6IcxB.Collection) flat_1[k] = v.Items.map(function(x) {
                    return _this.FlatObject(x);
                });
                else if (v instanceof $9JbVp.RefObject) flat_1[k] = v.object;
                else if (v instanceof Object) flat_1[k] = _this.FlatObject(v);
                else flat_1[k] = v;
            });
            return flat_1;
        } else return obj;
    };
    return RefFlattener;
}();
module.exports.RefFlattener = $c4a6de63480f73c4$var$RefFlattener;

});


parcelRegister("3Z5yA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Filters = void 0;
var $2e6b611460cd984f$var$Filters = /** @class */ function() {
    function Filters() {}
    Filters.TextContains = function(filter, field) {
        if (Array.isArray(field)) return filter.value.trim() ? field.some(function(f) {
            return f.trim().toLowerCase().includes(filter.value.trim().toLowerCase());
        }) : true;
        return filter.value.trim() ? field.trim().toLowerCase().includes(filter.value.trim().toLowerCase()) : true;
    };
    return Filters;
}();
module.exports.Filters = $2e6b611460cd984f$var$Filters;

});

parcelRegister("2UVc2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RegexExtractor = void 0;
var $21fd2d1778928b41$var$RegexExtractor = /** @class */ function() {
    function RegexExtractor(regex) {
        this.regex = regex;
    }
    RegexExtractor.prototype.Extract = function(str) {
        try {
            var m = this.regex.exec(str);
            return (m === null || m === void 0 ? void 0 : m[1]) || "";
        } catch (error) {
            throw new Error(error);
        }
    };
    RegexExtractor.prototype.ExtractAll = function(str) {
        var m;
        var matches = [];
        while((m = this.regex.exec(str)) !== null){
            // This is necessary to avoid infinite loops with zero-width matches
            if (m.index === this.regex.lastIndex) this.regex.lastIndex++;
            // The result can be accessed through the `m`-variable.
            m.forEach(function(match, groupIndex) {
                if (groupIndex === 1) matches.push(match);
            });
        }
        return matches;
    };
    return RegexExtractor;
}();
module.exports.RegexExtractor = $21fd2d1778928b41$var$RegexExtractor;

});

parcelRegister("3CTSE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PatternExtractorV2 = module.exports.PatternExtractor = void 0;
var $2a404462d8fb984c$var$PatternExtractor = /** @class */ function() {
    function PatternExtractor(pattern) {
        this.pattern = pattern;
    }
    PatternExtractor.prototype.Extract = function(url) {
        if (!url) return null;
        if (!this.pattern) return null;
        var urlParts = url.split('/');
        var patternParts = this.pattern.split('/');
        var params = {};
        if (urlParts.length !== patternParts.length) return null;
        for(var i = 0; i < urlParts.length; i++){
            if (patternParts[i].startsWith(':')) {
                var paramName = patternParts[i].substring(1);
                params[paramName] = urlParts[i];
            } else if (urlParts[i] !== patternParts[i]) return null;
        }
        return params;
    };
    return PatternExtractor;
}();
module.exports.PatternExtractor = $2a404462d8fb984c$var$PatternExtractor;
/*
    TO JEST DO DUPY BO ZAWSZE COŚ ZAJDZIE WIĘC NIE NADAJE SIE DO CotentSwitchera!!!!!!!!!
*/ var $2a404462d8fb984c$var$PatternExtractorV2 = /** @class */ function() {
    function PatternExtractorV2(pattern) {
        this.pattern = pattern;
    }
    PatternExtractorV2.prototype.Extract = function(input) {
        var patternSegments = this.pattern.split("/");
        var inputSegments = input.split("/");
        var params = {};
        for(var i = 0; i < patternSegments.length; i++){
            var patternSegment = patternSegments[i];
            var inputSegment = inputSegments[i];
            if (patternSegment.startsWith(":?")) {
                var paramName = patternSegment.substring(2);
                if (paramName != "") params[paramName] = inputSegment || null;
            } else if (patternSegment.startsWith(":")) {
                var paramName = patternSegment.substring(1);
                if (paramName != "") params[paramName] = inputSegment || null;
            }
        }
        return params;
    };
    return PatternExtractorV2;
}();
module.exports.PatternExtractorV2 = $2a404462d8fb984c$var$PatternExtractorV2;

});

parcelRegister("8B6cm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Validator = module.exports.ValidationResult = void 0;

var $afOau = parcelRequire("afOau");

var $6wI3m = parcelRequire("6wI3m");

var $dzlP0 = parcelRequire("dzlP0");
var $64269651993f5a6a$var$ValidationResult = /** @class */ function() {
    function ValidationResult(IsValid, IsNotValid, FirstError) {
        if (IsValid === void 0) IsValid = new $dzlP0.RefBool();
        if (IsNotValid === void 0) IsNotValid = new $dzlP0.RefBool(true);
        if (FirstError === void 0) FirstError = new $6wI3m.Ref("");
        this.IsValid = IsValid;
        this.IsNotValid = IsNotValid;
        this.FirstError = FirstError;
    }
    return ValidationResult;
}();
module.exports.ValidationResult = $64269651993f5a6a$var$ValidationResult;
var $64269651993f5a6a$var$ValidationRule = /** @class */ function() {
    function ValidationRule(predicate, message) {
        this.predicate = predicate;
        this.message = message;
    }
    return ValidationRule;
}();
var $64269651993f5a6a$var$Validator = /** @class */ function() {
    function Validator(valueToValidate, isEnabled) {
        if (isEnabled === void 0) isEnabled = true;
        var _this = this;
        this.valueToValidate = valueToValidate;
        this.isEnabled = isEnabled;
        this.isValid = new $dzlP0.RefBool();
        this.isNotValid = new $dzlP0.RefBool(true);
        this.firstErrorMessage = new $6wI3m.Ref("");
        this.rules = [];
        this.wasInitiallyValidated = false;
        this.valueToValidate.OnChange(function(v) {
            if (_this.isEnabled) _this.Validate();
        });
    }
    Validator.prototype.Enable = function(enable) {
        var _this = this;
        if (enable === void 0) enable = true;
        $afOau.RV.Use(enable, function(v) {
            _this.isEnabled = v;
            if (_this.isEnabled) _this.Validate();
        });
        return this;
    };
    Validator.prototype.Enabled = function() {
        this.isEnabled = true;
        this.Validate();
        return this;
    };
    Validator.prototype.Disabled = function() {
        this.isEnabled = false;
        return this;
    };
    Validator.prototype.Validate = function() {
        for(var _i = 0, _a = this.rules; _i < _a.length; _i++){
            var rule = _a[_i];
            var isValid = rule.predicate(this.valueToValidate.value);
            if (isValid == false) {
                this.firstErrorMessage.value = rule.message;
                this.isValid.value = false;
                this.isNotValid.value = true;
                return this;
            }
        }
        this.firstErrorMessage.value = "";
        this.isValid.value = true;
        this.isNotValid.value = false;
        return this;
    };
    Validator.prototype.MustBeNotEmpty = function(message) {
        if (message === void 0) message = "Value can not be empty";
        this.AddRule(function(v) {
            return !!v;
        }, message);
        return this;
    };
    Validator.prototype.MustBeLowerThan = function(value, message) {
        if (message === void 0) message = "Value must be lower than " + value;
        this.AddRule(function(v) {
            return +v < value;
        }, message);
        return this;
    };
    Validator.prototype.MustBeLowerOrEqualThan = function(value, message) {
        if (message === void 0) message = "Value must be lower or equal to " + value;
        this.AddRule(function(v) {
            return +v <= value;
        }, message);
        return this;
    };
    Validator.prototype.MustBeGraterThan = function(value, message) {
        if (message === void 0) message = "Value must be greater than " + value;
        this.AddRule(function(v) {
            return +v > value;
        }, message);
        return this;
    };
    Validator.prototype.MustBeGraterOrEqualThan = function(value, message) {
        if (message === void 0) message = "Value must be greater or equal to " + value;
        this.AddRule(function(v) {
            return +v >= value;
        }, message);
        return this;
    };
    Validator.prototype.MustBeOneOf = function(options, message) {
        if (message === void 0) message = "Must be ".concat(options.join(" or "));
        this.AddRule(function(v) {
            return options.includes(v);
        }, message);
        return this;
    };
    Validator.prototype.AddRule = function(predicate, messageIfNotValid) {
        this.rules.push(new $64269651993f5a6a$var$ValidationRule(predicate, messageIfNotValid));
        return this;
    };
    Object.defineProperty(Validator.prototype, "IsValid", {
        get: function() {
            return this.Result.IsValid;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Validator.prototype, "IsNotValid", {
        get: function() {
            return this.Result.IsNotValid;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Validator.prototype, "FirstError", {
        get: function() {
            return this.Result.FirstError;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Validator.prototype, "Result", {
        get: function() {
            if (this.wasInitiallyValidated === false && this.isEnabled) {
                this.Validate();
                this.wasInitiallyValidated = true;
            }
            return new $64269651993f5a6a$var$ValidationResult(this.isValid, this.isNotValid, this.firstErrorMessage);
        },
        enumerable: false,
        configurable: true
    });
    return Validator;
}();
module.exports.Validator = $64269651993f5a6a$var$Validator;

});

parcelRegister("iwAjC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RefWatcher = void 0;
var $d7c762a3ad6d7260$var$RefWatcher = /** @class */ function() {
    function RefWatcher() {}
    RefWatcher.Watch = function(refs, doWhenAnyRefChange, callRightaway) {
        if (callRightaway === void 0) callRightaway = true;
        refs.forEach(function(ref) {
            ref.OnChange(function(v) {
                return doWhenAnyRefChange();
            });
        });
        if (callRightaway) doWhenAnyRefChange();
    };
    return RefWatcher;
}();
module.exports.RefWatcher = $d7c762a3ad6d7260$var$RefWatcher;

});

parcelRegister("7mcBr", function(module, exports) {
"use strict";
var $55b45d2339b48f9b$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Root = void 0;

var $iqyiC = parcelRequire("iqyiC");

var $joGvE = parcelRequire("joGvE");
var $55b45d2339b48f9b$var$Root = /** @class */ function(_super) {
    $55b45d2339b48f9b$var$__extends(Root, _super);
    function Root(hook, divClass) {
        if (divClass === void 0) divClass = "";
        var _a;
        var _this = _super.call(this, divClass) || this;
        (_a = (0, $iqyiC.$)(hook !== null && hook !== void 0 ? hook : Root.Hook)) === null || _a === void 0 || _a.Append(_this.Element);
        return _this;
    }
    Root.Hook = "body";
    return Root;
}($joGvE.Div);
module.exports.Root = $55b45d2339b48f9b$var$Root;

});

parcelRegister("gkD0R", function(module, exports) {
"use strict";
var $be3cc6b835bdc563$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Span = void 0;

var $aKtiT = parcelRequire("aKtiT");
var $be3cc6b835bdc563$var$Span = /** @class */ function(_super) {
    $be3cc6b835bdc563$var$__extends(Span, _super);
    function Span(text) {
        var _this = _super.call(this, "span") || this;
        if (text) _this.Text(text);
        return _this;
    }
    Span.Name = "Span";
    return Span;
}($aKtiT.ComponentBase);
module.exports.Span = $be3cc6b835bdc563$var$Span;

});

parcelRegister("aUfnT", function(module, exports) {
"use strict";
var $7f0b115c103f2e8e$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Pre = void 0;

var $aKtiT = parcelRequire("aKtiT");
var $7f0b115c103f2e8e$var$Pre = /** @class */ function(_super) {
    $7f0b115c103f2e8e$var$__extends(Pre, _super);
    function Pre() {
        return _super.call(this, "pre") || this;
    }
    return Pre;
}($aKtiT.ComponentBase);
module.exports.Pre = $7f0b115c103f2e8e$var$Pre;

});

parcelRegister("1h8RE", function(module, exports) {
"use strict";
var $0ede4142b3defe6a$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AutoWidthTwoColumns = void 0;

var $joGvE = parcelRequire("joGvE");
var $0ede4142b3defe6a$var$AutoWidthTwoColumns = /** @class */ function(_super) {
    $0ede4142b3defe6a$var$__extends(AutoWidthTwoColumns, _super);
    function AutoWidthTwoColumns() {
        var _this = _super.call(this, "tf-stretch") || this;
        _this.LeftColumn = new $joGvE.Div("tf-min-width-column");
        _this.RightColumn = new $joGvE.Div("tf-wide-column");
        _this.Append(_this.LeftColumn);
        _this.Append(_this.RightColumn);
        return _this;
    }
    AutoWidthTwoColumns.prototype.Show = function() {
        _super.prototype.Show.call(this, "inline-flex");
        return this;
    };
    return AutoWidthTwoColumns;
}($joGvE.Div);
module.exports.AutoWidthTwoColumns = $0ede4142b3defe6a$var$AutoWidthTwoColumns;

});

parcelRegister("gOMMX", function(module, exports) {
"use strict";
var $c3e7294051227311$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TwinColumns = void 0;

var $joGvE = parcelRequire("joGvE");
var $c3e7294051227311$var$TwinColumns = /** @class */ function(_super) {
    $c3e7294051227311$var$__extends(TwinColumns, _super);
    function TwinColumns() {
        var _this = _super.call(this) || this;
        _this.LeftColumn = new $joGvE.Div().HalfWidth().InlineBlock().Style("vertical-align: top");
        _this.RightColumn = new $joGvE.Div().HalfWidth().InlineBlock().Style("vertical-align: top");
        _this.Append(_this.LeftColumn);
        _this.Append(_this.RightColumn);
        return _this;
    }
    TwinColumns.prototype.AppendToLeft = function() {
        var _a;
        var content = [];
        for(var _i = 0; _i < arguments.length; _i++)content[_i] = arguments[_i];
        (_a = this.LeftColumn).Append.apply(_a, content);
        return this;
    };
    TwinColumns.prototype.AppendToRight = function() {
        var _a;
        var content = [];
        for(var _i = 0; _i < arguments.length; _i++)content[_i] = arguments[_i];
        (_a = this.RightColumn).Append.apply(_a, content);
        return this;
    };
    TwinColumns.prototype.Show = function() {
        _super.prototype.Show.call(this);
        return this;
    };
    return TwinColumns;
}($joGvE.Div);
module.exports.TwinColumns = $c3e7294051227311$var$TwinColumns;

});

parcelRegister("hPtm1", function(module, exports) {
"use strict";
var $cfadf83aa2467e9d$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TwoFloatingColumns = void 0;

var $joGvE = parcelRequire("joGvE");
var $cfadf83aa2467e9d$var$TwoFloatingColumns = /** @class */ function(_super) {
    $cfadf83aa2467e9d$var$__extends(TwoFloatingColumns, _super);
    function TwoFloatingColumns() {
        var _this = _super.call(this) || this;
        _this.LeftColumn = new $joGvE.Div() //.Style("border: 3px dotted green")
        .FloatLeft(); //.Background("lightblue")
        _this.RightColumn = new $joGvE.Div() //.Style("border: 3px dotted blue")
        .FloatLeft(); //.Border(1, "lightyellow")
        _this.ClearBoth();
        _this.Append(_this.LeftColumn);
        _this.Append(_this.RightColumn);
        return _this;
    }
    TwoFloatingColumns.prototype.Show = function() {
        _super.prototype.Show.call(this);
        return this;
    };
    return TwoFloatingColumns;
}($joGvE.Div);
module.exports.TwoFloatingColumns = $cfadf83aa2467e9d$var$TwoFloatingColumns;

});

parcelRegister("2S24U", function(module, exports) {
"use strict";
var $21723c9d67724d86$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Button = void 0;

var $aKtiT = parcelRequire("aKtiT");

var $6wI3m = parcelRequire("6wI3m");
var $21723c9d67724d86$var$Button = /** @class */ function(_super) {
    $21723c9d67724d86$var$__extends(Button, _super);
    function Button(label, onClick) {
        if (label === void 0) label = "Button";
        var _this = _super.call(this, "button") || this;
        _this.label = label;
        _this.InitialLabel = "";
        if (label instanceof $6wI3m.Ref) _this.InitialLabel = label.value;
        else _this.InitialLabel = label;
        _this.Class(Button.DefaultCssClasses);
        if (onClick) _this.OnClick(function() {
            return onClick(_this);
        });
        _this.Label(_this.label);
        return _this;
    }
    Button.prototype.Label = function(label, transform) {
        var _this = this;
        this.React(label, function(v) {
            return _this.element.innerHTML = transform ? transform(v) : v.toString();
        });
        return this;
    };
    Button.prototype.RestoreInitialLabel = function() {
        return this.Label(this.InitialLabel);
    };
    Button.Name = "Button";
    Button.DefaultCssClasses = "";
    return Button;
}($aKtiT.ComponentBase);
module.exports.Button = $21723c9d67724d86$var$Button;

});

parcelRegister("5PIlt", function(module, exports) {
"use strict";
var $43f41d38fca657e1$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Link = void 0;

var $2s69t = parcelRequire("2s69t");
var $43f41d38fca657e1$var$Link = /** @class */ function(_super) {
    $43f41d38fca657e1$var$__extends(Link, _super);
    function Link(label, url, openInNewCard) {
        if (openInNewCard === void 0) openInNewCard = false;
        var _this = _super.call(this, "a") || this;
        _this.React(label, function(v) {
            return _this.Label(v);
        });
        _this.React(url, function(v) {
            return _this.Url(v);
        });
        if (url === undefined && typeof label === "string" && label.startsWith("http")) _this.Url(label);
        if (openInNewCard) _this.OpenInNewCard();
        return _this;
    }
    Link.prototype.Label = function(label) {
        this.Text(label);
        return this;
    };
    Link.prototype.Url = function(url) {
        this.Attribute("href", url);
        return this;
    };
    Link.prototype.OpenInNewCard = function() {
        this.Attribute("target", "_blank");
        return this;
    };
    Link.prototype.DoNotOpenInNewCard = function() {
        this.RemoveAttribute("target");
        return this;
    };
    Link.prototype.NoDecorationOnHover = function() {
        this.Style("text-decoration: none");
        return this;
    };
    Link.Name = "Link";
    return Link;
}($2s69t.ComponentBase);
module.exports.Link = $43f41d38fca657e1$var$Link;

});

parcelRegister("eONQW", function(module, exports) {
"use strict";
var $ac9c67f290a10e7d$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Image = void 0;

var $aKtiT = parcelRequire("aKtiT");

var $8PO3e = parcelRequire("8PO3e");

var $d5iKF = parcelRequire("d5iKF");

var $CJCrq = parcelRequire("CJCrq");
var $ac9c67f290a10e7d$var$Image = /** @class */ function(_super) {
    $ac9c67f290a10e7d$var$__extends(Image, _super);
    function Image(src, alt) {
        var _this = _super.call(this, "img") || this;
        _this.Info = new $d5iKF.ImageInfo(); // Do not use directly! Use OnInfoReady event instead
        _this.OnInfoReady = new $8PO3e.HandlersCollection();
        _this.blobUrl = "";
        _this.busy = false;
        if (src instanceof Blob) _this.FromBlob(src);
        else if (src) _this.React(src, function(v) {
            return v && _this.Src(v);
        });
        if (alt) _this.React(alt, function(v) {
            return _this.Alt(v);
        });
        _this.element.onload = function() {
            _this.Info.Width = _this.element.naturalWidth;
            _this.Info.Height = _this.element.naturalHeight;
            _this.OnInfoReady.Call(_this.Info);
            if (_this.Info.LoadMethod == $CJCrq.ImageSource.Blob) URL.revokeObjectURL(_this.blobUrl); // For memory clean up
            _this.busy = false;
        };
        return _this;
    }
    Image.prototype.FromBlob = function(blob) {
        if (this.busy) return this;
        this.busy = true;
        this.blobUrl = URL.createObjectURL(blob);
        this.Attribute("src", this.blobUrl);
        this.Info.LoadMethod = $CJCrq.ImageSource.Blob;
        this.Info.Size = blob.size;
        return this;
    };
    Image.prototype.Src = function(src) {
        if (!src) return this;
        if (this.busy) return this;
        this.busy = true;
        this.Attribute("src", src);
        this.Info.LoadMethod = $CJCrq.ImageSource.Http;
        this.Info.Size = -1;
        return this;
    };
    Image.prototype.GetAlt = function() {
        var _a;
        return (_a = this.GetAttribute("alt")) !== null && _a !== void 0 ? _a : "";
    };
    Object.defineProperty(Image.prototype, "IsEmpty", {
        get: function() {
            return this.GetAttribute("src") === "";
        },
        enumerable: false,
        configurable: true
    });
    Image.prototype.FromBase64 = function(base64) {
        if (!base64) return this;
        if (this.busy) return this;
        this.busy = true;
        var base64prefix = "data:image/png;base64,";
        if (!base64.startsWith(base64prefix)) base64 = base64prefix + base64;
        this.Attribute("src", base64);
        this.Info.LoadMethod = $CJCrq.ImageSource.Base64;
        this.Info.Size = this.Base64Size;
        return this;
    };
    Object.defineProperty(Image.prototype, "IsBase64", {
        get: function() {
            var _a, _b;
            return (_b = (_a = this.GetAttribute("src")) === null || _a === void 0 ? void 0 : _a.startsWith("data:image")) !== null && _b !== void 0 ? _b : false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Image.prototype, "IsHttp", {
        get: function() {
            var _a, _b;
            return (_b = (_a = this.GetAttribute("src")) === null || _a === void 0 ? void 0 : _a.startsWith("http")) !== null && _b !== void 0 ? _b : false;
        },
        enumerable: false,
        configurable: true
    });
    Image.prototype.Load = function(source) {
        if (source instanceof Blob) this.FromBlob(source);
        else if (this.IsHttp) this.Src(source);
        else if (this.IsBase64) this.FromBase64(source);
        return this;
    };
    Image.prototype.Alt = function(description) {
        if (description) this.Attribute("alt", description);
        return this;
    };
    Image.prototype.ObjectPosition = function(xAxis, yAxis) {
        var _this = this;
        this.React(xAxis, function(x) {
            return _this.Style("object-position", "".concat(x, "% ").concat(yAxis.value, "%"));
        });
        this.React(yAxis, function(y) {
            return _this.Style("object-position", "".concat(xAxis.value, "% ").concat(y, "%"));
        });
        return this;
    };
    Image.prototype.ObjectFit = function(fit) {
        var _this = this;
        this.React(fit, function(x) {
            return _this.Style("object-fit", x);
        });
        return this;
    };
    Object.defineProperty(Image.prototype, "SourceInfo", {
        get: function() {
            var src = this.GetAttribute("src");
            if (!src) return $CJCrq.ImageSource.Unset;
            if (src.startsWith("http")) return $CJCrq.ImageSource.Http;
            if (src.startsWith("data:image")) return $CJCrq.ImageSource.Base64;
            return $CJCrq.ImageSource.Unset;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Image.prototype, "Base64Size", {
        get: function() {
            var base64 = this.GetAttribute("src");
            var size = base64.length * (3 / 4);
            return Number(size);
        },
        enumerable: false,
        configurable: true
    });
    Image.Name = "Image";
    return Image;
}($aKtiT.ComponentBase);
module.exports.Image = $ac9c67f290a10e7d$var$Image;

});
parcelRegister("d5iKF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ImageInfo = void 0;

var $CJCrq = parcelRequire("CJCrq");
var $986a49b1f35547d3$var$ImageInfo = /** @class */ function() {
    function ImageInfo() {
        this.Width = 0;
        this.Height = 0;
        this.Size = 0;
        this.LoadMethod = $CJCrq.ImageSource.Unset;
    }
    Object.defineProperty(ImageInfo.prototype, "AsString", {
        get: function() {
            return "".concat(this.Width, "\u00D7").concat(this.Height, "px, ").concat((this.Size / 1024).toFixed(1), "kb");
        },
        enumerable: false,
        configurable: true
    });
    return ImageInfo;
}();
module.exports.ImageInfo = $986a49b1f35547d3$var$ImageInfo;

});
parcelRegister("CJCrq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ImageSource = void 0;
var $0746efb636b3d380$var$ImageSource;
(function(ImageSource) {
    ImageSource["Unset"] = "Unset";
    ImageSource["Http"] = "http";
    ImageSource["Base64"] = "base64";
    ImageSource["Blob"] = "blob";
})($0746efb636b3d380$var$ImageSource || (module.exports.ImageSource = $0746efb636b3d380$var$ImageSource = {}));

});



parcelRegister("iuQir", function(module, exports) {
"use strict";
var $d7739854c757ee07$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $d7739854c757ee07$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $d7739854c757ee07$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Canvas = void 0;

var $2s69t = parcelRequire("2s69t");
var $d7739854c757ee07$var$Canvas = /** @class */ function(_super) {
    $d7739854c757ee07$var$__extends(Canvas, _super);
    function Canvas() {
        var _this = _super.call(this, "canvas") || this;
        _this.busy = false;
        return _this;
    }
    Object.defineProperty(Canvas.prototype, "Context", {
        get: function() {
            var context = this.element.getContext("2d", {
                alpha: false,
                desynchronized: true
            });
            if (!context) throw new Error("Failed to get context");
            context.imageSmoothingEnabled = false;
            return context;
        },
        enumerable: false,
        configurable: true
    });
    Canvas.prototype.Draw = function(picture) {
        return $d7739854c757ee07$var$__awaiter(this, void 0, void 0, function() {
            var bitmap;
            return $d7739854c757ee07$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this.busy) return [
                            2 /*return*/ 
                        ];
                        this.busy = true;
                        return [
                            4 /*yield*/ ,
                            createImageBitmap(picture)
                        ];
                    case 1:
                        bitmap = _a.sent();
                        this.Context.clearRect(0, 0, bitmap.width, bitmap.height);
                        this.element.width = bitmap.width;
                        this.element.height = bitmap.height;
                        this.Context.drawImage(bitmap, 0, 0);
                        bitmap.close();
                        this.busy = false;
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    Canvas.Name = "Canvas";
    return Canvas;
}($2s69t.ComponentBase);
module.exports.Canvas = $d7739854c757ee07$var$Canvas;

});

parcelRegister("8a2qt", function(module, exports) {
"use strict";
var $5f1123a90b240cf7$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ClickableImage = void 0;

var $aKtiT = parcelRequire("aKtiT");

var $eONQW = parcelRequire("eONQW");
var $5f1123a90b240cf7$var$ClickableImage = /** @class */ function(_super) {
    $5f1123a90b240cf7$var$__extends(ClickableImage, _super);
    function ClickableImage(src, url, alt) {
        var _this = _super.call(this, "a") || this;
        _this.CursorPointer();
        _this.image = new $eONQW.Image(src);
        _this.Append(_this.image);
        if (url) _this.Url(url);
        if (alt) _this.Alt(alt);
        return _this;
    }
    ClickableImage.prototype.Src = function(src) {
        return this.Attribute("src", src);
    };
    ClickableImage.prototype.Url = function(url) {
        return this.Attribute("href", url);
    };
    ClickableImage.prototype.Alt = function(description) {
        return this.Attribute("alt", description);
    };
    ClickableImage.Name = "ClickableImage";
    return ClickableImage;
}($aKtiT.ComponentBase);
module.exports.ClickableImage = $5f1123a90b240cf7$var$ClickableImage;

});

parcelRegister("gyVEa", function(module, exports) {
"use strict";
var $c0ec89c624c3e597$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NewLine = void 0;

var $aKtiT = parcelRequire("aKtiT");
var $c0ec89c624c3e597$var$NewLine = /** @class */ function(_super) {
    $c0ec89c624c3e597$var$__extends(NewLine, _super);
    function NewLine() {
        return _super.call(this, "br") || this;
    }
    return NewLine;
}($aKtiT.ComponentBase);
module.exports.NewLine = $c0ec89c624c3e597$var$NewLine;

});

parcelRegister("gwSD4", function(module, exports) {
"use strict";
var $c08a02bb9f008e92$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Line = void 0;

var $aKtiT = parcelRequire("aKtiT");
var $c08a02bb9f008e92$var$Line = /** @class */ function(_super) {
    $c08a02bb9f008e92$var$__extends(Line, _super);
    function Line() {
        var _this = _super.call(this, "hr") || this;
        _this.ClearBoth();
        return _this;
    }
    return Line;
}($aKtiT.ComponentBase);
module.exports.Line = $c08a02bb9f008e92$var$Line;

});

parcelRegister("bQA5y", function(module, exports) {
"use strict";
var $8a008b807e25ba4c$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Paragraph = void 0;

var $aKtiT = parcelRequire("aKtiT");
var $8a008b807e25ba4c$var$Paragraph = /** @class */ function(_super) {
    $8a008b807e25ba4c$var$__extends(Paragraph, _super);
    function Paragraph(klass) {
        var _this = _super.call(this, "p") || this;
        _this.Class(klass);
        return _this;
    }
    return Paragraph;
}($aKtiT.ComponentBase);
module.exports.Paragraph = $8a008b807e25ba4c$var$Paragraph;

});

parcelRegister("8fPhC", function(module, exports) {
"use strict";
var $6027813168e64ccb$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UnorderedList = void 0;

var $2s69t = parcelRequire("2s69t");

var $2MZa4 = parcelRequire("2MZa4");
var $6027813168e64ccb$var$UnorderedList = /** @class */ function(_super) {
    $6027813168e64ccb$var$__extends(UnorderedList, _super);
    function UnorderedList(initialItems) {
        var _this = _super.call(this, "ul") || this;
        if (initialItems && initialItems instanceof Array) _this.LoadItems(initialItems);
        if (initialItems && initialItems instanceof $2s69t.Collection) initialItems.OnChange(function(items) {
            return _this.LoadItems(items);
        });
        return _this;
    }
    UnorderedList.prototype.Add = function(item) {
        this.Append(new $2MZa4.ListItem(item));
        return this;
    };
    UnorderedList.prototype.LoadItems = function(items) {
        var _this = this;
        this.Clear();
        items.forEach(function(i) {
            return _this.Add(i);
        });
        return this;
    };
    UnorderedList.Name = "UnorderedList";
    return UnorderedList;
}($2s69t.ComponentBase);
module.exports.UnorderedList = $6027813168e64ccb$var$UnorderedList;

});
parcelRegister("2MZa4", function(module, exports) {
"use strict";
var $207f81d6353d7e92$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ListItem = void 0;

var $aKtiT = parcelRequire("aKtiT");
var $207f81d6353d7e92$var$ListItem = /** @class */ function(_super) {
    $207f81d6353d7e92$var$__extends(ListItem, _super);
    function ListItem(item) {
        var _this = _super.call(this, "li") || this;
        _this.Append(item);
        return _this;
    }
    return ListItem;
}($aKtiT.ComponentBase);
module.exports.ListItem = $207f81d6353d7e92$var$ListItem;

});


parcelRegister("2yjo2", function(module, exports) {
"use strict";
var $1dbdcb8929a6339d$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OrderedList = void 0;

var $2s69t = parcelRequire("2s69t");

var $2MZa4 = parcelRequire("2MZa4");
var $1dbdcb8929a6339d$var$OrderedList = /** @class */ function(_super) {
    $1dbdcb8929a6339d$var$__extends(OrderedList, _super);
    function OrderedList(initialItems, type) {
        if (type === void 0) type = "1";
        var _this = _super.call(this, "ol") || this;
        _this.Attribute("type", type);
        if (initialItems) _this.LoadItems(initialItems);
        return _this;
    }
    OrderedList.prototype.Add = function(item) {
        this.Append(new $2MZa4.ListItem(item));
        return this;
    };
    OrderedList.prototype.LoadItems = function(items) {
        var _this = this;
        this.Clear();
        items.forEach(function(i) {
            return _this.Add(i);
        });
        return this;
    };
    OrderedList.Name = "OrderedList";
    return OrderedList;
}($2s69t.ComponentBase);
module.exports.OrderedList = $1dbdcb8929a6339d$var$OrderedList;

});

parcelRegister("9ewxt", function(module, exports) {
"use strict";
var $6b8ea9689e3c7664$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CollectionViewer = void 0;

var $joGvE = parcelRequire("joGvE");
var $6b8ea9689e3c7664$var$CollectionViewer = /** @class */ function(_super) {
    $6b8ea9689e3c7664$var$__extends(CollectionViewer, _super);
    function CollectionViewer(collection) {
        var _this = _super.call(this) || this;
        collection.OnChange(function(v) {
            _this.Clear().Append(JSON.stringify(v));
        }, true);
        return _this;
    }
    return CollectionViewer;
}($joGvE.Div);
module.exports.CollectionViewer = $6b8ea9689e3c7664$var$CollectionViewer;

});

parcelRegister("4TgXd", function(module, exports) {
"use strict";
var $38f97332e8486431$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CollectionPrinter = void 0;

var $6IcxB = parcelRequire("6IcxB");

var $8y6Fd = parcelRequire("8y6Fd");

var $joGvE = parcelRequire("joGvE");
var $38f97332e8486431$var$CollectionPrinter = /** @class */ function(_super) {
    $38f97332e8486431$var$__extends(CollectionPrinter, _super);
    function CollectionPrinter(data, itemPrinter, options) {
        if (options === void 0) options = {};
        var _this = _super.call(this) || this;
        if (data && data instanceof $6IcxB.Collection) data = new $8y6Fd.CollectionView(data).Refresh();
        data.OnChange(function(items) {
            _this.Clear();
            if (options.reverse == true) _this.Prepend.apply(_this, items.map(function(item) {
                return itemPrinter(item);
            }));
            else _this.Append.apply(_this, items.map(function(item) {
                return itemPrinter(item);
            }));
        }, true);
        return _this;
    }
    return CollectionPrinter;
}($joGvE.Div);
module.exports.CollectionPrinter = $38f97332e8486431$var$CollectionPrinter;

});

parcelRegister("8UMl5", function(module, exports) {
"use strict";
var $67d90cd94994eb0c$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $67d90cd94994eb0c$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $67d90cd94994eb0c$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CopyIcon = void 0;

var $dv39x = parcelRequire("dv39x");
/*
    NIE WIEM O CO KAMAN ALE KIEDY TA KLASA DZIEDZICZY PO Link TO DOSTAJE:
    Cannot access 'Link' before initialization
    CO CIEKAWE KIEDY ZADEKLARUJE SIE TE KLASE ZARAZ POD Link (W PLIKU Link.ts) TO WSZYSTKO DZIAŁA!
    LUB KIEDY ZROBI SIĘ DOKŁADNĄ KOPIE Link I TYLKO INACZEJ NAZWIE TO TEŻ DZIAŁA!
    ŻADNE CZYSZCZENIE, ZMIENIANIE IMPORTÓW, REINSTALACJA NARZĘDZI NIE POMAGA. NIE WIEM O CO CHODZI :(
*/ var $67d90cd94994eb0c$var$CopyIcon = /** @class */ function(_super) {
    $67d90cd94994eb0c$var$__extends(CopyIcon, _super); // 'extends A' because when trying to 'extend Link' it throws 'Cannot access 'Link' before initialization', which does not make sense!!!
    function CopyIcon(value, icon) {
        if (icon === void 0) icon = "\uD83D\uDCCB";
        var _this = _super.call(this, icon) || this;
        _this.MarginLeft(8).OnClick(function() {
            return $67d90cd94994eb0c$var$__awaiter(_this, void 0, void 0, function() {
                return $67d90cd94994eb0c$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.CopyToClipboard(value)
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        });
        return _this;
    }
    CopyIcon.prototype.CopyToClipboard = function(textToCopy) {
        // navigator clipboard api needs a secure context (https)
        if (navigator.clipboard && window.isSecureContext) return new Promise(function(res, rej) {
            // navigator clipboard api method'
            navigator.clipboard.writeText(textToCopy);
            res("Success");
        });
        else {
            // text area method
            var textArea_1 = document.createElement("textarea");
            textArea_1.value = textToCopy;
            // make the textarea out of viewport
            textArea_1.style.position = "fixed";
            textArea_1.style.left = "-999999px";
            textArea_1.style.top = "-999999px";
            document.body.appendChild(textArea_1);
            textArea_1.focus();
            textArea_1.select();
            return new Promise(function(res, rej) {
                // here the magic happens
                document.execCommand('copy') ? res("Copy to clipboard succeeded") : rej("Copy to clipboard failed");
                textArea_1.remove();
            });
        }
    };
    return CopyIcon;
}($dv39x.A // 'extends A' because when trying to 'extend Link' it throws 'Cannot access 'Link' before initialization', which does not make sense!!!
);
module.exports.CopyIcon = $67d90cd94994eb0c$var$CopyIcon;

});
parcelRegister("dv39x", function(module, exports) {
"use strict";
var $9d409db7c74604f2$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.A = void 0;

var $2s69t = parcelRequire("2s69t");
var $9d409db7c74604f2$var$A = /** @class */ function(_super) {
    $9d409db7c74604f2$var$__extends(A, _super);
    function A(label) {
        var _this = _super.call(this, "a") || this;
        _this.Text(label);
        return _this;
    }
    A.Name = "A";
    return A;
}($2s69t.ComponentBase);
module.exports.A = $9d409db7c74604f2$var$A;

});


parcelRegister("7LfyP", function(module, exports) {
"use strict";
var $5a68fe3a0b69bef6$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Tabs = void 0;

var $2s69t = parcelRequire("2s69t");

var $gYRyj = parcelRequire("gYRyj");
var $5a68fe3a0b69bef6$var$Tabs = /** @class */ function(_super) {
    $5a68fe3a0b69bef6$var$__extends(Tabs, _super);
    function Tabs(ref) {
        if (ref === void 0) ref = new $2s69t.Ref("");
        var _this = _super.call(this) || this;
        _this.ref = ref;
        _this.switches = new $gYRyj.TabsSwitcher(_this.ref);
        _this.content = new $2s69t.DestroyingContentSwitcher(_this.ref);
        _this.Append(_this.switches, _this.content);
        return _this;
    }
    Tabs.prototype.Add = function(label, content) {
        this.switches.Add(label);
        this.content.AddContent(label, content);
        return this;
    };
    Tabs.Name = "Tabs";
    return Tabs;
}($2s69t.Div);
module.exports.Tabs = $5a68fe3a0b69bef6$var$Tabs;

});
parcelRegister("gYRyj", function(module, exports) {
"use strict";
var $c5cbca57d8bc3bdc$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TabsSwitcher = void 0;

var $2s69t = parcelRequire("2s69t");
var $c5cbca57d8bc3bdc$var$TabsSwitcher = /** @class */ function(_super) {
    $c5cbca57d8bc3bdc$var$__extends(TabsSwitcher, _super);
    function TabsSwitcher(ref) {
        var _this = _super.call(this, "ul", ref) || this;
        _this.switches = {};
        _this.Attribute("uk-tab");
        _this.Class("uk-tab");
        return _this;
    }
    TabsSwitcher.prototype.Refresh = function() {
        var _this = this;
        this.switches.Keys().forEach(function(activator) {
            var cmp = _this.switches[activator];
            if (_this.ref.value === activator) cmp.AddClass("uk-active");
            else cmp.RemoveClass("uk-active");
        });
    };
    TabsSwitcher.prototype.Add = function(label) {
        var _this = this;
        var item = new $2s69t.ListItem(new $2s69t.Link(label, "#"));
        this.switches[label] = item;
        item.OnClick(function() {
            return _this.ref.value = label;
        });
        if (this.ref.value == label) item.AddClass("uk-active");
        if (this.ref.value == "") this.ref.value = label;
        this.Append(item);
        return this;
    };
    TabsSwitcher.Name = "TabsSwitcher";
    return TabsSwitcher;
}($2s69t.RefComponentBase);
module.exports.TabsSwitcher = $c5cbca57d8bc3bdc$var$TabsSwitcher;

});


parcelRegister("hIO35", function(module, exports) {
"use strict";
var $ce6d5e5be4be20de$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NonRefEditableLabel = module.exports.EditableLabel = void 0;

var $aKtiT = parcelRequire("aKtiT");

var $gkD0R = parcelRequire("gkD0R");

var $3B1VX = parcelRequire("3B1VX");

var $etGN3 = parcelRequire("etGN3");
var $ce6d5e5be4be20de$var$EditableLabel = /** @class */ function(_super) {
    $ce6d5e5be4be20de$var$__extends(EditableLabel, _super);
    function EditableLabel(ref) {
        var _this = _super.call(this, "div") || this;
        _this.ref = ref;
        _this.valueBeforeEdit = "";
        _this.label = new $3B1VX.Text(ref).CursorPointer().Show().OnClick(function() {
            _this.EditMode();
        });
        _this.textInput = new $etGN3.TextInput(ref);
        _this.textInput.OnBlur(function() {
            return _this.EndOfEdit();
        }).OnEnterKeyPressed(function() {
            return _this.EndOfEdit();
        }).Hide();
        _this.Append(_this.label);
        _this.Append(_this.textInput);
        return _this;
    }
    EditableLabel.prototype.EditMode = function() {
        this.valueBeforeEdit = this.ref.value;
        var labelWidth = getComputedStyle(this.label.Element).width;
        var w = +labelWidth.replace("px", "");
        if (w < 100) w += 32;
        this.label.Hide();
        this.textInput.Show().Width(w).Padding(2, 6).Focus();
    };
    Object.defineProperty(EditableLabel.prototype, "IsEditMode", {
        get: function() {
            return this.textInput.IsVisible();
        },
        enumerable: false,
        configurable: true
    });
    EditableLabel.prototype.ToggleEditMode = function() {
        if (this.IsEditMode) this.CloseEditMode();
        else this.EditMode();
        return this;
    };
    EditableLabel.prototype.OpenEditMode = function() {
        this.EditMode();
        return this;
    };
    EditableLabel.prototype.CloseEditMode = function() {
        this.EndOfEdit();
        return this;
    };
    EditableLabel.prototype.LabelConfig = function(config) {
        config(this.label);
        return this;
    };
    EditableLabel.prototype.TextInputConfig = function(config) {
        config(this.textInput);
        return this;
    };
    EditableLabel.prototype.OnEditEnd = function(callback) {
        this.editEnd = callback;
        return this;
    };
    EditableLabel.prototype.EndOfEdit = function() {
        var _a;
        if (!this.textInput.IsVisible()) return; // To prevent double call
        this.textInput.Hide();
        this.label.Show();
        (_a = this.editEnd) === null || _a === void 0 || _a.call(this, this.valueBeforeEdit, this.ref.value);
    };
    EditableLabel.prototype.DefaultText = function(text) {
        this.label.DefaultText(text);
        return this;
    };
    EditableLabel.prototype.Placeholder = function(placeholder) {
        this.textInput.Placeholder(placeholder);
        return this;
    };
    EditableLabel.prototype.Style = function(prop, val) {
        this.label.Style(prop, val);
        this.textInput.Style(prop, val);
        return this;
    };
    EditableLabel.Name = "EditableLabel";
    return EditableLabel;
}($aKtiT.ComponentBase);
module.exports.EditableLabel = $ce6d5e5be4be20de$var$EditableLabel;
var $ce6d5e5be4be20de$var$NonRefEditableLabel = /** @class */ function(_super) {
    $ce6d5e5be4be20de$var$__extends(NonRefEditableLabel, _super);
    function NonRefEditableLabel(value, onChange) {
        var _this = _super.call(this, "div") || this;
        _this.value = "";
        _this.label = new $gkD0R.Span(value);
        _this.label.Show().OnClick(function() {
            var labelWidth = getComputedStyle(_this.label.Element).width;
            var w = +labelWidth.replace("px", "");
            if (w < 100) w += 20;
            _this.label.Hide();
            _this.textInput.Show().Width(w).Padding(2, 6).Focus();
        });
        _this.textInput = new $etGN3.NonRefTextInput(value, function(v) {
            _this.value = v;
            onChange(v);
        });
        _this.textInput.OnBlur(function() {
            _this.textInput.Hide();
            _this.label.Show();
            _this.label.Text(_this.value);
        }).OnEnterKeyPressed(function() {
            _this.textInput.Hide();
            _this.label.Show();
            _this.label.Text(_this.value);
        }).Hide();
        _this.Append(_this.label);
        _this.Append(_this.textInput);
        return _this;
    }
    NonRefEditableLabel.prototype.Placeholder = function(placeholder) {
        this.textInput.Placeholder(placeholder);
        return this;
    };
    NonRefEditableLabel.prototype.Style = function(prop, val) {
        this.label.Style(prop, val);
        this.textInput.Style(prop, val);
        return this;
    };
    return NonRefEditableLabel;
}($aKtiT.ComponentBase);
module.exports.NonRefEditableLabel = $ce6d5e5be4be20de$var$NonRefEditableLabel;

});
parcelRegister("etGN3", function(module, exports) {
"use strict";
var $a8a4f76189473a77$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NonRefTextInput = module.exports.TextInput = void 0;

var $aKtiT = parcelRequire("aKtiT");

var $6wI3m = parcelRequire("6wI3m");

var $k6KGm = parcelRequire("k6KGm");

var $8PO3e = parcelRequire("8PO3e");
var $a8a4f76189473a77$var$TextInput = /** @class */ function(_super) {
    $a8a4f76189473a77$var$__extends(TextInput, _super);
    function TextInput(ref) {
        if (ref === void 0) ref = new $6wI3m.Ref("");
        var _this = _super.call(this, "input", ref) || this;
        _this.onChange = new $8PO3e.HandlersCollection();
        _this.Class(TextInput.DefaultCssClasses);
        _this.element.addEventListener('input', function(e) {
            _this.ref.value = e.target.value;
            _this.onChange.Call(_this.ref.value, e);
        });
        _this.Refresh();
        return _this;
    }
    TextInput.prototype.Placeholder = function(placeholderText) {
        var _this = this;
        if (placeholderText) this.React(placeholderText, function(v) {
            return _this.element.setAttribute("placeholder", v);
        });
        return this;
    };
    TextInput.prototype.OnChange = function(handler) {
        this.onChange.Add(handler);
        return this;
    };
    TextInput.prototype.Refresh = function() {
        this.element.value = this.ref.value;
        if (this.showThatChanged) this.ref.HasChanged ? this.element.classList.add("tf-value-changed") : this.element.classList.remove("tf-value-changed");
    };
    TextInput.Name = "TextInput";
    TextInput.DefaultCssClasses = "";
    return TextInput;
}($k6KGm.RefComponentBase);
module.exports.TextInput = $a8a4f76189473a77$var$TextInput;
var $a8a4f76189473a77$var$NonRefTextInput = /** @class */ function(_super) {
    $a8a4f76189473a77$var$__extends(NonRefTextInput, _super);
    function NonRefTextInput(value, onChange) {
        var _this = _super.call(this, "input") || this;
        _this.value = value;
        _this.Class($a8a4f76189473a77$var$TextInput.DefaultCssClasses);
        _this.element.addEventListener('input', function(e) {
            // this.ref.SetValue(e.target.value, this);
            onChange(e.target.value);
        });
        _this.Refresh();
        return _this;
    }
    NonRefTextInput.prototype.Placeholder = function(placeholder) {
        this.element.setAttribute("placeholder", placeholder);
        return this;
    };
    NonRefTextInput.prototype.Refresh = function() {
        this.element.value = this.value;
    // if (this.showThatChanged)
    //     this.ref.HasChanged
    //         ? this.element.classList.add("tf-value-changed")
    //         : this.element.classList.remove("tf-value-changed");
    };
    NonRefTextInput.DefaultCssClasses = "";
    return NonRefTextInput;
}($aKtiT.ComponentBase);
module.exports.NonRefTextInput = $a8a4f76189473a77$var$NonRefTextInput;

});


parcelRegister("jCElc", function(module, exports) {
"use strict";
var $e490dbcb2c83c831$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PasswordInput = void 0;

var $6wI3m = parcelRequire("6wI3m");

var $joGvE = parcelRequire("joGvE");

var $gkD0R = parcelRequire("gkD0R");

var $etGN3 = parcelRequire("etGN3");
var $e490dbcb2c83c831$var$PasswordInput = /** @class */ function(_super) {
    $e490dbcb2c83c831$var$__extends(PasswordInput, _super);
    function PasswordInput(passwordRef) {
        if (passwordRef === void 0) passwordRef = new $6wI3m.Ref("");
        var _this = _super.call(this, "") || this;
        _this.passwordRef = passwordRef;
        _this.showPasswordBtn = new $gkD0R.Span("\uD83D\uDC40").PositionAbsolute().Top(8).Right(6).Opacity(0.5).CursorPointer().Hide();
        _this.PositionRelative();
        _this.passwordInput = new $etGN3.TextInput(_this.passwordRef).Class($etGN3.TextInput.DefaultCssClasses).Attribute("type", "password");
        _this.Append(_this.passwordInput, _this.showPasswordBtn);
        return _this;
    }
    PasswordInput.prototype.SetupInput = function(setup) {
        setup(this.passwordInput);
        return this;
    };
    PasswordInput.prototype.SetupButton = function(setup) {
        setup(this.showPasswordBtn);
        return this;
    };
    PasswordInput.prototype.StyleInput = function(style) {
        this.passwordInput.Style(style);
        return this;
    };
    PasswordInput.prototype.StyleButton = function(style) {
        this.showPasswordBtn.Style(style);
        return this;
    };
    PasswordInput.prototype.ShowPasswordOnTouch = function() {
        var _this = this;
        this.showPasswordBtn.Show();
        this.showPasswordBtn.On([
            'mousedown',
            'touchstart'
        ], function() {
            _this.passwordInput.Attribute("type", "text");
            _this.showPasswordBtn.Opacity(1);
        }).On([
            'mouseup',
            'touchend'
        ], function() {
            _this.passwordInput.Attribute("type", "password");
            _this.showPasswordBtn.Opacity(0.5);
        });
        return this;
    };
    PasswordInput.prototype.TogglePasswordView = function() {
        var _this = this;
        this.showPasswordBtn.Show();
        var passwordVisible = new $6wI3m.Ref(false);
        this.showPasswordBtn.OnClick(function() {
            passwordVisible.value = !passwordVisible.value;
            _this.passwordInput.Attribute("type", passwordVisible.value ? "text" : "password");
            _this.showPasswordBtn.Opacity(passwordVisible.value ? 1 : 0.5);
        });
        return this;
    };
    PasswordInput.prototype.Placeholder = function(placeholder) {
        var _this = this;
        this.React(placeholder, function(v) {
            return _this.passwordInput.Placeholder(v);
        });
        return this;
    };
    PasswordInput.Name = "PasswordInput";
    return PasswordInput;
}($joGvE.Div);
module.exports.PasswordInput = $e490dbcb2c83c831$var$PasswordInput;

});

parcelRegister("4ytZ3", function(module, exports) {
"use strict";
var $3511988913dff7b1$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NumberInput = void 0;

var $k6KGm = parcelRequire("k6KGm");

var $6wI3m = parcelRequire("6wI3m");
var $3511988913dff7b1$var$NumberInput = /** @class */ function(_super) {
    $3511988913dff7b1$var$__extends(NumberInput, _super);
    function NumberInput(ref) {
        if (ref === void 0) ref = new $6wI3m.Ref(0);
        var _this = _super.call(this, "input", ref) || this;
        _this.min = undefined;
        _this.max = undefined;
        _this.Class(NumberInput.DefaultCssClasses);
        _this.element.setAttribute("type", "number");
        _this.element.setAttribute("value", _this.ref.value.toString());
        _this.element.addEventListener('input', function(e) {
            // console.log(this.ID, 'input',e.target.value, this.ref.value)
            _this.ref.value = +e.target.value; // TODO: zwalidować czy to nie powoduje zapętlenia refreshy
        });
        _this.element.addEventListener('mousewheel', function(e) {
            // e.preventDefault();
            // console.log(this.ID, 'mousewheel',e.target.value, this.ref.value)
            _this.ref.value = +e.target.value;
        }, {
            passive: false
        });
        return _this;
    }
    NumberInput.prototype.Step = function(step) {
        var _this = this;
        this.React(step, function(v) {
            return _this.Attribute("step", v.toString());
        });
        return this;
    };
    NumberInput.prototype.Min = function(min) {
        var _this = this;
        this.React(min, function(v) {
            return _this.Attribute("min", v.toString());
        });
        return this;
    };
    NumberInput.prototype.Max = function(max) {
        var _this = this;
        this.React(max, function(v) {
            return _this.Attribute("max", v.toString());
        });
        return this;
    };
    NumberInput.prototype.Range = function(min, max) {
        this.Min(min);
        this.Max(max);
        return this;
    };
    NumberInput.prototype.Refresh = function() {
        // console.log(this.ID, 'refresh', this.ref.value)
        this.element.value = this.ref.value.toString();
        if (this.min !== undefined && this.max !== undefined) {
            if (this.min !== this.max && this.ref.value >= this.min && this.ref.value <= this.max) this.Style("background", "");
            else this.Style("background", "pink");
        }
        if (this.showThatChanged) this.ref.HasChanged ? this.element.classList.add("tf-value-changed") : this.element.classList.remove("tf-value-changed");
    };
    NumberInput.Name = "NumberInput";
    NumberInput.DefaultCssClasses = "";
    return NumberInput;
}($k6KGm.RefComponentBase);
module.exports.NumberInput = $3511988913dff7b1$var$NumberInput;

});

parcelRegister("2Q6Ax", function(module, exports) {
"use strict";
var $21158c68a1869eda$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NumericRange = void 0;

var $2s69t = parcelRequire("2s69t");
var $21158c68a1869eda$var$NumericRange = /** @class */ function(_super) {
    $21158c68a1869eda$var$__extends(NumericRange, _super);
    function NumericRange(min, max, range) {
        var _this = _super.call(this) || this;
        _this.min = min;
        _this.max = max;
        _this.minInput = new $2s69t.NumberInput(_this.min).HalfWidth();
        _this.maxInput = new $2s69t.NumberInput(_this.max).HalfWidth();
        if (range) {
            _this.minInput.Min(range[0]);
            _this.maxInput.Max(range[1]);
        }
        _this.Append(_this.minInput, _this.maxInput);
        return _this;
    }
    NumericRange.prototype.ShowThatChanged = function(showOrNot) {
        this.minInput.ShowThatChanged(showOrNot);
        this.maxInput.ShowThatChanged(showOrNot);
        return this;
    };
    NumericRange.Name = "NumericRange";
    return NumericRange;
}($2s69t.Div);
module.exports.NumericRange = $21158c68a1869eda$var$NumericRange;

});

parcelRegister("2OnCU", function(module, exports) {
"use strict";
var $20c2940b48787776$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Range = void 0;

var $k6KGm = parcelRequire("k6KGm");

var $6wI3m = parcelRequire("6wI3m");
var $20c2940b48787776$var$Range = /** @class */ function(_super) {
    $20c2940b48787776$var$__extends(Range, _super);
    function Range(ref, range) {
        if (ref === void 0) ref = new $6wI3m.Ref(0);
        if (range === void 0) range = [
            0,
            100
        ];
        var _this = _super.call(this, "input", ref) || this;
        _this.min = undefined;
        _this.max = undefined;
        _this.Class(Range.DefaultCssClasses);
        if (range && range.length == 2) {
            _this.Min(range[0]);
            _this.Max(range[1]);
        }
        _this.Attribute("type", "range");
        _this.Attribute("value", _this.ref.value.toString());
        _this.element.addEventListener('input', function(e) {
            _this.ref.value = +e.target.value;
        });
        return _this;
    }
    Range.prototype.Min = function(min) {
        var _this = this;
        this.React(min, function(v) {
            return _this.Attribute("min", v.toString());
        });
        return this;
    };
    Range.prototype.Max = function(max) {
        var _this = this;
        this.React(max, function(v) {
            return _this.Attribute("max", v.toString());
        });
        return this;
    };
    Range.prototype.Refresh = function() {
        this.element.value = this.ref.value.toString();
    };
    Range.Name = "Range";
    Range.DefaultCssClasses = "";
    return Range;
}($k6KGm.RefComponentBase);
module.exports.Range = $20c2940b48787776$var$Range;

});

parcelRegister("bGQX2", function(module, exports) {
"use strict";
var $882cb0f4f90f3af3$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $882cb0f4f90f3af3$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Select = void 0;

var $2s69t = parcelRequire("2s69t");

var $k6KGm = parcelRequire("k6KGm");
var $882cb0f4f90f3af3$var$Select = /** @class */ function(_super) {
    $882cb0f4f90f3af3$var$__extends(Select, _super);
    function Select(ref, initialOptions, optionsReloadTrigger) {
        if (ref === void 0) ref = new $2s69t.Ref("");
        if (initialOptions === void 0) initialOptions = [];
        var _this = _super.call(this, "select", ref) || this;
        _this.options = [];
        _this.InitialOptions = [];
        _this.clickHandler = function() {
            _this.RemoveDefaultOption();
            _this.element.removeEventListener('click', _this.clickHandler);
            _this.ref.value = _this.element.value; // BEZ TEGO PO KLIKNIĘCU KONTROLKA POKAZUJE PIERWSZĄ WARTOŚĆ ALE ref SIĘ NIE USTAWIA NA TE WARTOŚĆ
        };
        _this.modifyValueAfterChangeFn = function(t) {
            return t;
        };
        _this.DefaultValue = "__default__";
        _this.wasDefaultValueEverSet = false;
        _this.removeItOnFirstClick = false;
        _this.AddClass(Select.DefaultCssClasses);
        _this.WidthAuto();
        if (initialOptions instanceof $2s69t.Collection) initialOptions.OnChange(function() {
            return _this.LoadOptions(initialOptions.Items);
        });
        else if (typeof initialOptions === "function") {
            var options = initialOptions();
            _this.LoadOptions(options);
            if (!optionsReloadTrigger) _this.element.addEventListener('click', function(e) {
                var options = initialOptions();
                _this.LoadOptions(options);
            });
            else optionsReloadTrigger.OnChange(function() {
                return _this.LoadOptions(initialOptions());
            });
        } else if (Array.isArray(initialOptions)) {
            if (initialOptions[0] instanceof $2s69t.SelectOption) initialOptions.forEach(function(opt) {
                return _this.AddOption(opt);
            });
            else if (typeof initialOptions[0] == "string") initialOptions.forEach(function(opt) {
                return _this.AddOption(new $2s69t.SelectOption(opt));
            });
        } else if (initialOptions instanceof Object) {
            var entries = Object.entries(initialOptions);
            entries.map(function(_a) {
                var key = _a[0], value = _a[1];
                return _this.AddOption(new $2s69t.SelectOption(key, value));
            });
        }
        _this.InitialOptions = $882cb0f4f90f3af3$var$__spreadArray([], _this.options, true);
        _this.element.addEventListener('change', function(e) {
            var _a, _b;
            _this.ref.value = _this.modifyValueAfterChangeFn(e.target.value);
            var index = _this.options.findIndex(function(x) {
                return x.Value === e.target.value;
            });
            var key = ((_a = _this.options.find(function(x) {
                return x.Value === e.target.value;
            })) === null || _a === void 0 ? void 0 : _a.Text) || "";
            (_b = _this.onChangeCallback) === null || _b === void 0 || _b.call(_this, _this.ref.value, index, key);
        });
        _this.element.value = ref.value != null ? String(ref.value) : "";
        if (_this.removeItOnFirstClick) _this.RemoveDefaultOptionOnFirstClick();
        return _this;
    }
    Object.defineProperty(Select.prototype, "Index", {
        get: function() {
            var _this = this;
            return this.options.findIndex(function(x) {
                return x.Value === _this.ref.value;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Select.prototype, "Key", {
        get: function() {
            var _this = this;
            var _a;
            return ((_a = this.options.find(function(x) {
                return x.Value === _this.ref.value;
            })) === null || _a === void 0 ? void 0 : _a.Text) || this.defaultOptionText;
        },
        enumerable: false,
        configurable: true
    });
    Select.prototype.SetValue = function(value) {
        var _this = this;
        var _a, _b;
        _super.prototype.SetValue.call(this, value);
        var index = this.options.findIndex(function(x) {
            return x.Value === _this.ref.value;
        });
        var key = ((_a = this.options.find(function(x) {
            return x.Value === _this.ref.value;
        })) === null || _a === void 0 ? void 0 : _a.Text) || "";
        (_b = this.onChangeCallback) === null || _b === void 0 || _b.call(this, this.ref.value, index, key);
        return this;
    };
    Select.prototype.RemoveDefaultOptionOnFirstClick = function() {
        /*
            UŻYCIE TEJ OPCJI SPOWODUJE USUNIĘCIE WARTOŚCI DOMYŚLNEJ Z LISTY OPCJI
            ALE RÓWNIEŻ USTAWI PIERWSZĄ OPCJĘ. DEFAULTOWA JUŻ SIĘ WIĘCEJ NIE POJAWI.
            NIE WIEM CZY NIE LEPIEJ BYŁO BY Z TEGO ZREZYGNOWAĆ.
        */ this.element.addEventListener('click', this.clickHandler);
        // this.OnClick(this.handler)
        return this;
    };
    Object.defineProperty(Select.prototype, "IsOpen", {
        get: function() {
            return document.activeElement === this.element;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Select.prototype, "Options", {
        get: function() {
            return this.options;
        },
        enumerable: false,
        configurable: true
    });
    Select.prototype.ModifyAfterChange = function(fn) {
        this.modifyValueAfterChangeFn = fn;
        return this;
    };
    Select.prototype.CreateOption = function(option) {
        var optionElement = document.createElement("option");
        optionElement.text = option.Text;
        optionElement.value = option.Value != null ? String(option.Value) : "";
        return optionElement;
    };
    Select.prototype.PrependOption = function(option) {
        this.options.unshift(option);
        var optionElement = this.CreateOption(option);
        this.element.Prepend(optionElement);
        this.Refresh();
        return this;
    };
    Select.prototype.AddOption = function(option) {
        this.options.push(option);
        var optionElement = this.CreateOption(option);
        this.element.Append(optionElement);
        this.Refresh();
        return this;
    };
    Object.defineProperty(Select.prototype, "IsDefault", {
        get: function() {
            return !this.IsValueInOptions();
        },
        enumerable: false,
        configurable: true
    });
    Select.prototype.AddDefaultOption = function(text, removeItOnFirstClick) {
        if (removeItOnFirstClick === void 0) removeItOnFirstClick = false;
        this.removeItOnFirstClick = removeItOnFirstClick;
        this.wasDefaultValueEverSet = true;
        this.defaultOptionText = text;
        this.defaultOptionElement = document.createElement("option");
        this.defaultOptionElement.text = text;
        this.defaultOptionElement.value = this.DefaultValue;
        this.element.Append(this.defaultOptionElement);
        this.Refresh();
        return this;
    };
    Select.prototype.RemoveDefaultOption = function() {
        if (this.defaultOptionElement) {
            this.element.removeChild(this.defaultOptionElement);
            this.defaultOptionElement = null;
        }
        return this;
    };
    Select.prototype.ClearOptions = function() {
        this.options = [];
        this.element.textContent = '';
        if (this.wasDefaultValueEverSet) this.AddDefaultOption(this.defaultOptionText);
        return this;
    };
    Select.prototype.AddOptions = function(options) {
        var _this = this;
        options.forEach(function(o) {
            return _this.AddOption(o);
        });
        return this;
    };
    Select.prototype.LoadOptions = function(options) {
        var _this = this;
        this.ClearOptions();
        if (options[0] instanceof $2s69t.SelectOption) options.forEach(function(o) {
            return _this.AddOption(o);
        });
        else options.forEach(function(o) {
            return _this.AddOption(new $2s69t.SelectOption(o));
        });
        this.Refresh();
        return this;
    };
    Select.prototype.ReplaceOption = function(predicate, replacement) {
        var optionsCopy = $882cb0f4f90f3af3$var$__spreadArray([], this.Options, true);
        var foundIndex = optionsCopy.findIndex(function(x) {
            return predicate(x);
        });
        optionsCopy[foundIndex] = replacement;
        this.LoadOptions(optionsCopy);
        return this;
    };
    Select.prototype.LoadInitialOptions = function() {
        return this.LoadOptions(this.InitialOptions);
    };
    Select.prototype.OnChange = function(callback, callRightaway) {
        var _this = this;
        var _a, _b;
        if (callRightaway === void 0) callRightaway = false;
        this.onChangeCallback = callback;
        if (callRightaway) {
            var index = this.options.findIndex(function(x) {
                return x.Value === _this.ref.value;
            });
            var key = ((_a = this.options.find(function(x) {
                return x.Value === _this.ref.value;
            })) === null || _a === void 0 ? void 0 : _a.Text) || "";
            (_b = this.onChangeCallback) === null || _b === void 0 || _b.call(this, this.ref.value, index, key);
        }
        return this;
    };
    Select.prototype.Refresh = function() {
        if (this.IsValueInOptions()) this.element.value = this.ref.value != null ? String(this.ref.value) : "";
        else this.element.value = this.DefaultValue;
        if (this.showThatChanged) this.ref.HasChanged ? this.element.classList.add("tf-value-changed") : this.element.classList.remove("tf-value-changed");
        return this;
    };
    Select.prototype.IsValueInOptions = function() {
        var refValue = this.ref.value != null ? String(this.ref.value) : "";
        return this.options.map(function(x) {
            var _a;
            return (_a = x.Value) === null || _a === void 0 ? void 0 : _a.toString();
        }).includes(refValue);
    };
    Select.Name = "Select";
    Select.DefaultCssClasses = "";
    return Select;
}($k6KGm.RefComponentBase);
module.exports.Select = $882cb0f4f90f3af3$var$Select;

});

parcelRegister("eBSeP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SelectOption = void 0;
var $aa2e97fb58a44c38$var$SelectOption = /** @class */ function() {
    function SelectOption(Text, Value) {
        this.Text = Text;
        this.Value = Value;
        if (this.Value === undefined) this.Value = this.Text;
    }
    return SelectOption;
}();
module.exports.SelectOption = $aa2e97fb58a44c38$var$SelectOption;

});

parcelRegister("7fnxp", function(module, exports) {
"use strict";
var $546c313ef87b9e01$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NonRefCheckboxV2 = module.exports.NonRefCheckbox = module.exports.Checkbox = void 0;

var $k6KGm = parcelRequire("k6KGm");

var $jHilJ = parcelRequire("jHilJ");

var $6wI3m = parcelRequire("6wI3m");

var $aKtiT = parcelRequire("aKtiT");

var $8PO3e = parcelRequire("8PO3e");

var $gkD0R = parcelRequire("gkD0R");
var $546c313ef87b9e01$var$Checkbox = /** @class */ function(_super) {
    $546c313ef87b9e01$var$__extends(Checkbox, _super);
    function Checkbox(ref, label) {
        if (ref === void 0) ref = new $6wI3m.Ref(false);
        var _this = _super.call(this, "label", ref) || this;
        _this.ref = ref;
        _this.onCheckHandlers = new $8PO3e.HandlersCollection();
        _this.onUncheckHandlers = new $8PO3e.HandlersCollection();
        _this.onChangeHandlers = new $8PO3e.HandlersCollection();
        _this.Class("tf-checkbox");
        _this.Input = new $jHilJ.GenericComponent("input").AddClass("uk-checkbox").Attribute("type", "checkbox");
        if (ref.value) _this.Input.Attribute("checked", ref.value ? "checked" : "");
        _this.element.addEventListener('click', function(e) {
            _this.ref.value = _this.Input.element.checked; // czemu nie target.checked?
            _this.onChangeHandlers.Call(_this.ref.value);
            if (_this.ref.value == true) _this.onCheckHandlers.Call();
            else _this.onUncheckHandlers.Call();
        });
        _this.Append(_this.Input);
        if (label) _this.Append(new $gkD0R.Span(label).Class("checkbox-text"));
        return _this;
    }
    Checkbox.prototype.OnCheck = function(handler) {
        this.onCheckHandlers.Add(handler);
        return this;
    };
    Checkbox.prototype.OnUncheck = function(handler) {
        this.onUncheckHandlers.Add(handler);
        return this;
    };
    Checkbox.prototype.OnChange = function(handler) {
        this.onChangeHandlers.Add(handler);
        return this;
    };
    Checkbox.prototype.Refresh = function() {
        this.Input.element.checked = this.ref.value;
        if (this.showThatChanged) this.ref.HasChanged ? this.Input.element.classList.add("tf-value-changed") : this.Input.element.classList.remove("tf-value-changed");
    };
    Checkbox.prototype.Enabled = function() {
        this.Input.Enabled();
        return this;
    };
    Checkbox.prototype.Disabled = function() {
        this.Input.Disabled();
        return this;
    };
    Checkbox.prototype.Enable = function(isEnabled) {
        this.Input.Enable(isEnabled);
        return this;
    };
    Checkbox.prototype.EnableWhen = function(toWatch, predicate) {
        if (predicate === void 0) predicate = function(v) {
            return !!v;
        };
        this.Input.EnableWhen(toWatch, predicate);
        return this;
    };
    Checkbox.prototype.DisableWhen = function(toWatch, predicate) {
        if (predicate === void 0) predicate = function(v) {
            return !!v;
        };
        this.Input.DisableWhen(toWatch, predicate);
        return this;
    };
    Checkbox.prototype.Disable = function(isDisabled) {
        this.Input.Disable(isDisabled);
        return this;
    };
    Checkbox.Name = "Checkbox";
    return Checkbox;
}($k6KGm.RefComponentBase);
module.exports.Checkbox = $546c313ef87b9e01$var$Checkbox;
var $546c313ef87b9e01$var$NonRefCheckbox = /** @class */ function(_super) {
    $546c313ef87b9e01$var$__extends(NonRefCheckbox, _super);
    function NonRefCheckbox(value, onChange, label) {
        var _this = _super.call(this, "label") || this;
        _this.value = value;
        _this.input = new $jHilJ.GenericComponent("input").AddClass("uk-checkbox").Attribute("type", "checkbox");
        if (value()) _this.input.Attribute("checked");
        else _this.input.RemoveAttribute("checked");
        _this.element.addEventListener('click', function(e) {
            // console.log('!', this.input.element.checked);
            onChange(_this.input.element.checked);
        });
        _this.Append(_this.input);
        if (label) _this.Append(new $gkD0R.Span(" " + label));
        return _this;
    }
    NonRefCheckbox.prototype.Refresh = function() {
        this.input.element.checked = this.value();
    };
    return NonRefCheckbox;
}($aKtiT.ComponentBase);
module.exports.NonRefCheckbox = $546c313ef87b9e01$var$NonRefCheckbox;
var $546c313ef87b9e01$var$NonRefCheckboxV2 = /** @class */ function(_super) {
    $546c313ef87b9e01$var$__extends(NonRefCheckboxV2, _super);
    function NonRefCheckboxV2(value, onChange, label) {
        var _this = _super.call(this, "label") || this;
        _this.value = value;
        _this.input = new $jHilJ.GenericComponent("input").AddClass("uk-checkbox").Attribute("type", "checkbox");
        if (value) _this.input.Attribute("checked");
        else _this.input.RemoveAttribute("checked");
        _this.element.addEventListener('click', function(e) {
            onChange(_this.input.element.checked);
        });
        _this.Append(_this.input);
        if (label) _this.Append(new $gkD0R.Span(" " + label));
        return _this;
    }
    NonRefCheckboxV2.prototype.Refresh = function() {
        this.input.element.checked = this.value;
    };
    return NonRefCheckboxV2;
}($aKtiT.ComponentBase);
module.exports.NonRefCheckboxV2 = $546c313ef87b9e01$var$NonRefCheckboxV2;

});
parcelRegister("jHilJ", function(module, exports) {
"use strict";
var $e570444aa1c3a529$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GenericComponent = void 0;

var $aKtiT = parcelRequire("aKtiT");
var $e570444aa1c3a529$var$GenericComponent = /** @class */ function(_super) {
    $e570444aa1c3a529$var$__extends(GenericComponent, _super);
    function GenericComponent(element) {
        return _super.call(this, element) || this;
    }
    return GenericComponent;
}($aKtiT.ComponentBase);
module.exports.GenericComponent = $e570444aa1c3a529$var$GenericComponent;

});


parcelRegister("5duNI", function(module, exports) {
"use strict";
var $3cc60f0ae7725ed1$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $3cc60f0ae7725ed1$var$__assign = module.exports && module.exports.__assign || function() {
    $3cc60f0ae7725ed1$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3cc60f0ae7725ed1$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Rate = void 0;

var $joGvE = parcelRequire("joGvE");

var $85QoO = parcelRequire("85QoO");

var $1gg6H = parcelRequire("1gg6H");
var $3cc60f0ae7725ed1$var$Rate = /** @class */ function(_super) {
    $3cc60f0ae7725ed1$var$__extends(Rate, _super);
    function Rate(rating, config) {
        var _this = _super.call(this) || this;
        _this.Config = new $85QoO.RateConfig();
        if (config) _this.Config = $3cc60f0ae7725ed1$var$__assign($3cc60f0ae7725ed1$var$__assign({}, _this.Config), config);
        var _loop_1 = function(i) {
            var star = new $1gg6H.RateStar(rating, i, this_1.Config);
            if (this_1.Config.Readonly == false) star.OnClick(function() {
                return rating.value = i;
            });
            this_1.Append(star);
        };
        var this_1 = this;
        for(var i = 1; i <= _this.Config.Count; i++)_loop_1(i);
        return _this;
    }
    Rate.Name = "Rate";
    return Rate;
}($joGvE.Div);
module.exports.Rate = $3cc60f0ae7725ed1$var$Rate;

});
parcelRegister("85QoO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RateConfig = void 0;
var $5e476fc5648d347a$var$RateConfig = /** @class */ function() {
    function RateConfig() {
        this.Count = 5;
        this.SelectedSymbol = "\u2B50";
        this.SelectedStyle = "opacity: 1;";
        this.DeselectedSymbol = "\u2B50";
        this.DeselectedStyle = "opacity: 0.4;";
        this.Readonly = false;
    }
    return RateConfig;
}();
module.exports.RateConfig = $5e476fc5648d347a$var$RateConfig;

});

parcelRegister("1gg6H", function(module, exports) {
"use strict";
var $0eb3c79bca772948$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RateStar = void 0;

var $joGvE = parcelRequire("joGvE");

var $gkD0R = parcelRequire("gkD0R");
var $0eb3c79bca772948$var$RateStar = /** @class */ function(_super) {
    $0eb3c79bca772948$var$__extends(RateStar, _super);
    function RateStar(rating, showWhenLowerOrEqual, config) {
        var _this = _super.call(this) || this;
        _this.showWhenLowerOrEqual = showWhenLowerOrEqual;
        _this.config = config;
        _this.selected = new $gkD0R.Span(_this.config.SelectedSymbol).Style(_this.config.SelectedStyle).Hide();
        _this.deselected = new $gkD0R.Span(_this.config.DeselectedSymbol).Style(_this.config.DeselectedStyle);
        _this.DisplayInlineBlock();
        if (_this.config.Readonly == false) _this.CursorPointer();
        _this.Append(_this.selected, _this.deselected);
        rating.OnChange(function(v) {
            if (v >= _this.showWhenLowerOrEqual) {
                _this.selected.Show();
                _this.deselected.Hide();
            } else {
                _this.selected.Hide();
                _this.deselected.Show();
            }
        }, true);
        return _this;
    }
    return RateStar;
}($joGvE.Div);
module.exports.RateStar = $0eb3c79bca772948$var$RateStar;

});


parcelRegister("8Q6S6", function(module, exports) {
"use strict";
var $66f882a3097101e7$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DateInput = void 0;

var $6wI3m = parcelRequire("6wI3m");

var $k6KGm = parcelRequire("k6KGm");
var $66f882a3097101e7$var$DateInput = /** @class */ function(_super) {
    $66f882a3097101e7$var$__extends(DateInput, _super);
    function DateInput(value) {
        var _this = this;
        if (value instanceof $6wI3m.Ref) _this = _super.call(this, "input", value) || this;
        else if (value instanceof Date) _this = _super.call(this, "input", new $6wI3m.Ref(value)) || this;
        else if (typeof value === "number") _this = _super.call(this, "input", new $6wI3m.Ref(new Date(value))) || this;
        else _this = _super.call(this, "input", new $6wI3m.Ref(new Date())) || this;
        _this.Class("uk-input");
        _this.Attribute("type", "date");
        _this.element.addEventListener('change', function(e) {
            var _a;
            var v = new Date(e.target.value);
            _this.ref.value = v;
            (_a = _this.onChange) === null || _a === void 0 || _a.call(_this, v);
        });
        _this.Refresh();
        return _this;
    }
    DateInput.prototype.OnChange = function(callback) {
        this.onChange = callback;
        return this;
    };
    DateInput.prototype.Refresh = function() {
        this.element.valueAsDate = new Date(this.ref.value);
        if (this.showThatChanged) this.ref.HasChanged ? this.element.classList.add("tf-value-changed") : this.element.classList.remove("tf-value-changed");
    };
    DateInput.prototype.PadTo2Digits = function(num) {
        return num.toString().padStart(2, '0');
    };
    DateInput.prototype.FormatDate = function(date) {
        return [
            date.getFullYear(),
            this.PadTo2Digits(date.getMonth() + 1),
            this.PadTo2Digits(date.getDate())
        ].join('-');
    };
    DateInput.Name = "DateInput";
    return DateInput;
}($k6KGm.RefComponentBase);
module.exports.DateInput = $66f882a3097101e7$var$DateInput;

});

parcelRegister("5ACZp", function(module, exports) {
"use strict";
var $411e8f08c0ff235c$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TimeInput = void 0;

var $6wI3m = parcelRequire("6wI3m");

var $k6KGm = parcelRequire("k6KGm");
var $411e8f08c0ff235c$var$TimeInput = /** @class */ function(_super) {
    $411e8f08c0ff235c$var$__extends(TimeInput, _super);
    function TimeInput(ref) {
        if (ref === void 0) ref = new $6wI3m.Ref(TimeInput.DefaultTime);
        var _this = _super.call(this, "input", ref) || this;
        _this.Class("uk-input");
        _this.Attribute("type", "time");
        _this.element.addEventListener('change', function(e) {
            var _a;
            var v = e.target.value;
            var _b = v.split(":"), hour = _b[0], minute = _b[1];
            _this.ref.value = v;
            (_a = _this.onChange) === null || _a === void 0 || _a.call(_this, v, +hour, +minute);
        });
        _this.Refresh();
        return _this;
    }
    TimeInput.prototype.OnChange = function(callback) {
        this.onChange = callback;
        return this;
    };
    TimeInput.prototype.Refresh = function() {
        this.element.value = this.FormatTime(this.ref.value);
        if (this.showThatChanged) this.ref.HasChanged ? this.element.classList.add("tf-value-changed") : this.element.classList.remove("tf-value-changed");
    };
    TimeInput.prototype.AddTime = function(hours, minutes) {
        var _a, _b, _c;
        if (minutes === void 0) minutes = 0;
        var _d = ((_b = (_a = this.Value) === null || _a === void 0 ? void 0 : _a.split(":")) === null || _b === void 0 ? void 0 : _b.map(function(x) {
            return +x;
        })) || [
            0,
            0
        ], hh = _d[0], mm = _d[1];
        hh = (hh + hours) % 24;
        hh < 0 && (hh = 23);
        mm = (mm + minutes) % 60;
        mm < 0 && (mm = 59);
        var v = hh + ":" + mm;
        this.Value = v;
        (_c = this.onChange) === null || _c === void 0 || _c.call(this, v, hh, mm);
        return this;
    };
    TimeInput.prototype.SetTime = function(hours, minutes) {
        var _a;
        if (minutes === void 0) minutes = 0;
        var v = hours + ":" + minutes;
        this.Value = v;
        (_a = this.onChange) === null || _a === void 0 || _a.call(this, v, hours, minutes);
        return this;
    };
    TimeInput.prototype.PadTo2Digits = function(num) {
        return num.toString().padStart(2, '0');
    };
    TimeInput.prototype.FormatTime = function(time) {
        var _a = time.split(":"), hour = _a[0], minute = _a[1];
        return [
            this.PadTo2Digits(hour),
            this.PadTo2Digits(minute)
        ].join(':');
    };
    TimeInput.Name = "TimeInput";
    TimeInput.DefaultTime = "12:00";
    return TimeInput;
}($k6KGm.RefComponentBase);
module.exports.TimeInput = $411e8f08c0ff235c$var$TimeInput;

});

parcelRegister("3UiF9", function(module, exports) {
"use strict";
var $2d851419d9636d90$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DateTimeInput = void 0;

var $6wI3m = parcelRequire("6wI3m");

var $k6KGm = parcelRequire("k6KGm");
var $2d851419d9636d90$var$DateTimeInput = /** @class */ function(_super) {
    $2d851419d9636d90$var$__extends(DateTimeInput, _super);
    function DateTimeInput(ref) {
        var _this = this;
        if (ref instanceof $6wI3m.Ref) _this = _super.call(this, "input", ref) || this;
        else if (ref instanceof Date) _this = _super.call(this, "input", new $6wI3m.Ref(ref)) || this;
        else if (typeof ref === "number") _this = _super.call(this, "input", new $6wI3m.Ref(new Date(ref))) || this;
        else _this = _super.call(this, "input", new $6wI3m.Ref(new Date())) || this;
        _this.Class("uk-input");
        _this.Attribute("type", "datetime-local");
        // this.Attribute("type", "datetime");
        _this.element.addEventListener('change', function(e) {
            var v = e.target.value;
            // console.log('onchange', v)
            _this.ref.value = new Date(v);
        });
        _this.Refresh();
        return _this;
    }
    DateTimeInput.prototype.Refresh = function() {
        // Uzyskanie aktualnej daty i godziny w czasie uniwersalnym (UTC)
        var t = this.ref.value;
        // const tzoh = new Date().getTimezoneOffset() / 60;
        // console.log('TZO', tzoh)
        var year = t.getFullYear();
        var month = t.getMonth() + 1; // Pamiętaj, że miesiące są indeksowane od 0
        var day = t.getDate();
        // console.log(t.getHours(), tzoh)
        var hours = t.getHours(); //- tzoh;
        var minutes = t.getMinutes();
        // // Formatowanie daty i godziny do ISO string
        var dateWithoutTimezone = "".concat(year, "-").concat(month.toString().padStart(2, '0'), "-").concat(day.toString().padStart(2, '0'), "T").concat(hours.toString().padStart(2, '0'), ":").concat(minutes.toString().padStart(2, '0'));
        // console.log('CCCCCCCCc', currentISOString)
        this.element.value = dateWithoutTimezone;
        // console.log('REFR1', this.ref.value)
        // // console.log('REFR iso', this.ref.value.toISOString())
        // // console.log('REFR utc', this.ref.value.toUTCString())
        // console.log('REFR iii', currentISOString)
        // this.element.value =currentISOString// this.ref.value.toISOString().slice(0, 16);
        // console.log('REFR', this.element.value)
        if (this.showThatChanged) this.ref.HasChanged ? this.element.classList.add("tf-value-changed") : this.element.classList.remove("tf-value-changed");
    };
    DateTimeInput.Name = "DateTimeInput";
    return DateTimeInput;
}($k6KGm.RefComponentBase);
module.exports.DateTimeInput = $2d851419d9636d90$var$DateTimeInput;

});

parcelRegister("2Tv9C", function(module, exports) {
"use strict";
var $21b8e266d708dd19$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EditableDateLabel = void 0;

var $3B1VX = parcelRequire("3B1VX");

var $8Q6S6 = parcelRequire("8Q6S6");

var $joGvE = parcelRequire("joGvE");

var $8PO3e = parcelRequire("8PO3e");

var $2Vdhf = parcelRequire("2Vdhf");

var $2s69t = parcelRequire("2s69t");
var $21b8e266d708dd19$var$EditableDateLabel = /** @class */ function(_super) {
    $21b8e266d708dd19$var$__extends(EditableDateLabel, _super);
    function EditableDateLabel(ref, printer) {
        if (ref === void 0) ref = new $2Vdhf.RefDate(0);
        if (printer === void 0) printer = function(value) {
            return +value == 0 ? "unset" : value.getDate() + "." + (value.getMonth() + 1) + "." + value.getFullYear();
        };
        var _this = _super.call(this) || this;
        _this.onChange = new $8PO3e.HandlersCollection();
        _this.Label = new $3B1VX.Text(ref, function(v) {
            return printer(v);
        }).CursorPointer().OnClick(function() {
            _this.Label.Hide();
            _this.DateInput.Show();
            _this.OffButton.Show();
        });
        _this.DateInput = new $8Q6S6.DateInput(ref).DisplayInline().WidthAuto().Hide().OnChange(function(date) {
            _this.DateInput.Hide();
            _this.OffButton.Hide();
            _this.Label.Show();
            _this.onChange.Call(date);
        }).OnBlur(function() {
            _this.DateInput.Hide();
            _this.OffButton.Hide();
            _this.Label.Show();
        });
        _this.OffButton = new $2s69t.Button("\u2716").CursorPointer().Inline().Hide();
        _this.OffButton.OnClick(function() {
            _this.Label.Show();
            _this.DateInput.Hide();
            _this.OffButton.Hide();
        });
        // this.DateInput.Width(85, "%")
        _this.OffButton.MarginLeft(6);
        // NIE DA SIE KLIKNĄĆ W KONTROLKE BO ŁAPIE BLURA :(
        // this.SetAttribute("tabindex", "0");
        // this.OnBlur(() =>
        // {
        //     this.DateInput.Hide();
        //     this.Label.Show();
        // });
        _this.Append(_this.Label, _this.DateInput, _this.OffButton);
        return _this;
    }
    EditableDateLabel.prototype.OnChange = function(handler) {
        this.onChange.Add(handler);
        return this;
    };
    EditableDateLabel.prototype.DateInputConfig = function(config) {
        config(this.DateInput);
        return this;
    };
    EditableDateLabel.prototype.OffButtonConfig = function(config) {
        config(this.OffButton);
        return this;
    };
    EditableDateLabel.prototype.LabelConfig = function(config) {
        config(this.Label);
        return this;
    };
    EditableDateLabel.Name = "EditableDateLabel";
    return EditableDateLabel;
}($joGvE.Div);
module.exports.EditableDateLabel = $21b8e266d708dd19$var$EditableDateLabel;

});

parcelRegister("fGn1O", function(module, exports) {
"use strict";
var $b6aca43425439cfe$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EditableTextarea = void 0;

var $aKtiT = parcelRequire("aKtiT");

var $3B1VX = parcelRequire("3B1VX");

var $37QPp = parcelRequire("37QPp");
var $b6aca43425439cfe$var$EditableTextarea = /** @class */ function(_super) {
    $b6aca43425439cfe$var$__extends(EditableTextarea, _super);
    function EditableTextarea(ref, config) {
        if (config === void 0) config = {
            editOnClick: true
        };
        var _this = _super.call(this, "div") || this;
        _this.ref = ref;
        _this.config = config;
        _this.valueBeforeEdit = "";
        _this.label = new $3B1VX.Text(ref).CursorPointer().Show();
        if (config.editOnClick) _this.label.OnClick(function() {
            if (config.editOnClick) _this.EditMode();
        });
        _this.textInput = new $37QPp.MultilineInput(ref).Hide();
        if (config.editOnClick) _this.textInput.OnBlur(function() {
            if (config.editOnClick) _this.EndOfEdit();
        });
        _this.Append(_this.label, _this.textInput);
        return _this;
    }
    EditableTextarea.prototype.EditMode = function() {
        var linesCount = this.ref.value.split("\n").length;
        this.textInput.Rows(linesCount);
        this.valueBeforeEdit = this.ref.value;
        var labelWidth = getComputedStyle(this.label.Element).width;
        var w = +labelWidth.replace("px", "");
        if (w < 100) w += 32;
        this.label.Hide();
        this.textInput.Show().Width(w).Padding(2, 6);
    };
    EditableTextarea.prototype.EnableEditMode = function() {
        this.config.editOnClick = true;
    };
    EditableTextarea.prototype.DisableEditMode = function() {
        this.config.editOnClick = false;
    };
    Object.defineProperty(EditableTextarea.prototype, "IsEditMode", {
        get: function() {
            return this.textInput.IsVisible();
        },
        enumerable: false,
        configurable: true
    });
    EditableTextarea.prototype.ToggleEditMode = function() {
        if (this.IsEditMode) this.CloseEditMode();
        else this.EditMode();
        return this;
    };
    EditableTextarea.prototype.OpenEditMode = function() {
        this.EditMode();
        return this;
    };
    EditableTextarea.prototype.CloseEditMode = function() {
        this.EndOfEdit();
        return this;
    };
    EditableTextarea.prototype.LabelConfig = function(config) {
        config(this.label);
        return this;
    };
    EditableTextarea.prototype.TextInputConfig = function(config) {
        config(this.textInput);
        return this;
    };
    EditableTextarea.prototype.OnEditEnd = function(callback) {
        this.editEnd = callback;
        return this;
    };
    EditableTextarea.prototype.EndOfEdit = function() {
        var _a;
        if (!this.textInput.IsVisible()) return; // To prevent double call
        this.textInput.Hide();
        this.label.Show();
        (_a = this.editEnd) === null || _a === void 0 || _a.call(this, this.valueBeforeEdit, this.ref.value);
    };
    EditableTextarea.prototype.DefaultText = function(text) {
        this.label.DefaultText(text);
        return this;
    };
    EditableTextarea.prototype.Placeholder = function(placeholder) {
        this.textInput.Placeholder(placeholder);
        return this;
    };
    EditableTextarea.prototype.Style = function(prop, val) {
        this.label.Style(prop, val);
        this.textInput.Style(prop, val);
        return this;
    };
    EditableTextarea.Name = "EditableTextarea";
    return EditableTextarea;
}($aKtiT.ComponentBase);
module.exports.EditableTextarea = $b6aca43425439cfe$var$EditableTextarea;

});
parcelRegister("37QPp", function(module, exports) {
"use strict";
var $246b012041d45c9e$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MultilineInput = void 0;

var $k6KGm = parcelRequire("k6KGm");

var $6wI3m = parcelRequire("6wI3m");
var $246b012041d45c9e$var$MultilineInput = /** @class */ function(_super) {
    $246b012041d45c9e$var$__extends(MultilineInput, _super);
    function MultilineInput(ref) {
        if (ref === void 0) ref = new $6wI3m.Ref("");
        var _this = this;
        if (typeof ref === "string") ref = new $6wI3m.Ref(ref);
        _this = _super.call(this, "textarea", ref) || this;
        _this.Class(MultilineInput.DefaultCssClasses);
        _this.element.addEventListener('input', function(e) {
            _this.ref.value = e.target.value;
        });
        _this.Refresh();
        return _this;
    }
    MultilineInput.prototype.Placeholder = function(placeholder) {
        var _this = this;
        this.React(placeholder, function(v) {
            return _this.Attribute("placeholder", v.toString());
        });
        return this;
    };
    MultilineInput.prototype.Readonly = function() {
        this.Attribute("readonly");
        return this;
    };
    MultilineInput.prototype.Rows = function(count) {
        var _this = this;
        this.React(count, function(v) {
            return _this.Attribute("rows", v.toString());
        });
        return this;
    };
    MultilineInput.prototype.Refresh = function() {
        this.element.value = this.ref.value;
        if (this.showThatChanged) this.ref.HasChanged ? this.element.classList.add("tf-value-changed") : this.element.classList.remove("tf-value-changed");
    };
    MultilineInput.Name = "MultilineInput";
    MultilineInput.DefaultCssClasses = "";
    return MultilineInput;
}($k6KGm.RefComponentBase);
module.exports.MultilineInput = $246b012041d45c9e$var$MultilineInput;

});


parcelRegister("hEMp0", function(module, exports) {
"use strict";
var $cdabb7ce117dd32c$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LabeledTextInput2 = module.exports.LabeledTextInput = void 0;

var $etGN3 = parcelRequire("etGN3");

var $6wI3m = parcelRequire("6wI3m");

var $gkD0R = parcelRequire("gkD0R");

var $joGvE = parcelRequire("joGvE");
var $cdabb7ce117dd32c$var$LabeledTextInput = /** @class */ function(_super) {
    $cdabb7ce117dd32c$var$__extends(LabeledTextInput, _super);
    function LabeledTextInput(label, variable) {
        if (variable === void 0) variable = new $6wI3m.Ref("");
        var _this = _super.call(this, "LabeledTextInput") || this;
        _this.Append(new $gkD0R.Span(label).Class("label"));
        _this.Append(new $etGN3.TextInput(variable).Placeholder(label).Class("input"));
        return _this;
    }
    return LabeledTextInput;
}($joGvE.Div);
module.exports.LabeledTextInput = $cdabb7ce117dd32c$var$LabeledTextInput;
var $cdabb7ce117dd32c$var$LabeledTextInput2 = /** @class */ function(_super) {
    $cdabb7ce117dd32c$var$__extends(LabeledTextInput2, _super);
    function LabeledTextInput2(label, variable) {
        if (variable === void 0) variable = new $6wI3m.Ref("");
        var _this = _super.call(this) || this;
        _this.Append(new $gkD0R.Span(label).Width(320).DisplayInlineBlock(), new $etGN3.TextInput(variable).Placeholder(label).Width(200));
        return _this;
    }
    return LabeledTextInput2;
}($joGvE.Div);
module.exports.LabeledTextInput2 = $cdabb7ce117dd32c$var$LabeledTextInput2;

});

parcelRegister("kUDwd", function(module, exports) {
"use strict";
var $f397b129d653e146$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LabeledNumberInput = void 0;

var $joGvE = parcelRequire("joGvE");

var $gkD0R = parcelRequire("gkD0R");

var $4ytZ3 = parcelRequire("4ytZ3");
var $f397b129d653e146$var$LabeledNumberInput = /** @class */ function(_super) {
    $f397b129d653e146$var$__extends(LabeledNumberInput, _super);
    function LabeledNumberInput(label, ref) {
        var _this = _super.call(this, "tf-form-labeled-number") || this;
        _this.label = label;
        _this.ref = ref;
        _this.labelCmp = new $gkD0R.Span(_this.label).Class("label");
        _this.numberInput = new $4ytZ3.NumberInput(_this.ref).Class("input");
        _this.Append(_this.labelCmp, _this.numberInput);
        return _this;
    }
    LabeledNumberInput.prototype.Min = function(min) {
        this.numberInput.Min(min);
        return this;
    };
    LabeledNumberInput.prototype.Max = function(max) {
        this.numberInput.Max(max);
        return this;
    };
    LabeledNumberInput.prototype.Step = function(step) {
        this.numberInput.Step(step);
        return this;
    };
    LabeledNumberInput.prototype.Edit = function(hook) {
        hook(this.labelCmp, this.numberInput);
        return this;
    };
    return LabeledNumberInput;
}($joGvE.Div);
module.exports.LabeledNumberInput = $f397b129d653e146$var$LabeledNumberInput;

});

parcelRegister("iBXy5", function(module, exports) {
"use strict";
var $d8c9dfd5cab4d14d$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LabeledSelect2 = module.exports.LabeledSelect = void 0;

var $joGvE = parcelRequire("joGvE");

var $gkD0R = parcelRequire("gkD0R");

var $bGQX2 = parcelRequire("bGQX2");
var $d8c9dfd5cab4d14d$var$LabeledSelect = /** @class */ function(_super) {
    $d8c9dfd5cab4d14d$var$__extends(LabeledSelect, _super);
    function LabeledSelect(label, ref, selectOptions) {
        if (selectOptions === void 0) selectOptions = [];
        var _this = _super.call(this, "tf-form-labeled-select") || this;
        _this.label = label;
        _this.ref = ref;
        _this.selectOptions = selectOptions;
        _this.labelCmp = new $gkD0R.Span(_this.label).Class("label");
        _this.input = new $bGQX2.Select(_this.ref, _this.selectOptions).Class("input");
        _this.Append(_this.labelCmp, _this.input);
        return _this;
    }
    LabeledSelect.prototype.Edit = function(hook) {
        hook(this.labelCmp, this.input);
        return this;
    };
    return LabeledSelect;
}($joGvE.Div);
module.exports.LabeledSelect = $d8c9dfd5cab4d14d$var$LabeledSelect;
var $d8c9dfd5cab4d14d$var$LabeledSelect2 = /** @class */ function(_super) {
    $d8c9dfd5cab4d14d$var$__extends(LabeledSelect2, _super);
    function LabeledSelect2(label, ref, selectOptions) {
        if (selectOptions === void 0) selectOptions = [];
        var _this = _super.call(this, "tf-form-labeled-select") || this;
        _this.label = label;
        _this.ref = ref;
        _this.selectOptions = selectOptions;
        _this.labelCmp = new $gkD0R.Span(_this.label).Class("label").Width(320).DisplayInlineBlock();
        _this.Select = new $bGQX2.Select(_this.ref, _this.selectOptions).Class("input").Width(200);
        _this.Append(_this.labelCmp, _this.Select);
        return _this;
    }
    LabeledSelect2.prototype.Edit = function(hook) {
        hook(this.labelCmp, this.Select);
        return this;
    };
    return LabeledSelect2;
}($joGvE.Div);
module.exports.LabeledSelect2 = $d8c9dfd5cab4d14d$var$LabeledSelect2;

});

parcelRegister("6dx9g", function(module, exports) {
"use strict";
var $012b0f2770500f94$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MultipleFilesInput = module.exports.FileInput = module.exports.FileInputV1 = void 0;

var $aKtiT = parcelRequire("aKtiT");

var $8PO3e = parcelRequire("8PO3e");
var $012b0f2770500f94$var$FileInputV1 = /** @class */ function(_super) {
    $012b0f2770500f94$var$__extends(FileInputV1, _super);
    function FileInputV1() {
        var _this = _super.call(this, "input") || this;
        _this.onChange = new $8PO3e.HandlersCollection();
        _this.Attribute("type", "file");
        _this.Class($012b0f2770500f94$var$FileInput.DefaultCssClasses);
        _this.element.addEventListener('change', function(e) {
            var _a;
            // console.log(this.element.files[0])
            _this.onChange.Call((_a = _this.element.files) === null || _a === void 0 ? void 0 : _a[0], e);
        });
        return _this;
    }
    FileInputV1.prototype.OnChange = function(handler) {
        this.onChange.Add(handler);
        return this;
    };
    FileInputV1.Name = "FileInput";
    FileInputV1.DefaultCssClasses = "";
    return FileInputV1;
}($aKtiT.ComponentBase);
module.exports.FileInputV1 = $012b0f2770500f94$var$FileInputV1;
var $012b0f2770500f94$var$FileInput = /** @class */ function(_super) {
    $012b0f2770500f94$var$__extends(FileInput, _super);
    function FileInput(onChange) {
        var _this = _super.call(this, "input") || this;
        _this.onChange = new $8PO3e.HandlersCollection();
        _this.Attribute("type", "file");
        _this.Class(FileInput.DefaultCssClasses);
        _this.onChange.Add(onChange);
        _this.element.addEventListener('change', function(e) {
            var _a;
            _this.onChange.Call((_a = _this.element.files) === null || _a === void 0 ? void 0 : _a[0], e);
        });
        return _this;
    }
    FileInput.prototype.OnChange = function(handler) {
        this.onChange.Add(handler);
        return this;
    };
    FileInput.Name = "FileInput";
    FileInput.DefaultCssClasses = "";
    return FileInput;
}($aKtiT.ComponentBase);
module.exports.FileInput = $012b0f2770500f94$var$FileInput;
var $012b0f2770500f94$var$MultipleFilesInput = /** @class */ function(_super) {
    $012b0f2770500f94$var$__extends(MultipleFilesInput, _super);
    function MultipleFilesInput(onChange) {
        var _this = _super.call(this, "input") || this;
        _this.onChange = new $8PO3e.HandlersCollection();
        _this.Attribute("type", "file").Attribute("multiple");
        _this.Class($012b0f2770500f94$var$FileInput.DefaultCssClasses);
        _this.onChange.Add(onChange);
        _this.element.addEventListener('change', function(e) {
            _this.onChange.Call(_this.element.files, e);
        });
        return _this;
    }
    MultipleFilesInput.prototype.OnChange = function(handler) {
        this.onChange.Add(handler);
        return this;
    };
    MultipleFilesInput.Name = "MultipleFilesInput";
    MultipleFilesInput.DefaultCssClasses = "";
    return MultipleFilesInput;
}($aKtiT.ComponentBase);
module.exports.MultipleFilesInput = $012b0f2770500f94$var$MultipleFilesInput;

});

parcelRegister("bL1Ff", function(module, exports) {
"use strict";
var $88f55ffae983f4ad$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PopupMenu = module.exports.Menu = void 0;

var $joGvE = parcelRequire("joGvE");

var $gkD0R = parcelRequire("gkD0R");

var $2S24U = parcelRequire("2S24U");
var $88f55ffae983f4ad$var$Menu = /** @class */ function(_super) {
    $88f55ffae983f4ad$var$__extends(Menu, _super);
    function Menu(menuItems, menuClasses, onClose) {
        if (menuClasses === void 0) menuClasses = "";
        var _this = _super.call(this, "menu") || this;
        _this.onClose = onClose;
        // ☢️ UWAGA! TO MA BYĆ FUNKCJA (NIE METODA) JEŚLI ZROBIMY Z TEGO METODĘ TO NIE DZIAŁA document.removeEventListener. 
        // NIE WAŻNE CZY DO TEJ METODY PRZEKAŻEMY WSKAŹNIK NA METODE, WYWOŁANIE FUNKCJI STRZAŁKOWEJ CZY ZROBIMY .bind(this). 
        // KAŻDA TA OPCJA NIE DZIAŁA CO POTEM POWODUJE PROBLEMY Z RemoveSelf BO JEST TRACONY KONTEKST DO this. 
        // MOŻNA OD BIEDY WSPOMÓC SIĘ POMOCNICZĄ FLAGĄ ALE TAK KOD JEST CZYSTSZY CHOĆ WYGLĄDA KRETYŃSKO.
        _this.DocumentClick = function() {
            var _a;
            _this.RemoveSelf();
            (_a = _this.onClose) === null || _a === void 0 || _a.call(_this);
        };
        _this.Class(menuClasses);
        _this.Append.apply(_this, Object.entries(menuItems).map(function(_a) {
            var label = _a[0], action = _a[1];
            var span = new $gkD0R.Span(label).Class("menu-item").OnClick(function() {
                var _a;
                document.removeEventListener("click", _this.DocumentClick);
                _this.RemoveSelf();
                (_a = _this.onClose) === null || _a === void 0 || _a.call(_this);
                action();
            });
            return span;
        }));
        document.addEventListener("click", _this.DocumentClick, {
            once: true
        });
        return _this;
    }
    Menu.Name = "Menu";
    return Menu;
}($joGvE.Div);
module.exports.Menu = $88f55ffae983f4ad$var$Menu;
/*
    REMEMBER TO KEEP BUTTON IN A RELATIVE CONTAINER.
*/ var $88f55ffae983f4ad$var$PopupMenu = /** @class */ function(_super) {
    $88f55ffae983f4ad$var$__extends(PopupMenu, _super);
    function PopupMenu(menuItems, activator, menuClasses) {
        if (activator === void 0) activator = new $2S24U.Button("\u22EE").RemoveAllClasses();
        if (menuClasses === void 0) menuClasses = "";
        var _this = _super.call(this, "popup-menu") || this;
        var allowClick = true;
        _this.Append(activator.OnClick(function(_) {
            if (!allowClick) return;
            allowClick = false;
            _.Disabled();
            _this.Append(new $88f55ffae983f4ad$var$Menu(menuItems, menuClasses, function() {
                allowClick = true;
                _.Enabled();
            }));
        }));
        return _this;
    }
    PopupMenu.Name = "PopupMenu";
    return PopupMenu;
}($joGvE.Div);
module.exports.PopupMenu = $88f55ffae983f4ad$var$PopupMenu;

});

parcelRegister("5BSVz", function(module, exports) {
"use strict";
var $415b03e7f5c4206b$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TextCombo = void 0;

var $6wI3m = parcelRequire("6wI3m");

var $joGvE = parcelRequire("joGvE");

var $gg7jy = parcelRequire("gg7jy");

var $azQFq = parcelRequire("azQFq");
// TODO?: pokazywanie wyników tylko jeśli jest focus na kontrolce
// ✅ TODO: możliwość odkliknięcia - lista wyników znika
// TODO: możliwość wybrania strzałkami z klawiatury
// ✅ TODO: ESC zamyka listę wyników
// TODO: po wybraniu/kliknięciu lista wyników zamyka się
var $415b03e7f5c4206b$var$TextCombo = /** @class */ function(_super) {
    $415b03e7f5c4206b$var$__extends(TextCombo, _super);
    function TextCombo(needle, stack) {
        if (needle === void 0) needle = new $6wI3m.Ref("");
        if (stack === void 0) stack = [];
        var _this = _super.call(this) || this;
        _this.needle = needle;
        _this.MaxResults = 5;
        _this.whenNoResultsText = "No results found";
        _this.SearchInput = new $azQFq.ClearableTextInput(_this.needle);
        _this.ResultsList = new $gg7jy.TextComboSearchResult(_this.MaxResults);
        needle.OnChange(function(v) {
            // TODO: move it all to TextComboSearchResult????
            var needleValue = v.trim().toLowerCase();
            var items = Array.isArray(stack) ? stack : stack.Items;
            var filteredItems = items.filter(function(x) {
                return x.SearchBy.toLowerCase().includes(needleValue);
            });
            // TODO: move to ResultsList?
            if (filteredItems.length == 0) _this.ResultsList.NoResults(_this.whenNoResultsText);
            else if (needleValue.length == 0) _this.ResultsList.Hide();
            else _this.ResultsList.LoadResults(filteredItems);
        });
        _this.SearchInput.TextInput.OnBlur(function() {
            // Timeout because Hide fires before item click
            setTimeout(function() {
                _this.ResultsList.Hide();
            }, 300);
        });
        _this.SearchInput.TextInput.OnFocus(function() {
            if (needle.value.length > 0) _this.ResultsList.Show();
        });
        _this.Append(_this.SearchInput, _this.ResultsList);
        return _this;
    }
    TextCombo.prototype.Placeholder = function(placeholder) {
        this.SearchInput.TextInput.Placeholder(placeholder);
        return this;
    };
    TextCombo.prototype.NoResultsText = function(text) {
        this.whenNoResultsText = text;
        return this;
    };
    TextCombo.Name = "TextCombo";
    TextCombo.DefaultCssClasses = "";
    return TextCombo;
}($joGvE.Div);
module.exports.TextCombo = $415b03e7f5c4206b$var$TextCombo;

});
parcelRegister("gg7jy", function(module, exports) {
"use strict";
var $bd63d07550015afb$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TextComboSearchResult = void 0;

var $joGvE = parcelRequire("joGvE");

var $8Lkmv = parcelRequire("8Lkmv");
var $bd63d07550015afb$var$TextComboSearchResult = /** @class */ function(_super) {
    $bd63d07550015afb$var$__extends(TextComboSearchResult, _super);
    function TextComboSearchResult(maxResults) {
        var _this = _super.call(this, "TextComboSearchResult") || this;
        _this.maxResults = maxResults;
        return _this;
    }
    TextComboSearchResult.prototype.NoResults = function(whenNoResultsText) {
        if (whenNoResultsText === void 0) whenNoResultsText = "No results found";
        this.Clear();
        this.Show();
        this.Append(new $joGvE.Div().Text(whenNoResultsText).Style("text-align: center;").Class("no-results"));
    };
    TextComboSearchResult.prototype.LoadResults = function(items) {
        this.Clear();
        this.Show();
        this.Append.apply(this, items.slice(0, this.maxResults).map(function(x) {
            return new $8Lkmv.TextComboSearchResultItem(x);
        }));
    };
    return TextComboSearchResult;
}($joGvE.Div);
module.exports.TextComboSearchResult = $bd63d07550015afb$var$TextComboSearchResult;

});
parcelRegister("8Lkmv", function(module, exports) {
"use strict";
var $661281f9fbfe1c03$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TextComboSearchResultItem = void 0;

var $joGvE = parcelRequire("joGvE");
var $661281f9fbfe1c03$var$TextComboSearchResultItem = /** @class */ function(_super) {
    $661281f9fbfe1c03$var$__extends(TextComboSearchResultItem, _super);
    function TextComboSearchResultItem(item) {
        var _this = _super.call(this, "TextComboSearchResultItem") || this;
        _this.Append(item.BindedTo());
        return _this;
    }
    return TextComboSearchResultItem;
}($joGvE.Div);
module.exports.TextComboSearchResultItem = $661281f9fbfe1c03$var$TextComboSearchResultItem;

});


parcelRegister("azQFq", function(module, exports) {
"use strict";
var $7b3606d93cf72d77$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ClearableTextInput = void 0;

var $joGvE = parcelRequire("joGvE");

var $gkD0R = parcelRequire("gkD0R");

var $etGN3 = parcelRequire("etGN3");
var $7b3606d93cf72d77$var$ClearableTextInput = /** @class */ function(_super) {
    $7b3606d93cf72d77$var$__extends(ClearableTextInput, _super);
    function ClearableTextInput(value, placeholder) {
        var _this = _super.call(this, "ClearableTextInput") || this;
        _this.value = value;
        _this.placeholder = placeholder;
        _this.PositionRelative();
        _this.TextInput = new $etGN3.TextInput(_this.value).Placeholder(_this.placeholder || "");
        _this.ClearButton = new $gkD0R.Span("\xd7").Class("x");
        _this.ClearButton.OnClick(function() {
            return _this.value.value = "";
        }).VisibleWhen(_this.value, function(v) {
            return v.length > 0;
        });
        _this.Append(_this.TextInput, _this.ClearButton);
        return _this;
    }
    ClearableTextInput.Name = "ClearableTextInput";
    return ClearableTextInput;
}($joGvE.Div);
module.exports.ClearableTextInput = $7b3606d93cf72d77$var$ClearableTextInput;

});


parcelRegister("7Kd03", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SearchableItem = void 0;

var $joGvE = parcelRequire("joGvE");
var $5a36e9ce10fb7745$var$SearchableItem = /** @class */ function() {
    function SearchableItem(searchBy, bindedTo, onClick) {
        this.SearchBy = searchBy;
        this.BindedTo = function() {
            return new $joGvE.Div().Append(bindedTo()).OnClick(onClick);
        };
    }
    return SearchableItem;
}();
module.exports.SearchableItem = $5a36e9ce10fb7745$var$SearchableItem;

});

parcelRegister("bEnZu", function(module, exports) {
"use strict";
var $87b60a2f958f6b0a$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ModalWindow = void 0;

var $iqyiC = parcelRequire("iqyiC");

var $6wI3m = parcelRequire("6wI3m");

var $8PO3e = parcelRequire("8PO3e");

var $joGvE = parcelRequire("joGvE");

var $5PIlt = parcelRequire("5PIlt");

var $4wFdb = parcelRequire("4wFdb");

var $3B1VX = parcelRequire("3B1VX");
var $87b60a2f958f6b0a$var$ModalWindow = /** @class */ function(_super) {
    $87b60a2f958f6b0a$var$__extends(ModalWindow, _super);
    function ModalWindow(title, blurBackground, lockScroll, closeOnClickAway) {
        if (blurBackground === void 0) blurBackground = true;
        if (lockScroll === void 0) lockScroll = false;
        if (closeOnClickAway === void 0) closeOnClickAway = false;
        var _this = _super.call(this) || this;
        _this.blurBackground = blurBackground;
        _this.lockScroll = lockScroll;
        _this.closeOnClickAway = closeOnClickAway;
        _this.shutter = new $4wFdb.Shutter();
        _this.windowTitle = new $6wI3m.Ref("");
        _this.onBeforeCloseOrHideWindow = new $8PO3e.HandlersCollection();
        _this.onCloseOrHideWindow = new $8PO3e.HandlersCollection(); // close by pressing X or CloseWindow() call
        _this.onExitWindow = new $8PO3e.HandlersCollection(); // close by calling ExitWindow()
        _this.CloseButtonAction = function() {
            return _this.CloseWindow();
        };
        _this.CloseButton = new $5PIlt.Link("\xd7").NoDecorationOnHover().Class("tf-modal-window-close").OnClick(function() {
            return _this.CloseButtonAction();
        });
        _this.header = new $joGvE.Div().Class("tf-modal-window-header");
        _this.content = new $joGvE.Div().Class("tf-modal-window-content");
        _this.footer = new $joGvE.Div().Class("tf-modal-window-footer");
        _this.wasEverOpen = false;
        _this.Class(ModalWindow.DefaultCssClasses);
        _this.windowTitle.value = title instanceof $6wI3m.Ref ? title.value : title;
        return _this;
    }
    Object.defineProperty(ModalWindow.prototype, "Shutter", {
        get: function() {
            return this.shutter;
        },
        enumerable: false,
        configurable: true
    });
    ModalWindow.prototype.NoCloseButton = function() {
        this.CloseButton = null;
        return this;
    };
    ModalWindow.prototype.SetCloseButtonAction = function(handler) {
        this.CloseButtonAction = handler;
        return this;
    };
    ModalWindow.prototype.FullScreen = function() {
        return this.WidthPercent(100).HeightPercent(100);
    };
    ModalWindow.prototype.HideOnClose = function() {
        var _this = this;
        this.CloseButtonAction = function() {
            return _this.HideWindow();
        };
        return this;
    };
    ModalWindow.prototype.OpenWindow = function() {
        var _this = this;
        var _a, _b;
        this.Append(this.header.Append(new $joGvE.Div("tf-modal-window-header-title-section").Append(new $3B1VX.Text(this.windowTitle)), new $joGvE.Div("tf-modal-window-header-buttons-section").Append(this.CloseButton && this.CloseButton)), this.content, this.footer.HasAnyChildren && this.footer);
        if (this.blurBackground) (_a = (0, $iqyiC.$)(ModalWindow.Hook)) === null || _a === void 0 || _a.Append(this.shutter.Element);
        (_b = (0, $iqyiC.$)(ModalWindow.Hook)) === null || _b === void 0 || _b.Append(this.Element);
        if (this.lockScroll) this.LockPageScroll();
        if (this.closeOnClickAway) this.Shutter.OnClick(function() {
            return _this.CloseButtonAction();
        });
        return this;
    };
    ModalWindow.prototype.Title = function(title) {
        this.windowTitle.value = title;
        return this;
    };
    ModalWindow.prototype.CloseWindow = function(onClosePayload) {
        if (this.onBeforeCloseOrHideWindow.AreAny) {
            var allowClose = this.onBeforeCloseOrHideWindow.CallAndGatherReturnValue();
            if (allowClose.some(function(x) {
                return x == false;
            })) return this;
        }
        this.RemoveWindow();
        this.onCloseOrHideWindow.Call(onClosePayload);
        return this;
    };
    ModalWindow.prototype.RemoveWindow = function() {
        var _a, _b;
        this.Clear();
        try {
            (_a = (0, $iqyiC.$)(ModalWindow.Hook)) === null || _a === void 0 || _a.removeChild(this.Element);
            if (this.blurBackground) (_b = (0, $iqyiC.$)(ModalWindow.Hook)) === null || _b === void 0 || _b.removeChild(this.shutter.Element);
        } catch (ex) {
            throw new Error("[truffle] You are trying to remove element (that window) that is not a child of ".concat(ModalWindow.Hook, ". Make sure Root.Hook and ModalWindow.Root are the same. Remember to not attach ModalWindow to any other element with .Append(). Exception:"), ex);
        }
        if (this.lockScroll) this.UnlockPageScroll();
    };
    ModalWindow.prototype.ExitWindow = function(onExitPayload) {
        this.RemoveWindow();
        this.onExitWindow.Call(onExitPayload);
        return this;
    };
    ModalWindow.prototype.ShowWindow = function() {
        var _a;
        if (this.wasEverOpen == false) {
            this.OpenWindow();
            this.wasEverOpen = true;
        }
        (_a = (0, $iqyiC.$)(ModalWindow.Hook)) === null || _a === void 0 || _a.Append(this.shutter.Element);
        this.Show().ZIndex(100);
        return this;
    };
    ModalWindow.prototype.HideWindow = function() {
        var _a;
        if (this.blurBackground) (_a = (0, $iqyiC.$)(ModalWindow.Hook)) === null || _a === void 0 || _a.removeChild(this.shutter.Element);
        this.Hide();
        this.onCloseOrHideWindow.Call();
        if (this.lockScroll) this.UnlockPageScroll();
        return this;
    };
    ModalWindow.prototype.AddToHeader = function() {
        var _a;
        var elements = [];
        for(var _i = 0; _i < arguments.length; _i++)elements[_i] = arguments[_i];
        (_a = this.header).Append.apply(_a, elements);
        return this;
    };
    ModalWindow.prototype.AddContent = function() {
        var _a;
        var elements = [];
        for(var _i = 0; _i < arguments.length; _i++)elements[_i] = arguments[_i];
        (_a = this.content).Append.apply(_a, elements);
        return this;
    };
    ModalWindow.prototype.AddToFooter = function() {
        var _a;
        var elements = [];
        for(var _i = 0; _i < arguments.length; _i++)elements[_i] = arguments[_i];
        (_a = this.footer).Append.apply(_a, elements);
        return this;
    };
    ModalWindow.prototype.OnCloseWindow = function(handler) {
        this.onCloseOrHideWindow.Add(handler);
        return this;
    };
    ModalWindow.prototype.OnExitWindow = function(handler) {
        this.onExitWindow.Add(handler);
        return this;
    };
    ModalWindow.prototype.OnBeforeCloseWindow = function(handler) {
        this.onBeforeCloseOrHideWindow.Add(handler);
        return this;
    };
    ModalWindow.prototype.LockPageScroll = function() {
        document.body.classList.add("tf-stop-scrolling");
    };
    ModalWindow.prototype.UnlockPageScroll = function() {
        document.body.classList.remove("tf-stop-scrolling");
    };
    ModalWindow.Name = "ModalWindow";
    ModalWindow.DefaultCssClasses = "";
    ModalWindow.Hook = "body";
    return ModalWindow;
}($joGvE.Div);
module.exports.ModalWindow = $87b60a2f958f6b0a$var$ModalWindow;

});
parcelRegister("4wFdb", function(module, exports) {
"use strict";
var $34ba1e59762b223a$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Shutter = void 0;

var $joGvE = parcelRequire("joGvE");
var $34ba1e59762b223a$var$Shutter = /** @class */ function(_super) {
    $34ba1e59762b223a$var$__extends(Shutter, _super);
    function Shutter() {
        return _super.call(this, "tf-shutter") || this;
    }
    return Shutter;
}($joGvE.Div);
module.exports.Shutter = $34ba1e59762b223a$var$Shutter;

});


parcelRegister("fMKT6", function(module, exports) {
"use strict";
var $b7dfb5a097b9983d$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RadioSwitchesBuilder = void 0;

var $k6KGm = parcelRequire("k6KGm");
var $b7dfb5a097b9983d$var$RadioSwitchesBuilder = /** @class */ function(_super) {
    $b7dfb5a097b9983d$var$__extends(RadioSwitchesBuilder, _super);
    function RadioSwitchesBuilder(ref) {
        var _this = _super.call(this, "div", ref) || this;
        _this.switches = {};
        _this.classWhenActive = {};
        return _this;
    }
    RadioSwitchesBuilder.prototype.Refresh = function() {
        var _this = this;
        this.switches.Keys().forEach(function(activator) {
            var cmp = _this.switches[activator];
            var classWhenActive = _this.classWhenActive[activator];
            if (_this.ref.value === activator) cmp.AddClass(classWhenActive);
            else cmp.RemoveClass(classWhenActive);
        });
    };
    RadioSwitchesBuilder.prototype.AddSwitch = function(activator, cmp, cssClassWhenActive) {
        var _this = this;
        this.switches[activator] = cmp;
        this.classWhenActive[activator] = cssClassWhenActive;
        cmp.OnClick(function() {
            return _this.ref.value = activator;
        });
        if (this.ref.value == activator) cmp.AddClass(cssClassWhenActive);
        if (this.ref.value == "") this.ref.value = activator;
        this.Append(cmp);
        return this;
    };
    return RadioSwitchesBuilder;
}($k6KGm.RefComponentBase);
module.exports.RadioSwitchesBuilder = $b7dfb5a097b9983d$var$RadioSwitchesBuilder;

});

parcelRegister("a9HcF", function(module, exports) {
"use strict";
var $764c41ee5cf11ca2$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DestroyingContentSwitcher = void 0;

var $k6KGm = parcelRequire("k6KGm");
var $764c41ee5cf11ca2$var$DestroyingContentSwitcher = /** @class */ function(_super) {
    $764c41ee5cf11ca2$var$__extends(DestroyingContentSwitcher, _super);
    function DestroyingContentSwitcher(ref) {
        var _this = _super.call(this, "div", ref) || this;
        _this.contents = {};
        return _this;
    }
    DestroyingContentSwitcher.prototype.AddContent = function(activator, cmp) {
        var activatorKey = activator != null ? String(activator) : "";
        this.contents[activatorKey] = cmp;
        if (activator === this.ref.value) {
            var result = cmp();
            if (Array.isArray(result)) this.Append.apply(this, result);
            else this.Append(result);
        } else if (this.defaultContent) {
            // this.Append(this.defaultContent()) 
            var result = this.defaultContent();
            if (Array.isArray(result)) this.Append.apply(this, result);
            else this.Append(result);
        }
        return this;
    };
    DestroyingContentSwitcher.prototype.AddDefaultContent = function(cmp) {
        this.defaultContent = cmp;
        if (!this.contents.Keys().includes(this.ref.value != null ? String(this.ref.value) : "")) {
            // this.Append(cmp());
            var result = cmp();
            if (Array.isArray(result)) this.Append.apply(this, result);
            else this.Append(result);
        }
        return this;
    };
    DestroyingContentSwitcher.prototype.Refresh = function() {
        var _a, _b;
        var valueKey = this.ref.value != null ? String(this.ref.value) : "";
        var c = (_b = (_a = this.contents)[valueKey]) === null || _b === void 0 ? void 0 : _b.call(_a);
        this.Clear();
        if (c) {
            // this.Append(c);
            // const result = c;
            if (Array.isArray(c)) this.Append.apply(this, c);
            else this.Append(c);
        } else if (this.defaultContent) {
            // this.Append(this.defaultContent())
            var result = this.defaultContent();
            if (Array.isArray(result)) this.Append.apply(this, result);
            else this.Append(result);
        }
    };
    DestroyingContentSwitcher.Name = "DestroyingContentSwitcher";
    return DestroyingContentSwitcher;
}($k6KGm.RefComponentBase);
module.exports.DestroyingContentSwitcher = $764c41ee5cf11ca2$var$DestroyingContentSwitcher;

});

parcelRegister("3slAG", function(module, exports) {
"use strict";
var $2844bc1766a7ae91$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DestroyingPatternContentSwitcher = void 0;

var $k6KGm = parcelRequire("k6KGm");

var $3CTSE = parcelRequire("3CTSE");
var $2844bc1766a7ae91$var$DestroyingPatternContentSwitcher = /** @class */ function(_super) {
    $2844bc1766a7ae91$var$__extends(DestroyingPatternContentSwitcher, _super);
    function DestroyingPatternContentSwitcher(ref) {
        var _this = _super.call(this, "div", ref) || this;
        _this.contents = {}; // TODO: to jest słabe, trzeba by to wynieść do jakiejś osobnej klasy
        return _this;
    }
    DestroyingPatternContentSwitcher.prototype.AddContent = function(pattern, cmp) {
        this.contents[pattern] = cmp;
        // const extractor = new PatternExtractor(pattern);
        // const params = extractor.Extract(this.ref.value);
        // if (params == null) // a co jak mamy pattern bez parametrów? zwraca pusty obiekt? TAK!
        // {
        //     return this;
        // }
        // this.Append(cmp(params));
        return this;
    };
    DestroyingPatternContentSwitcher.prototype.AddDefaultContent = function(defaultCmp) {
        this.defaultContent = defaultCmp;
        if (!this.IsRefOneOfPatterns()) this.Append(defaultCmp());
        return this;
    };
    DestroyingPatternContentSwitcher.prototype.IsRefOneOfPatterns = function() {
        for(var _i = 0, _a = this.contents.Keys(); _i < _a.length; _i++){
            var pattern = _a[_i];
            var extractor = new $3CTSE.PatternExtractor(pattern);
            var params = extractor.Extract(this.ref.value);
            if (params != null) return true;
        }
        return false;
    };
    DestroyingPatternContentSwitcher.prototype.FindPatternAndParams = function() {
        for(var _i = 0, _a = this.contents.Keys(); _i < _a.length; _i++){
            var pattern = _a[_i];
            var extractor = new $3CTSE.PatternExtractor(pattern);
            var params = extractor.Extract(this.ref.value);
            if (params != null) return {
                found: true,
                pattern: pattern,
                params: params
            };
        }
        return {
            found: false,
            pattern: null,
            params: null
        };
    };
    DestroyingPatternContentSwitcher.prototype.Refresh = function() {
        this.Clear();
        var searchResult = this.FindPatternAndParams();
        if (searchResult.found) this.Append(this.contents[searchResult.pattern](searchResult.params));
        else if (this.defaultContent) this.Append(this.defaultContent());
        return this;
    };
    DestroyingPatternContentSwitcher.Name = "DestroyingPatternContentSwitcher";
    return DestroyingPatternContentSwitcher;
}($k6KGm.RefComponentBase);
module.exports.DestroyingPatternContentSwitcher = $2844bc1766a7ae91$var$DestroyingPatternContentSwitcher;

});

parcelRegister("4yfSX", function(module, exports) {
"use strict";
var $3506a8e7090cd5f2$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HidingContentSwitcher = void 0;

var $k6KGm = parcelRequire("k6KGm");
var $3506a8e7090cd5f2$var$HidingContentSwitcher = /** @class */ function(_super) {
    $3506a8e7090cd5f2$var$__extends(HidingContentSwitcher, _super);
    function HidingContentSwitcher(ref) {
        var _this = _super.call(this, "div", ref) || this;
        _this.contents = {};
        _this.showAses = {};
        _this.defaultContentShowAs = "";
        return _this;
    }
    HidingContentSwitcher.prototype.AddContent = function(activator, cmp, showAs) {
        var activatorKey = activator != null ? String(activator) : "";
        this.contents[activatorKey] = cmp();
        this.showAses[activatorKey] = showAs || "";
        if (activator === this.ref.value) this.Append(this.contents[activatorKey]);
        return this;
    };
    HidingContentSwitcher.prototype.AddDefaultContent = function(cmp, showAs) {
        this.defaultContent = cmp();
        this.defaultContentShowAs = showAs || "";
        if (!this.IsOneOfTheContents()) this.Append(this.defaultContent);
        return this;
    };
    HidingContentSwitcher.prototype.IsOneOfTheContents = function() {
        return this.contents.Keys().includes(this.ref.value != null ? String(this.ref.value) : "");
    };
    HidingContentSwitcher.prototype.Refresh = function() {
        var _a, _b;
        this.contents.Values().forEach(function(x) {
            return x.Hide();
        });
        var valueKey = this.ref.value != null ? String(this.ref.value) : "";
        var newContent = this.contents[valueKey];
        if (newContent) {
            (_a = this.defaultContent) === null || _a === void 0 || _a.Hide();
            if (!this.Exist(newContent)) this.Append(newContent);
            newContent.Show(this.showAses[valueKey]);
        } else {
            if (this.defaultContent && !this.Exist(this.defaultContent)) this.Append(this.defaultContent);
            (_b = this.defaultContent) === null || _b === void 0 || _b.Show(this.defaultContentShowAs);
        }
    };
    HidingContentSwitcher.Name = "HidingContentSwitcher";
    return HidingContentSwitcher;
}($k6KGm.RefComponentBase);
module.exports.HidingContentSwitcher = $3506a8e7090cd5f2$var$HidingContentSwitcher;

});

parcelRegister("3700g", function(module, exports) {
"use strict";
var $2442072dd1bbd50e$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Tabs = module.exports.TabsSwitcher = module.exports.ButtonTabs = void 0;

var $6wI3m = parcelRequire("6wI3m");

var $k6KGm = parcelRequire("k6KGm");

var $joGvE = parcelRequire("joGvE");

var $2S24U = parcelRequire("2S24U");

var $5PIlt = parcelRequire("5PIlt");

var $2MZa4 = parcelRequire("2MZa4");

var $a9HcF = parcelRequire("a9HcF");

var $fMKT6 = parcelRequire("fMKT6");
var $2442072dd1bbd50e$var$ButtonTabs = /** @class */ function(_super) {
    $2442072dd1bbd50e$var$__extends(ButtonTabs, _super);
    function ButtonTabs(ref) {
        if (ref === void 0) ref = new $6wI3m.Ref("");
        var _this = _super.call(this) || this;
        _this.ref = ref;
        _this.switches = new $fMKT6.RadioSwitchesBuilder(_this.ref);
        _this.content = new $a9HcF.DestroyingContentSwitcher(_this.ref);
        _this.Append(_this.switches, _this.content);
        return _this;
    }
    ButtonTabs.prototype.Add = function(label, content) {
        this.switches.AddSwitch(label, new $2S24U.Button(label), "uk-button-danger");
        this.content.AddContent(label, content);
        return this;
    };
    return ButtonTabs;
}($joGvE.Div);
module.exports.ButtonTabs = $2442072dd1bbd50e$var$ButtonTabs;
var $2442072dd1bbd50e$var$TabsSwitcher = /** @class */ function(_super) {
    $2442072dd1bbd50e$var$__extends(TabsSwitcher, _super);
    function TabsSwitcher(ref) {
        var _this = _super.call(this, "ul", ref) || this;
        _this.switches = {};
        _this.Attribute("uk-tab");
        _this.Class("uk-tab");
        return _this;
    }
    TabsSwitcher.prototype.Refresh = function() {
        var _this = this;
        this.switches.Keys().forEach(function(activator) {
            var cmp = _this.switches[activator];
            if (_this.ref.value === activator) cmp.AddClass("uk-active");
            else cmp.RemoveClass("uk-active");
        });
    };
    TabsSwitcher.prototype.Add = function(label) {
        var _this = this;
        var item = new $2MZa4.ListItem(new $5PIlt.Link(label, "#"));
        this.switches[label] = item;
        item.OnClick(function() {
            return _this.ref.value = label;
        });
        if (this.ref.value == label) item.AddClass("uk-active");
        if (this.ref.value == "") this.ref.value = label;
        this.Append(item);
        return this;
    };
    return TabsSwitcher;
}($k6KGm.RefComponentBase);
module.exports.TabsSwitcher = $2442072dd1bbd50e$var$TabsSwitcher;
var $2442072dd1bbd50e$var$Tabs = /** @class */ function(_super) {
    $2442072dd1bbd50e$var$__extends(Tabs, _super);
    function Tabs(ref) {
        if (ref === void 0) ref = new $6wI3m.Ref("");
        var _this = _super.call(this) || this;
        _this.ref = ref;
        _this.switches = new $2442072dd1bbd50e$var$TabsSwitcher(_this.ref);
        _this.content = new $a9HcF.DestroyingContentSwitcher(_this.ref);
        _this.Append(_this.switches, _this.content);
        return _this;
    }
    Tabs.prototype.Add = function(label, content) {
        this.switches.Add(label);
        this.content.AddContent(label, content);
        return this;
    };
    return Tabs;
}($joGvE.Div);
module.exports.Tabs = $2442072dd1bbd50e$var$Tabs;

});

parcelRegister("fhrT0", function(module, exports) {
"use strict";
var $b1fe132ae5518be4$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VerticalButtonTabs = void 0;

var $2S24U = parcelRequire("2S24U");

var $1h8RE = parcelRequire("1h8RE");

var $a9HcF = parcelRequire("a9HcF");

var $6wI3m = parcelRequire("6wI3m");

var $fMKT6 = parcelRequire("fMKT6");
var $b1fe132ae5518be4$var$VerticalButtonTabs = /** @class */ function(_super) {
    $b1fe132ae5518be4$var$__extends(VerticalButtonTabs, _super);
    function VerticalButtonTabs(ref) {
        if (ref === void 0) ref = new $6wI3m.Ref("");
        var _this = _super.call(this) || this;
        _this.ref = ref;
        _this.switcher = new $fMKT6.RadioSwitchesBuilder(_this.ref);
        _this.contentSwitcher = new $a9HcF.DestroyingContentSwitcher(_this.ref);
        _this.useActivator = function(label) {
            return new $2S24U.Button(label);
        };
        _this.LeftColumn.Append(_this.switcher);
        _this.RightColumn.Append(_this.contentSwitcher);
        return _this;
    }
    VerticalButtonTabs.prototype.Add = function(label, content) {
        this.switcher.AddSwitch(label, this.useActivator(label), "uk-button-danger");
        this.contentSwitcher.AddContent(label, content);
        return this;
    };
    VerticalButtonTabs.prototype.UseActivator = function(fn) {
        this.useActivator = fn;
        return this;
    };
    return VerticalButtonTabs;
}($1h8RE.AutoWidthTwoColumns);
module.exports.VerticalButtonTabs = $b1fe132ae5518be4$var$VerticalButtonTabs;

});

parcelRegister("4YE9f", function(module, exports) {
"use strict";
var $39fbe89ec484fc7d$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Led = module.exports.BlinkMode = void 0;

var $joGvE = parcelRequire("joGvE");
var $39fbe89ec484fc7d$var$BlinkMode;
(function(BlinkMode) {
    BlinkMode["Blink"] = "Blink";
    BlinkMode["LightUp"] = "Flash";
    BlinkMode["Both"] = "Both";
})($39fbe89ec484fc7d$var$BlinkMode || (module.exports.BlinkMode = $39fbe89ec484fc7d$var$BlinkMode = {}));
var $39fbe89ec484fc7d$var$Led = /** @class */ function(_super) {
    $39fbe89ec484fc7d$var$__extends(Led, _super);
    function Led(color) {
        if (color === void 0) color = Led.White;
        var _this = _super.call(this, "led") || this;
        _this.previousColor = Led.White;
        _this.currentColor = Led.White;
        _this.blinkTimer = null;
        _this.lightUpTimer = null;
        _this.SetColor(color);
        _this.NoShadow(color);
        return _this;
    }
    Led.prototype.LightUpShadow = function(color) {
        this.Style("box-shadow: 0 0 6px 2px ".concat(color));
    };
    Led.prototype.NoShadow = function(color) {
        this.Style("box-shadow: 0 0 2px 1px ".concat(color));
    };
    Led.prototype.SetColor = function(color) {
        this.previousColor = this.currentColor;
        this.currentColor = color;
        this.Background(color);
        if (color == Led.White) this.Style("border: 1px solid #d8d8d8");
        else this.Style("border: none");
        return this;
    };
    Led.prototype.PreviousColor = function() {
        this.SetColor(this.previousColor);
        return this;
    };
    Led.prototype.LightUp = function(color, duration) {
        var _this = this;
        if (color === void 0) color = this.currentColor;
        if (duration === void 0) duration = 0;
        this.SetColor(color);
        this.LightUpShadow(color);
        this.lightUpTimer && clearTimeout(this.lightUpTimer);
        if (duration > 0) this.lightUpTimer = setTimeout(function() {
            return _this.NoShadow(color);
        }, duration);
        return this;
    };
    Led.prototype.Blink = function(color, interval, mode) {
        var _this = this;
        if (color === void 0) color = this.currentColor;
        if (interval === void 0) interval = 1000;
        if (mode === void 0) mode = $39fbe89ec484fc7d$var$BlinkMode.Blink;
        this.SetColor(color);
        var counter = 0;
        this.blinkTimer && clearInterval(this.blinkTimer);
        if (interval > 0) this.blinkTimer = setInterval(function() {
            if (counter = 1 - counter) switch(mode){
                case $39fbe89ec484fc7d$var$BlinkMode.Blink:
                    _this.SetColor(color);
                    _this.NoShadow(color);
                    break;
                case $39fbe89ec484fc7d$var$BlinkMode.LightUp:
                    _this.LightUpShadow(color);
                    break;
                case $39fbe89ec484fc7d$var$BlinkMode.Both:
                    _this.SetColor(color);
                    _this.LightUpShadow(color);
                    break;
            }
            else switch(mode){
                case $39fbe89ec484fc7d$var$BlinkMode.Blink:
                    _this.SetColor(Led.White);
                    _this.NoShadow(Led.White);
                    break;
                case $39fbe89ec484fc7d$var$BlinkMode.LightUp:
                    _this.NoShadow(color);
                    break;
                case $39fbe89ec484fc7d$var$BlinkMode.Both:
                    _this.SetColor(Led.White);
                    _this.NoShadow(Led.White);
                    break;
            }
        }, interval);
        return this;
    };
    Led.prototype.Destroy = function() {
        this.blinkTimer && clearInterval(this.blinkTimer);
        this.lightUpTimer && clearInterval(this.lightUpTimer);
    };
    Led.Name = "Led";
    Led.Green = "#00e100";
    Led.Yellow = "#ffc107";
    Led.Red = "#f44336";
    Led.White = "#fff";
    Led.Blue = "#007bff";
    Led.Gray = "#c8c8c8";
    Led.Black = "#000";
    Led.Brown = "#8b4513";
    Led.Purple = "#9c27b0";
    Led.Pink = "#e91e63";
    Led.Orange = "#ff9800";
    return Led;
}($joGvE.Div);
module.exports.Led = $39fbe89ec484fc7d$var$Led;

});

parcelRegister("1bL1j", function(module, exports) {
"use strict";
var $0ddb4aba3c249cfe$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ProgressBar = void 0;

var $joGvE = parcelRequire("joGvE");

var $k6KGm = parcelRequire("k6KGm");
var $0ddb4aba3c249cfe$var$ProgressBar = /** @class */ function(_super) {
    $0ddb4aba3c249cfe$var$__extends(ProgressBar, _super);
    function ProgressBar(value, color) {
        if (color === void 0) color = "#f0506e";
        var _this = _super.call(this, "div", value) || this;
        _this.bar = new $joGvE.Div().HeightPercent(100);
        _this.Style("width: 100%; height: 2px; background-color: transparent; border: none;");
        _this.bar.Background(color);
        _this.Append(_this.bar);
        _this.Refresh();
        return _this;
    }
    ProgressBar.prototype.Invert = function() {
        this.bar.FloatRight();
        return this;
    };
    ProgressBar.prototype.Refresh = function() {
        this.bar.WidthPercent(this.ref.value);
    };
    ProgressBar.Name = "ProgressBar";
    return ProgressBar;
}($k6KGm.RefComponentBase);
module.exports.ProgressBar = $0ddb4aba3c249cfe$var$ProgressBar;

});

parcelRegister("8BrJA", function(module, exports) {
"use strict";
var $64374ae64cd84fe1$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TableBuilder = void 0;

var $2s69t = parcelRequire("2s69t");

var $8y6Fd = parcelRequire("8y6Fd");

var $1lIsG = parcelRequire("1lIsG");

var $pCapU = parcelRequire("pCapU");

var $cUBMo = parcelRequire("cUBMo");

var $1lG8E = parcelRequire("1lG8E");

var $7Fc9Q = parcelRequire("7Fc9Q");

var $3lnvs = parcelRequire("3lnvs");
var $64374ae64cd84fe1$var$TableBuilder = /** @class */ function(_super) {
    $64374ae64cd84fe1$var$__extends(TableBuilder, _super);
    function TableBuilder(data) {
        var _a;
        var _this = _super.call(this) || this;
        _this.columns = [];
        _this.body = new $1lIsG.TableBody();
        _this.whenEmpty = new $2s69t.Span("No results").Style("display: block; margin: 48px 0; text-align: center; white-space: nowrap;");
        if (data && data instanceof Array) _this.dataView = new $8y6Fd.CollectionView(new $2s69t.Collection(data)).Refresh();
        else if (data && data instanceof $2s69t.Collection) _this.dataView = new $8y6Fd.CollectionView(data).Refresh();
        else if (data && data instanceof $8y6Fd.CollectionView) _this.dataView = data;
        _this.Class(TableBuilder.DefaultCssClasses);
        (_a = _this.dataView) === null || _a === void 0 || _a.AddSubscriber(_this);
        return _this;
    }
    TableBuilder.prototype.Reset = function() {
        this.columns = [];
        this.Clear();
        return this;
    };
    TableBuilder.prototype.WhenEmpty = function(component) {
        this.whenEmpty = component;
        return this;
    };
    TableBuilder.prototype.Refresh = function() {
        var _this = this;
        var _a, _b, _c, _d;
        this.body.Clear();
        if (((_b = (_a = this.dataView) === null || _a === void 0 ? void 0 : _a.Items) === null || _b === void 0 ? void 0 : _b.length) === 0) this.body.Append(new $cUBMo.TableRow().Append(new $pCapU.TableCell().Merge(this.columns.length).Append(this.whenEmpty)));
        else (_d = (_c = this === null || this === void 0 ? void 0 : this.dataView) === null || _c === void 0 ? void 0 : _c.Items) === null || _d === void 0 || _d.forEach(function(record) {
            var _a;
            var row = new $cUBMo.TableRow();
            (_a = _this.eachRowHandler) === null || _a === void 0 || _a.call(_this, row, record);
            _this.columns.forEach(function(c) {
                if (c.AddWhen && !c.AddWhen(record)) {
                    // Add empty cell
                    var cell_1 = new $pCapU.TableCell();
                    row.Append(cell_1);
                    return;
                }
                var cell = new $pCapU.TableCell();
                var elem = c.Mapping(record, row, cell, _this.body, _this);
                var m;
                if (!Array.isArray(elem)) m = [
                    elem
                ];
                else m = elem;
                m.forEach(function(e) {
                    cell.Append(e);
                });
                row.Append(cell);
            });
            _this.body.Append(row);
        });
    };
    TableBuilder.prototype.Build = function() {
        this.Append(new $3lnvs.TableHeaderV2(this.columns.map(function(x) {
            return x.Headers;
        })));
        this.Refresh();
        this.Append(this.body);
        return this;
    };
    TableBuilder.prototype.AddColumn = function(headers, mapping, addWhen) {
        if (!Array.isArray(headers)) headers = [
            headers
        ];
        this.columns.push(new $7Fc9Q.TableColumn(headers, mapping, addWhen));
        return this;
    };
    TableBuilder.prototype.ForEachRow = function(handler) {
        this.eachRowHandler = handler;
        return this;
    };
    TableBuilder.Name = "TableBuilder";
    TableBuilder.DefaultCssClasses = "uk-table uk-table-small uk-table-divider uk-table-middle";
    return TableBuilder;
}($1lG8E.Table);
module.exports.TableBuilder = $64374ae64cd84fe1$var$TableBuilder;

});
parcelRegister("1lIsG", function(module, exports) {
"use strict";
var $0fba3dc739fa3f8a$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TableBody = void 0;

var $aKtiT = parcelRequire("aKtiT");
var $0fba3dc739fa3f8a$var$TableBody = /** @class */ function(_super) {
    $0fba3dc739fa3f8a$var$__extends(TableBody, _super); // TODO: no type for tbody?
    function TableBody() {
        return _super.call(this, "tbody") || this;
    }
    return TableBody;
}($aKtiT.ComponentBase);
module.exports.TableBody = $0fba3dc739fa3f8a$var$TableBody;

});

parcelRegister("pCapU", function(module, exports) {
"use strict";
var $04cff1167b76a41a$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TableCell = void 0;

var $aKtiT = parcelRequire("aKtiT");
var $04cff1167b76a41a$var$TableCell = /** @class */ function(_super) {
    $04cff1167b76a41a$var$__extends(TableCell, _super);
    function TableCell(content) {
        var _this = _super.call(this, "td") || this;
        if (!content) return _this;
        if (typeof content == "string") _this.element.innerText = content;
        else _this.Append(content);
        return _this;
    }
    TableCell.prototype.Merge = function(cellsOnRightCount) {
        this.Attribute("colspan", cellsOnRightCount.toString());
        return this;
    };
    return TableCell;
}($aKtiT.ComponentBase);
module.exports.TableCell = $04cff1167b76a41a$var$TableCell;

});

parcelRegister("cUBMo", function(module, exports) {
"use strict";
var $9668053d81ade9f5$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TableRow = void 0;

var $aKtiT = parcelRequire("aKtiT");

var $pCapU = parcelRequire("pCapU");
var $9668053d81ade9f5$var$TableRow = /** @class */ function(_super) {
    $9668053d81ade9f5$var$__extends(TableRow, _super);
    function TableRow() {
        return _super.call(this, "tr") || this;
    }
    TableRow.prototype.AddCells = function() {
        var _this = this;
        var cells = [];
        for(var _i = 0; _i < arguments.length; _i++)cells[_i] = arguments[_i];
        cells.forEach(function(c) {
            return _this.Append(new $pCapU.TableCell(c));
        });
        return this;
    };
    return TableRow;
}($aKtiT.ComponentBase);
module.exports.TableRow = $9668053d81ade9f5$var$TableRow;

});

parcelRegister("1lG8E", function(module, exports) {
"use strict";
var $0fb87073a0d55a2d$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Table = void 0;

var $2s69t = parcelRequire("2s69t");
var $0fb87073a0d55a2d$var$Table = /** @class */ function(_super) {
    $0fb87073a0d55a2d$var$__extends(Table, _super);
    function Table(headers, body) {
        var _this = _super.call(this, "table") || this;
        _this.Class(Table.DefaultCssClasses);
        if (headers) _this.AddHeaders.apply(_this, headers);
        if (body) body.forEach(function(row) {
            return _this.AddRow.apply(_this, row);
        });
        return _this;
    }
    Table.prototype.AddHeaders = function() {
        var headers = [];
        for(var _i = 0; _i < arguments.length; _i++)headers[_i] = arguments[_i];
        this.Append(new $2s69t.TableHeader(headers));
        return this;
    };
    Table.prototype.AddRow = function() {
        var _a;
        var cells = [];
        for(var _i = 0; _i < arguments.length; _i++)cells[_i] = arguments[_i];
        this.Append((_a = new $2s69t.TableRow()).AddCells.apply(_a, cells));
        return this;
    };
    Table.Name = "Table";
    Table.DefaultCssClasses = "";
    return Table;
}($2s69t.ComponentBase);
module.exports.Table = $0fb87073a0d55a2d$var$Table;

});

parcelRegister("7Fc9Q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TableColumn = void 0;
var $5945cb0a69213503$var$TableColumn = /** @class */ function() {
    function TableColumn(Headers, Mapping, AddWhen) {
        this.Headers = Headers;
        this.Mapping = Mapping;
        this.AddWhen = AddWhen;
    }
    return TableColumn;
}();
module.exports.TableColumn = $5945cb0a69213503$var$TableColumn;

});

parcelRegister("3lnvs", function(module, exports) {
"use strict";
var $26f591266fc43a13$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TableHeaderV2 = void 0;

var $2s69t = parcelRequire("2s69t");
var $26f591266fc43a13$var$TableHeaderV2 = /** @class */ function(_super) {
    $26f591266fc43a13$var$__extends(TableHeaderV2, _super);
    function TableHeaderV2(columnsHeaders) {
        var _this = _super.call(this, "thead") || this;
        var maxRows = Math.max.apply(Math, columnsHeaders.map(function(hs) {
            return hs.length;
        }));
        var _loop_1 = function(rowIndex) {
            var cells = columnsHeaders.map(function(x) {
                return x[rowIndex];
            });
            this_1.Append(new $2s69t.TableHeaderRow(cells));
        };
        var this_1 = this;
        for(var rowIndex = 0; rowIndex < maxRows; rowIndex++)_loop_1(rowIndex);
        return _this;
    }
    return TableHeaderV2;
}($2s69t.ComponentBase);
module.exports.TableHeaderV2 = $26f591266fc43a13$var$TableHeaderV2;

});


parcelRegister("bdjAM", function(module, exports) {
"use strict";
var $82a01b3c4a454fc0$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TableHeader = void 0;

var $aKtiT = parcelRequire("aKtiT");

var $dLmKH = parcelRequire("dLmKH");
var $82a01b3c4a454fc0$var$TableHeader = /** @class */ function(_super) {
    $82a01b3c4a454fc0$var$__extends(TableHeader, _super);
    function TableHeader(headers) {
        var _this = _super.call(this, "thead") || this;
        if (headers) _this.Append(new $dLmKH.TableHeaderRow(headers));
        return _this;
    }
    return TableHeader;
}($aKtiT.ComponentBase);
module.exports.TableHeader = $82a01b3c4a454fc0$var$TableHeader;

});
parcelRegister("dLmKH", function(module, exports) {
"use strict";
var $a05150494376724d$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TableHeaderRow = void 0;

var $aKtiT = parcelRequire("aKtiT");

var $kWKxK = parcelRequire("kWKxK");
var $a05150494376724d$var$TableHeaderRow = /** @class */ function(_super) {
    $a05150494376724d$var$__extends(TableHeaderRow, _super);
    function TableHeaderRow(strings) {
        var _this = _super.call(this, "tr") || this;
        strings.forEach(function(str) {
            _this.Append(new $kWKxK.TableHeaderCell(str));
        });
        return _this;
    }
    return TableHeaderRow;
}($aKtiT.ComponentBase);
module.exports.TableHeaderRow = $a05150494376724d$var$TableHeaderRow;

});
parcelRegister("kWKxK", function(module, exports) {
"use strict";
var $f3fd53f403c219a2$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TableHeaderCell = void 0;

var $aKtiT = parcelRequire("aKtiT");
var $f3fd53f403c219a2$var$TableHeaderCell = /** @class */ function(_super) {
    $f3fd53f403c219a2$var$__extends(TableHeaderCell, _super);
    function TableHeaderCell(element) {
        var _this = _super.call(this, "th") || this;
        if (!element) return _this;
        if (typeof element == "string") _this.Text(element);
        else _this.Append(element);
        return _this;
    }
    return TableHeaderCell;
}($aKtiT.ComponentBase);
module.exports.TableHeaderCell = $f3fd53f403c219a2$var$TableHeaderCell;

});



parcelRegister("2ZZKK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.JsonViewerConfig = void 0;
var $22f12e1fe2753cc2$var$JsonViewerConfig = /** @class */ function() {
    function JsonViewerConfig() {
        this.foldAll = true;
        this.foldSymbol = "\u2795";
        this.unfoldSymbol = "\u2796";
        this.keyPrinter = function(key, objType) {
            return "\u25FE " + key + ":";
        };
        this.arrayKeyPrinter = function(index, objType) {
            return "#" + index;
        };
        this.keyStyle = "color: #222";
        this.nullStyle = "color: #ff7f96";
        this.stringStyle = "color: green";
        this.numberStyle = "color: blue";
        this.boolStyle = "color: violet";
        this.typePrinter = function(t) {
            return "(" + t + ")";
        };
        this.typeInfoStyle = "color: #aaa; font-style: italic;";
        this.maxStringLength = 100;
        this.indent = 22;
        this.showCopyIcon = true;
        this.copyValueIcon = "\uD83D\uDCCB";
        this.openLinkButton = "\uD83C\uDF10";
        this.markedColor = "yellow";
    }
    return JsonViewerConfig;
}();
module.exports.JsonViewerConfig = $22f12e1fe2753cc2$var$JsonViewerConfig;

});

parcelRegister("eBKPc", function(module, exports) {
"use strict";
var $aa28d7d45cf2f7d2$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $aa28d7d45cf2f7d2$var$__assign = module.exports && module.exports.__assign || function() {
    $aa28d7d45cf2f7d2$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $aa28d7d45cf2f7d2$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.JsonViewer = module.exports.RefJsonViewer = void 0;

var $hPtm1 = parcelRequire("hPtm1");

var $5PIlt = parcelRequire("5PIlt");

var $8UMl5 = parcelRequire("8UMl5");

var $joGvE = parcelRequire("joGvE");

var $2ZZKK = parcelRequire("2ZZKK");

var $gkD0R = parcelRequire("gkD0R");
var $aa28d7d45cf2f7d2$var$RefJsonViewer = /** @class */ function(_super) {
    $aa28d7d45cf2f7d2$var$__extends(RefJsonViewer, _super);
    function RefJsonViewer(objAsString, config) {
        var _this = _super.call(this) || this;
        objAsString.OnChange(function(x) {
            var ob;
            try {
                ob = JSON.parse(x);
            } catch (ex) {
                return;
            }
            _this.Clear().Append(new $aa28d7d45cf2f7d2$var$JsonViewer(ob, undefined, config));
        }, true);
        return _this;
    }
    return RefJsonViewer;
}($joGvE.Div);
module.exports.RefJsonViewer = $aa28d7d45cf2f7d2$var$RefJsonViewer;
var $aa28d7d45cf2f7d2$var$ValuePrinter = /** @class */ function(_super) {
    $aa28d7d45cf2f7d2$var$__extends(ValuePrinter, _super);
    function ValuePrinter(value, style, config) {
        var _this = _super.call(this, value) || this;
        _this.config = config;
        _this.Margin(8).MarginLeft(0).Style(style).CursorPointer().OnClick(function(self) {
            return _this.Mark(self);
        });
        return _this;
    }
    ValuePrinter.prototype.Mark = function(element) {
        element.ToggleStyle("background-color", this.config.markedColor, "transparent");
    };
    return ValuePrinter;
}($gkD0R.Span);
var $aa28d7d45cf2f7d2$var$ValueTypePrinter = /** @class */ function(_super) {
    $aa28d7d45cf2f7d2$var$__extends(ValueTypePrinter, _super);
    function ValueTypePrinter(type, config) {
        var _this = _super.call(this, config.typePrinter(type)) || this;
        _this.config = config;
        _this.CursorPointer().Style(config.typeInfoStyle).OnClick(function(self) {
            return _this.Mark(self);
        });
        return _this;
    }
    ValueTypePrinter.prototype.Mark = function(element) {
        element.ToggleStyle("background-color", this.config.markedColor, "transparent");
    };
    return ValueTypePrinter;
}($gkD0R.Span);
var $aa28d7d45cf2f7d2$var$JsonViewer = /** @class */ function(_super) {
    $aa28d7d45cf2f7d2$var$__extends(JsonViewer, _super);
    function JsonViewer(obj, key, config) {
        if (key === void 0) key = "";
        var _this = _super.call(this) || this;
        _this.config = config;
        _this.Config = new $2ZZKK.JsonViewerConfig();
        _this.Config = $aa28d7d45cf2f7d2$var$__assign($aa28d7d45cf2f7d2$var$__assign({}, _this.Config), _this.config);
        var tk = new $hPtm1.TwoFloatingColumns();
        var objType = typeof obj;
        if (key) tk.LeftColumn.Append(new $gkD0R.Span(_this.Config.keyPrinter(key, objType)).FloatLeft().MarginRight(6).Style(_this.Config.keyStyle).CursorPointer().OnClick(function(_) {
            return _.ToggleStyle("background-color", _this.Config.markedColor, "transparent");
        }));
        if (obj === null) tk.RightColumn.Append(new $aa28d7d45cf2f7d2$var$ValuePrinter("null", _this.Config.nullStyle, _this.Config), new $aa28d7d45cf2f7d2$var$ValueTypePrinter("null", _this.Config));
        else if (objType === "string") {
            var str = void 0;
            if (obj.length > _this.Config.maxStringLength) str = "\"".concat(obj.slice(0, _this.Config.maxStringLength), ".....\"");
            else str = "\"".concat(obj, "\"");
            var isLink = obj.startsWith("http");
            var printer = new $aa28d7d45cf2f7d2$var$ValuePrinter(str, _this.Config.stringStyle, _this.Config);
            // if (isLink)
            // {
            //     printer.OnHover(_=>_.Style("text-decoration: underline"))
            //         .OnMouseOut(_=>_.Style("text-decoration: none"))
            // }
            tk.RightColumn.Append(printer);
            tk.RightColumn.Append(new $aa28d7d45cf2f7d2$var$ValueTypePrinter("".concat(obj.length, " char").concat(obj.length > 1 ? "s" : "", " string"), _this.Config), _this.Config.showCopyIcon && new $8UMl5.CopyIcon(obj, _this.Config.copyValueIcon), isLink && new $5PIlt.Link(_this.Config.openLinkButton, obj).MarginLeft(4).NoDecorationOnHover().OpenInNewCard());
        } else if (objType === "number") tk.RightColumn.Append(new $aa28d7d45cf2f7d2$var$ValuePrinter(obj.toString(), _this.Config.numberStyle, _this.Config), new $aa28d7d45cf2f7d2$var$ValueTypePrinter('number', _this.Config), _this.Config.showCopyIcon && new $8UMl5.CopyIcon(obj.toString(), _this.Config.copyValueIcon));
        else if (objType === "boolean") tk.RightColumn.Append(new $aa28d7d45cf2f7d2$var$ValuePrinter(obj ? "true" : "false", _this.Config.boolStyle, _this.Config), new $aa28d7d45cf2f7d2$var$ValueTypePrinter('boolean', _this.Config));
        else if (Array.isArray(obj)) {
            if (obj.length === 0) tk.RightColumn.Append(new $aa28d7d45cf2f7d2$var$ValuePrinter("[ ]", "", _this.Config), new $aa28d7d45cf2f7d2$var$ValueTypePrinter("empty array", _this.Config));
            else {
                var foldButton_1 = new $5PIlt.Link(_this.Config.foldSymbol).NoDecorationOnHover().MarginLeft(4).MarginRight(4).CursorPointer().OnClick(function() {
                    foldButton_1.Text(tk.RightColumn.IsVisible() ? _this.Config.foldSymbol : _this.Config.unfoldSymbol);
                    tk.RightColumn.Toggle();
                });
                tk.LeftColumn.Append(new $aa28d7d45cf2f7d2$var$ValueTypePrinter("array of ".concat(obj.length, " ").concat(_this.GetType(obj[0])).concat(obj.length > 1 ? "s" : ""), _this.Config), foldButton_1);
                if (_this.Config.foldAll) {
                    tk.RightColumn.Hide();
                    foldButton_1.Text(_this.Config.foldSymbol);
                } else {
                    tk.RightColumn.Show();
                    foldButton_1.Text(_this.Config.unfoldSymbol);
                }
                tk.LeftColumn.WidthPercent(100);
                tk.RightColumn.MarginLeft(_this.Config.indent);
                obj.forEach(function(e, i) {
                    return tk.RightColumn.Append(new JsonViewer(e, _this.Config.arrayKeyPrinter(i.toString(), typeof e), _this.config));
                });
            }
        } else if (objType === "object") {
            var keys = Object.keys(obj);
            if (keys.length === 0) tk.RightColumn.Append(new $aa28d7d45cf2f7d2$var$ValuePrinter("{ }", "", _this.Config), new $aa28d7d45cf2f7d2$var$ValueTypePrinter("empty object", _this.Config));
            else {
                if (key) {
                    var foldButton_2 = new $5PIlt.Link(_this.Config.foldSymbol).NoDecorationOnHover().MarginLeft(4).MarginRight(4).CursorPointer().OnClick(function() {
                        foldButton_2.Text(tk.RightColumn.IsVisible() ? _this.Config.foldSymbol : _this.Config.unfoldSymbol);
                        tk.RightColumn.Toggle();
                    });
                    tk.LeftColumn.Append(new $aa28d7d45cf2f7d2$var$ValueTypePrinter("".concat(keys.length, " field").concat(keys.length > 1 ? "s" : "", " object"), _this.Config), foldButton_2);
                    tk.LeftColumn.WidthPercent(100);
                    tk.RightColumn.MarginLeft(_this.Config.indent);
                    if (_this.Config.foldAll) {
                        tk.RightColumn.Hide();
                        foldButton_2.Text(_this.Config.foldSymbol);
                    } else {
                        tk.RightColumn.Show();
                        foldButton_2.Text(_this.Config.unfoldSymbol);
                    }
                }
                keys.forEach(function(k) {
                    var v = obj[k];
                    tk.RightColumn.Append(new JsonViewer(v, k, _this.config));
                });
            }
        }
        _this.Append(tk);
        _this.Append(new $joGvE.Div().ClearBoth());
        return _this;
    }
    JsonViewer.prototype.GetType = function(obj) {
        var objType = typeof obj;
        var isArray = Array.isArray(obj);
        if (isArray && obj.length > 0) return "array of ".concat(this.GetType(obj[0]), "s");
        else if (isArray) return "array";
        else return objType;
    };
    JsonViewer.Name = "JsonViewer";
    return JsonViewer;
}($joGvE.Div);
module.exports.JsonViewer = $aa28d7d45cf2f7d2$var$JsonViewer;

});

parcelRegister("e6E17", function(module, exports) {
"use strict";
var $a450aac81bb82448$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $a450aac81bb82448$var$__assign = module.exports && module.exports.__assign || function() {
    $a450aac81bb82448$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a450aac81bb82448$var$__assign.apply(this, arguments);
};
var $a450aac81bb82448$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $a450aac81bb82448$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Snack = module.exports.SnackPrinter = module.exports.SnackOptions = void 0;

var $iqyiC = parcelRequire("iqyiC");

var $6wI3m = parcelRequire("6wI3m");

var $1bL1j = parcelRequire("1bL1j");

var $joGvE = parcelRequire("joGvE");

var $gkD0R = parcelRequire("gkD0R");
var $a450aac81bb82448$var$SnackOptions = /** @class */ function() {
    function SnackOptions() {
        this.autoCloseTimeout = 4500;
        this.showCloseButton = true;
        this.clickAnywhereToClose = false;
        this.showTimeoutBar = true;
    }
    return SnackOptions;
}();
module.exports.SnackOptions = $a450aac81bb82448$var$SnackOptions;
var $a450aac81bb82448$var$SnackPrinter = /** @class */ function(_super) {
    $a450aac81bb82448$var$__extends(SnackPrinter, _super);
    function SnackPrinter(header, content, options) {
        var _this = _super.call(this) || this;
        _this.CloseButton = new $gkD0R.Span("\xd7").Class("tf-snack-x");
        _this.timer = null;
        var opt = $a450aac81bb82448$var$__assign($a450aac81bb82448$var$__assign({}, new $a450aac81bb82448$var$SnackOptions()), options);
        var p = new $6wI3m.Ref(100);
        if (opt.showTimeoutBar && opt.autoCloseTimeout && opt.autoCloseTimeout > 0) _this.timer = setInterval(function() {
            return p.value--;
        }, opt.autoCloseTimeout / 100);
        _this.Append(opt.showTimeoutBar && new $1bL1j.ProgressBar(p).Invert(), opt.showCloseButton && _this.CloseButton, new $joGvE.Div().Append(header).Class("tf-snack-label"), content && new $joGvE.Div().Append(content).Class("tf-snack-content"));
        return _this;
    }
    SnackPrinter.prototype.OnRemove = function() {
        return $a450aac81bb82448$var$__awaiter(this, void 0, void 0, function() {
            return $a450aac81bb82448$var$__generator(this, function(_a) {
                if (this.timer) clearInterval(this.timer);
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return SnackPrinter;
}($joGvE.Div);
module.exports.SnackPrinter = $a450aac81bb82448$var$SnackPrinter;
var $a450aac81bb82448$var$Snack = /** @class */ function(_super) {
    $a450aac81bb82448$var$__extends(Snack, _super);
    function Snack(header, content, options) {
        var _a;
        var _b;
        var _this = _super.call(this) || this;
        _this.Config = new $a450aac81bb82448$var$SnackOptions();
        _this.Class(Snack.DefaultCssClasses);
        _this.Config = $a450aac81bb82448$var$__assign($a450aac81bb82448$var$__assign({}, _this.Config), options);
        var cont = Array.isArray(content) ? (_a = new $joGvE.Div()).Append.apply(_a, content) : content;
        var printer = new $a450aac81bb82448$var$SnackPrinter(header, cont, _this.Config);
        printer.CloseButton.OnClick(function() {
            return _this.Close();
        });
        _this.Append(printer);
        if (_this.Config.clickAnywhereToClose) _this.OnClick(function() {
            _this.Close();
        });
        (_b = (0, $iqyiC.$)("body")) === null || _b === void 0 || _b.Append(_this.Element);
        if (_this.Config.autoCloseTimeout && _this.Config.autoCloseTimeout > 0) setTimeout(function() {
            return _this.Close();
        }, _this.Config.autoCloseTimeout);
        return _this;
    }
    Snack.prototype.Close = function() {
        var _a;
        (_a = (0, $iqyiC.$)("body")) === null || _a === void 0 || _a.Remove(this.Element);
        return this;
    };
    Snack.Name = "Snack";
    Snack.DefaultCssClasses = "tf-snack";
    return Snack;
}($joGvE.Div);
module.exports.Snack = $a450aac81bb82448$var$Snack;

});

parcelRegister("50yqK", function(module, exports) {
"use strict";
var $3a57a8fc65d9b876$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BasicPaginator = void 0;

var $3B1VX = parcelRequire("3B1VX");

var $2s69t = parcelRequire("2s69t");

var $kanmU = parcelRequire("kanmU");
var $3a57a8fc65d9b876$var$BasicPaginator = /** @class */ function(_super) {
    $3a57a8fc65d9b876$var$__extends(BasicPaginator, _super);
    function BasicPaginator(start, count, total, filtered) {
        var _this = _super.call(this, "paginator") || this;
        _this.count = count;
        _this.goToFirstButton = new $2s69t.Button("\xab").FontSize(18).Padding(0, 14).OnClick(function() {
            return _this.Brain.GoToFirst();
        });
        _this.gotoPreviousButton = new $2s69t.Button("\u2039").FontSize(18).Padding(0, 14).OnClick(function() {
            return _this.Brain.GoToPreviousPage();
        });
        _this.gotoNextButton = new $2s69t.Button("\u203A").FontSize(18).Padding(0, 14).OnClick(function() {
            return _this.Brain.GoToNextPage();
        });
        _this.gotoLastButton = new $2s69t.Button("\xbb").FontSize(18).Padding(0, 14).OnClick(function() {
            return _this.Brain.GoToLast();
        });
        _this.Brain = new $kanmU.PaginatorBrain(start, count, total, filtered);
        _this.display = new $3B1VX.Text(_this.Brain.display).Style("vertical-align: middle; margin: 0 16px");
        return _this;
    }
    BasicPaginator.prototype.AddGoToFirstButton = function() {
        this.Append(this.goToFirstButton);
        return this;
    };
    BasicPaginator.prototype.AddGoToPreviousButton = function() {
        this.Append(this.gotoPreviousButton);
        return this;
    };
    BasicPaginator.prototype.AddDisplay = function() {
        this.Append(this.display);
        return this;
    };
    BasicPaginator.prototype.AddGoToNextButton = function() {
        this.Append(this.gotoNextButton);
        return this;
    };
    BasicPaginator.prototype.AddGoToLastButton = function() {
        this.Append(this.gotoLastButton);
        return this;
    };
    BasicPaginator.prototype.AddPagesCountSwitch = function(pageSizes) {
        var _this = this;
        if (pageSizes === void 0) pageSizes = [
            5,
            10,
            20
        ];
        var pageSizesOptions = pageSizes.map(function(x) {
            return new $2s69t.SelectOption("".concat(x, " ").concat(_this.Brain.options.PerPageTranslation), x);
        });
        var pagesCountSwitch = new $2s69t.Select(this.count, pageSizesOptions).ModifyAfterChange(function(v) {
            return +v;
        }).WidthAuto();
        this.Append(pagesCountSwitch);
        return this;
    };
    return BasicPaginator;
}($2s69t.Div);
module.exports.BasicPaginator = $3a57a8fc65d9b876$var$BasicPaginator;

});
parcelRegister("kanmU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PaginatorBrain = module.exports.PaginatorBrainOptions = void 0;

var $6wI3m = parcelRequire("6wI3m");
var $eae6de5785a00ef7$var$PaginatorBrainOptions = /** @class */ function() {
    function PaginatorBrainOptions() {
        this.FilteredTranslation = "filtered";
        this.InTotalTranslation = "in total";
        this.NoResultsTranslation = "No results";
        this.PerPageTranslation = "per page";
    }
    return PaginatorBrainOptions;
}();
module.exports.PaginatorBrainOptions = $eae6de5785a00ef7$var$PaginatorBrainOptions;
var $eae6de5785a00ef7$var$PaginatorBrain = /** @class */ function() {
    function PaginatorBrain(start, count, total, filtered, options) {
        if (options === void 0) options = new $eae6de5785a00ef7$var$PaginatorBrainOptions();
        var _this = this;
        this.start = start;
        this.count = count;
        this.total = total;
        this.filtered = filtered;
        this.options = options;
        this.display = new $6wI3m.Ref("");
        this.start.OnChange(function(_) {
            return _this.Refresh();
        });
        this.count.OnChange(function(_) {
            return _this.Refresh();
        });
        this.total.OnChange(function(_) {
            return _this.Refresh();
        });
        this.filtered.OnChange(function(_) {
            return _this.Refresh();
        });
        this.Refresh();
    }
    PaginatorBrain.prototype.Refresh = function() {
        var _a = this.Calc(), start = _a[0], end = _a[1];
        var total = this.total.value;
        var filtered = this.filtered.value;
        if (filtered > 0 && total > 0) {
            start += 1;
            if (start > end) start = end;
        }
        if (start < 0) start = 0;
        if (filtered != total) this.display.value = "".concat(start, " - ").concat(end, " / ").concat(filtered, " ").concat(this.options.FilteredTranslation, " / ").concat(total, " ").concat(this.options.InTotalTranslation);
        else if (start == end && start == 0) this.display.value = this.options.NoResultsTranslation;
        else if (start == end) this.display.value = "".concat(start, " / ").concat(total);
        else this.display.value = "".concat(start, " - ").concat(end, " / ").concat(total);
    };
    PaginatorBrain.prototype.Calc = function() {
        var start = this.start.value;
        var count = this.count.value;
        var last = this.filtered.value;
        var end = 0;
        if (start < 0) start = 0;
        if (start >= last) start = last;
        end = start + count;
        if (end >= last) end = last;
        if (start == end && start > 0) start -= 1;
        this.start.value = start;
        return [
            start,
            end
        ];
    };
    PaginatorBrain.prototype.GoToNextPage = function() {
        this.start.value += this.count.value;
    };
    PaginatorBrain.prototype.GoToPreviousPage = function() {
        this.start.value -= this.count.value;
    };
    PaginatorBrain.prototype.GoToFirst = function() {
        this.start.value = 0;
    };
    PaginatorBrain.prototype.GoToLast = function() {
        this.start.value = this.total.value - 1;
    };
    return PaginatorBrain;
}();
module.exports.PaginatorBrain = $eae6de5785a00ef7$var$PaginatorBrain;

});


parcelRegister("et3h1", function(module, exports) {
"use strict";
var $a886502ccd1e8fc0$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SimplePaginator = void 0;

var $50yqK = parcelRequire("50yqK");
var $a886502ccd1e8fc0$var$SimplePaginator = /** @class */ function(_super) {
    $a886502ccd1e8fc0$var$__extends(SimplePaginator, _super);
    function SimplePaginator(start, count, total, filtered) {
        var _this = _super.call(this, start, count, total, filtered) || this;
        _this.AddGoToFirstButton();
        _this.AddGoToPreviousButton();
        _this.AddDisplay();
        _this.AddGoToNextButton();
        _this.AddGoToLastButton();
        _this.AddPagesCountSwitch([
            5,
            10,
            30
        ]);
        return _this;
    }
    return SimplePaginator;
}($50yqK.BasicPaginator);
module.exports.SimplePaginator = $a886502ccd1e8fc0$var$SimplePaginator;

});

parcelRegister("5snGY", function(module, exports) {
"use strict";
var $3f91f20cf066699d$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CollectionPaginator = module.exports.CollectionPaginatorOptions = void 0;

var $epBKP = parcelRequire("epBKP");

var $50yqK = parcelRequire("50yqK");
var $3f91f20cf066699d$var$CollectionPaginatorOptions = /** @class */ function() {
    function CollectionPaginatorOptions() {
        this.PerPage = [
            10,
            30,
            100
        ];
        this.PerPageStorageKey = "";
    }
    return CollectionPaginatorOptions;
}();
module.exports.CollectionPaginatorOptions = $3f91f20cf066699d$var$CollectionPaginatorOptions;
var $3f91f20cf066699d$var$CollectionPaginator = /** @class */ function(_super) {
    $3f91f20cf066699d$var$__extends(CollectionPaginator, _super);
    function CollectionPaginator(collectionView, options) {
        if (options === void 0) options = new $3f91f20cf066699d$var$CollectionPaginatorOptions();
        var _this = this;
        var start = new $epBKP.RefNumber(0);
        var count = new $epBKP.RefNumber(options.PerPage[0] || 10).Storable(options === null || options === void 0 ? void 0 : options.PerPageStorageKey);
        var total = collectionView.Collection.CountRef;
        var filtered = collectionView.FilteredCount;
        collectionView.See(start, count).Refresh();
        _this = _super.call(this, start, count, total, filtered) || this;
        _this.AddGoToFirstButton();
        _this.AddGoToPreviousButton();
        _this.AddDisplay();
        _this.AddGoToNextButton();
        _this.AddGoToLastButton();
        _this.AddPagesCountSwitch(options.PerPage);
        return _this;
    }
    return CollectionPaginator;
}($50yqK.BasicPaginator);
module.exports.CollectionPaginator = $3f91f20cf066699d$var$CollectionPaginator;

});

parcelRegister("bjWq6", function(module, exports) {
"use strict";
var $83dec913f80e5f62$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Spinner = void 0;

var $2s69t = parcelRequire("2s69t");
var $83dec913f80e5f62$var$Spinner = /** @class */ function(_super) {
    $83dec913f80e5f62$var$__extends(Spinner, _super);
    function Spinner() {
        var _this = _super.call(this, "div") || this;
        _this.Attribute("uk-spinner").Style("margin-left", "8px");
        return _this;
    }
    return Spinner;
}($2s69t.ComponentBase);
module.exports.Spinner = $83dec913f80e5f62$var$Spinner;

});

parcelRegister("ckMZV", function(module, exports) {
"use strict";
var $8fad5c3bf2fab2a9$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Pie = void 0;

var $k6KGm = parcelRequire("k6KGm");
// https://www.freecodecamp.org/news/css-only-pie-chart/
var $8fad5c3bf2fab2a9$var$Pie = /** @class */ function(_super) {
    $8fad5c3bf2fab2a9$var$__extends(Pie, _super);
    function Pie(value) {
        var _this = _super.call(this, "div", value) || this;
        _this.Refresh();
        return _this;
    // this.Style(`--p: ${value}; --b: 22px; --c: #1e87f0;`)
    // this.Text(value.toString() + "%")
    }
    Pie.prototype.Refresh = function() {
        this.Html("<div class=\"pie\" style=\"--p:".concat(this.ref.value, ";--b:18px;--c:lightblue;\">").concat(this.ref.value, "%</div>"));
    };
    Pie.Name = "Pie";
    return Pie;
}($k6KGm.RefComponentBase);
module.exports.Pie = $8fad5c3bf2fab2a9$var$Pie;

});

parcelRegister("djLWA", function(module, exports) {
"use strict";
var $9b223d6054e3ab07$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $9b223d6054e3ab07$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OnlineStorage = void 0;

var $cOIL8 = parcelRequire("cOIL8");
// TODO: remove due to better OnlineStorage @ @tblabs/storage
var $9b223d6054e3ab07$var$OnlineStorage = /** @class */ function() {
    function OnlineStorage(url) {
        this.url = url;
    }
    OnlineStorage.prototype.Upload = function(file_1, newFileNameWithoutExtension_1) {
        return $9b223d6054e3ab07$var$__awaiter(this, arguments, void 0, function(file, newFileNameWithoutExtension, folder, override) {
            var fileExtension, formData, response, fileDir, ex_1;
            if (folder === void 0) folder = "";
            if (override === void 0) override = true;
            return $9b223d6054e3ab07$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        if (!file || !(newFileNameWithoutExtension === null || newFileNameWithoutExtension === void 0 ? void 0 : newFileNameWithoutExtension.trim())) return [
                            2 /*return*/ ,
                            $cOIL8.UploadResult.Failure("No file or file name provided")
                        ];
                        fileExtension = file.name.split('.').pop();
                        formData = new FormData();
                        formData.append('file', file);
                        formData.append('folder', folder.trim());
                        formData.append('name', newFileNameWithoutExtension.trim() + "." + fileExtension);
                        formData.append('override', override ? "override-if-exist" : "throw-if-already-exist");
                        return [
                            4 /*yield*/ ,
                            fetch(this.url, {
                                method: 'POST',
                                body: formData
                            })
                        ];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) throw new Error("Request failed with status ".concat(response.status));
                        return [
                            4 /*yield*/ ,
                            response.text()
                        ];
                    case 2:
                        fileDir = _a.sent();
                        return [
                            2 /*return*/ ,
                            $cOIL8.UploadResult.Success(fileDir)
                        ];
                    case 3:
                        ex_1 = _a.sent();
                        return [
                            2 /*return*/ ,
                            $cOIL8.UploadResult.Failure("Can not upload: ".concat(ex_1.message))
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return OnlineStorage;
}();
module.exports.OnlineStorage = $9b223d6054e3ab07$var$OnlineStorage;

});
parcelRegister("cOIL8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UploadResult = void 0;
var $954cdfd10ed9378c$var$UploadResult = /** @class */ function() {
    function UploadResult(IsSuccess, UploadedFileDir, ErrorMessage) {
        if (IsSuccess === void 0) IsSuccess = false;
        if (UploadedFileDir === void 0) UploadedFileDir = "";
        if (ErrorMessage === void 0) ErrorMessage = "";
        this.IsSuccess = IsSuccess;
        this.UploadedFileDir = UploadedFileDir;
        this.ErrorMessage = ErrorMessage;
    }
    UploadResult.Success = function(dir) {
        return new UploadResult(true, dir, "");
    };
    UploadResult.Failure = function(reason) {
        return new UploadResult(false, "", reason);
    };
    return UploadResult;
}();
module.exports.UploadResult = $954cdfd10ed9378c$var$UploadResult;

});


parcelRegister("aq9Em", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Switch = void 0;
var $7963d1637bb659f7$var$Switch = /** @class */ function() {
    function Switch(valueFromCtor) {
        this.valueFromCtor = valueFromCtor;
        this.cases = {};
    }
    Switch.prototype.Case = function(value, toDo) {
        this.cases[value] = toDo;
        return this;
    };
    Switch.prototype.Default = function(toDo) {
        this.default = toDo;
        return this;
    };
    Switch.prototype.Execute = function(variable) {
        var _a, _b, _c, _d, _e, _f;
        if (!variable) return ((_b = (_a = this.cases) === null || _a === void 0 ? void 0 : _a[this.valueFromCtor]) === null || _b === void 0 ? void 0 : _b.call(_a)) || ((_c = this.default) === null || _c === void 0 ? void 0 : _c.call(this)) || undefined;
        return ((_e = (_d = this.cases) === null || _d === void 0 ? void 0 : _d[variable]) === null || _e === void 0 ? void 0 : _e.call(_d)) || ((_f = this.default) === null || _f === void 0 ? void 0 : _f.call(this)) || undefined;
    };
    return Switch;
}();
module.exports.Switch = $7963d1637bb659f7$var$Switch;

});




parcelRegister("45fvw", function(module, exports) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, 'toString')) a.toString = b.toString;
        if (hasOwnProp(b, 'valueOf')) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) console.warn('Deprecation warning: ' + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ': ' + arguments[0][key] + ', ';
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this['_' + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L'
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, '');
        return input.replace(/\\/g, '');
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = '', i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') return tok.slice(1);
            return tok;
        }).join('');
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = 'Invalid date';
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = '%d', defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }
    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years'
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year'
    };
    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === 'string') token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken('Y', 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });
    addFormatToken(0, [
        'YY',
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        'YYYY',
        4
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYY',
        5
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYYY',
        6,
        true
    ], 0, 'year');
    // PARSING
    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);
    addParseToken([
        'YYYYY',
        'YYYYYY'
    ], YEAR);
    addParseToken('YYYY', function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet('FullYear', true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken('M', [
        'MM',
        2
    ], 'Mo', function() {
        return this.month() + 1;
    });
    addFormatToken('MMM', 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken('MMMM', 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        'M',
        'MM'
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        'MMM',
        'MMMM'
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'), defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months['standalone'];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, 'Month');
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken('w', [
        'ww',
        2
    ], 'wo', 'week');
    addFormatToken('W', [
        'WW',
        2
    ], 'Wo', 'isoWeek');
    // PARSING
    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);
    addWeekParseToken([
        'w',
        'ww',
        'W',
        'WW'
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    // FORMATTING
    addFormatToken('d', 0, 'do', 'day');
    addFormatToken('dd', 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken('ddd', 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken('dddd', 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');
    // PARSING
    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        'dd',
        'ddd',
        'dddd'
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        'd',
        'e',
        'E'
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== 'string') return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === 'number') return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'), defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'), defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken('H', [
        'HH',
        2
    ], 0, 'hour');
    addFormatToken('h', [
        'hh',
        2
    ], 0, hFormat);
    addFormatToken('k', [
        'kk',
        2
    ], 0, kFormat);
    addFormatToken('hmm', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken('hmmss', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken('Hmm', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken('Hmmss', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem('a', true);
    meridiem('A', false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);
    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);
    addParseToken([
        'H',
        'HH'
    ], HOUR);
    addParseToken([
        'k',
        'kk'
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        'a',
        'A'
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        'h',
        'hh'
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet('Hours', true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? 'pm' : 'PM';
        else return isLower ? 'am' : 'AM';
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire('./locale/' + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== 'undefined' && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn('Locale ' + key + ' not found. Did you forget to load it?');
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride', "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            'YYYYYY-MM-DD',
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            'YYYY-MM-DD',
            /\d{4}-\d\d-\d\d/
        ],
        [
            'GGGG-[W]WW-E',
            /\d{4}-W\d\d-\d/
        ],
        [
            'GGGG-[W]WW',
            /\d{4}-W\d\d/,
            false
        ],
        [
            'YYYY-DDD',
            /\d{4}-\d{3}/
        ],
        [
            'YYYY-MM',
            /\d{4}-\d\d/,
            false
        ],
        [
            'YYYYYYMMDD',
            /[+-]\d{10}/
        ],
        [
            'YYYYMMDD',
            /\d{8}/
        ],
        [
            'GGGG[W]WWE',
            /\d{4}W\d{3}/
        ],
        [
            'GGGG[W]WW',
            /\d{4}W\d{2}/,
            false
        ],
        [
            'YYYYDDD',
            /\d{7}/
        ],
        [
            'YYYYMM',
            /\d{6}/,
            false
        ],
        [
            'YYYY',
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            'HH:mm:ss.SSSS',
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            'HH:mm:ss,SSSS',
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            'HH:mm:ss',
            /\d\d:\d\d:\d\d/
        ],
        [
            'HH:mm',
            /\d\d:\d\d/
        ],
        [
            'HHmmss.SSSS',
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            'HHmmss,SSSS',
            /\d\d\d\d\d\d,\d+/
        ],
        [
            'HHmmss',
            /\d\d\d\d\d\d/
        ],
        [
            'HHmm',
            /\d\d\d\d/
        ],
        [
            'HH',
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = 'Z';
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === '') return createInvalid({
            nullInput: true
        });
        if (typeof input === 'string') config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === 'string') configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isBefore', args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isAfter', args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond'
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset('Z', ':');
    offset('ZZ', '');
    // PARSING
    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken([
        'Z',
        'ZZ'
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || [
            '-',
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, 'm');
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), 'm');
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, '_locale')) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, '_isValid')) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, 'M');
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, 'Month') + months * isAdding);
        if (days) set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, 'add'), subtract = createAdder(-1, 'subtract');
    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'years',
            'year',
            'y',
            'months',
            'month',
            'M',
            'days',
            'day',
            'd',
            'dates',
            'date',
            'D',
            'hours',
            'hour',
            'h',
            'minutes',
            'minute',
            'm',
            'seconds',
            'second',
            's',
            'milliseconds',
            'millisecond',
            'ms'
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'sameDay',
            'nextDay',
            'lastDay',
            'nextWeek',
            'lastWeek',
            'sameElse'
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf('day'), format = hooks.calendarFormat(this, sod) || 'sameElse', output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return 'moment.invalid(/* ' + this._i + ' */)';
        var func = 'moment', zone = '', prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
    addFormatToken('y', [
        'y',
        1
    ], 'yo', 'eraYear');
    addFormatToken('y', [
        'yy',
        2
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyy',
        3
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyyy',
        4
    ], 0, 'eraYear');
    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);
    addParseToken([
        'N',
        'NN',
        'NNN',
        'NNNN',
        'NNNNN'
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);
    addParseToken([
        'y',
        'yy',
        'yyy',
        'yyyy'
    ], YEAR);
    addParseToken([
        'yo'
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale('en')._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case 'undefined':
                    eras[i].until = Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case 'N':
                case 'NN':
                case 'NNN':
                    if (abbr === eraName) return eras[i];
                    break;
                case 'NNNN':
                    if (name === eraName) return eras[i];
                    break;
                case 'NNNNN':
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return '';
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return '';
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return '';
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    addFormatToken(0, [
        'gg',
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        'GG',
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
    // ALIASES
    // PARSING
    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);
    addWeekParseToken([
        'gggg',
        'ggggg',
        'GGGG',
        'GGGGG'
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        'gg',
        'GG'
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken('Q', 0, 'Qo', 'quarter');
    // PARSING
    addRegexToken('Q', match1);
    addParseToken('Q', function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken('D', [
        'DD',
        2
    ], 'Do', 'date');
    // PARSING
    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        'D',
        'DD'
    ], DATE);
    addParseToken('Do', function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet('Date', true);
    // FORMATTING
    addFormatToken('DDD', [
        'DDDD',
        3
    ], 'DDDo', 'dayOfYear');
    // PARSING
    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken([
        'DDD',
        'DDDD'
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }
    // FORMATTING
    addFormatToken('m', [
        'mm',
        2
    ], 0, 'minute');
    // PARSING
    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken([
        'm',
        'mm'
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet('Minutes', false);
    // FORMATTING
    addFormatToken('s', [
        'ss',
        2
    ], 0, 'second');
    // PARSING
    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken([
        's',
        'ss'
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet('Seconds', false);
    // FORMATTING
    addFormatToken('S', 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        'SS',
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        'SSS',
        3
    ], 0, 'millisecond');
    addFormatToken(0, [
        'SSSS',
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        'SSSSS',
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        'SSSSSS',
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        'SSSSSSS',
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        'SSSSSSSS',
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        'SSSSSSSSS',
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);
    var token, getSetMillisecond;
    for(token = 'SSSS'; token.length <= 9; token += 'S')addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }
    for(token = 'S'; token.length <= 9; token += 'S')addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet('Milliseconds', false);
    // FORMATTING
    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }
    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) proto[Symbol.for('nodejs.util.inspect.custom')] = function() {
        return 'Moment<' + this.format() + '>';
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || '';
        if (index != null) return get$1(format, index, field, 'month');
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, 'month');
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, 'day');
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, 'day');
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }
    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD'
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC'
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs('ms'), asSeconds = makeAs('s'), asMinutes = makeAs('m'), asHours = makeAs('h'), asDays = makeAs('d'), asWeeks = makeAs('w'), asMonths = makeAs('M'), asQuarters = makeAs('Q'), asYears = makeAs('y'), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter('milliseconds'), seconds = makeGetter('seconds'), minutes = makeGetter('minutes'), hours = makeGetter('hours'), days = makeGetter('days'), months = makeGetter('months'), years = makeGetter('years');
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as('s')), minutes = round(duration.as('m')), hours = round(duration.as('h')), days = round(duration.as('d')), months = round(duration.as('M')), weeks = round(duration.as('w')), years = round(duration.as('y')), a = seconds <= thresholds.ss && [
            's',
            seconds
        ] || seconds < thresholds.s && [
            'ss',
            seconds
        ] || minutes <= 1 && [
            'm'
        ] || minutes < thresholds.m && [
            'mm',
            minutes
        ] || hours <= 1 && [
            'h'
        ] || hours < thresholds.h && [
            'hh',
            hours
        ] || days <= 1 && [
            'd'
        ] || days < thresholds.d && [
            'dd',
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            'w'
        ] || weeks < thresholds.w && [
            'ww',
            weeks
        ];
        a = a || months <= 1 && [
            'M'
        ] || months < thresholds.M && [
            'MM',
            months
        ] || years <= 1 && [
            'y'
        ] || [
            'yy',
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === 's') thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') withSuffix = argWithSuffix;
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
        return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');
    // PARSING
    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = '2.30.1';
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
        DATE: 'YYYY-MM-DD',
        TIME: 'HH:mm',
        TIME_SECONDS: 'HH:mm:ss',
        TIME_MS: 'HH:mm:ss.SSS',
        WEEK: 'GGGG-[W]WW',
        MONTH: 'YYYY-MM'
    };
    return hooks;
});

});























class $b216b0eb7439fe32$export$f69c19e57285b83a {
    Name;
    Body;
    constructor(Name, Body){
        this.Name = Name;
        this.Body = Body;
    }
}


class $5c97da8b615e66f9$export$44b688a57c0ea831 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, Dataset){
        super("GetMetadata", {
            Database: Database,
            Dataset: Dataset
        });
    }
}



class $45a158b08e11d32b$export$7ce83225b1a2ab35 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, Dataset){
        super("DropDataset", {
            Database: Database,
            Dataset: Dataset
        });
    }
}


class $6afb9edbb9c148cf$export$a9076aff4a6d0070 {
    _db;
    dataset;
    constructor(_db, dataset){
        this._db = _db;
        this.dataset = dataset;
    }
    get Name() {
        return this.dataset;
    }
    get Database() {
        return this._db;
    }
    get DatasetPath() {
        return this._db.DatabaseDir + "/Datasets/" + this.dataset;
    }
    async GetMetadata() {
        const response = await this._db.Send(new (0, $5c97da8b615e66f9$export$44b688a57c0ea831)(this._db.DatabaseDir, this.dataset));
        if (!response.IsSuccess) throw new Error("Failed to get metadata: " + response.ErrorMessage);
        return response.Result;
    }
    CanUserDo(action) {
        if (!this._db.User.Privileges) return false;
        if (this._db.User.Privileges?.[action] && typeof this._db.User.Privileges[action] === "object") return (this._db.User.Privileges[action].Datasets == "all" || this._db.User.Privileges[action].Datasets?.includes(this.dataset)) ?? false;
        if (this._db.User.Privileges?.[action] && typeof this._db.User.Privileges[action] === "boolean") return this._db.User.Privileges[action];
        return false;
    }
    Log(message) {
        this._db.Log(message);
    }
    async Drop() {
        this.Log(`Dropping "${this.DatasetPath}"...`);
        const result = await this._db.Send(new (0, $45a158b08e11d32b$export$7ce83225b1a2ab35)(this._db.DatabaseDir, this.dataset));
        if (!result.IsSuccess) throw new Error("Failed to drop dataset: " + result.ErrorMessage);
        this.Log(`"${this.DatasetPath}" dropped successfully.`);
    }
}


var $d83b6b847cfe9f3e$export$69e133a2b31764a9;
(function(DatasetType) {
    DatasetType["Unknown"] = "Unknown";
    DatasetType["Object"] = "Object";
    DatasetType["Text"] = "Text";
    DatasetType["Picture"] = "Picture";
    DatasetType["File"] = "File";
})($d83b6b847cfe9f3e$export$69e133a2b31764a9 || ($d83b6b847cfe9f3e$export$69e133a2b31764a9 = {}));




class $e4e5ebdfac92419f$export$c8c5e7182924d536 {
    ToRaw(target) {
        try {
            return this.ConvertToRaw(target);
        } catch (ex) {
            console.error(`Conversion from object to raw problem: ${ex.message}\n\nStack trace: ${ex.stack}\n\nObject:`, target);
            throw ex;
        }
    }
    FromRaw(raw) {
        try {
            return this.ConvertFromRaw(raw);
        } catch (ex) {
            console.error(`Conversion from raw to object problem: ${ex.message}\n\nStack trace: ${ex.stack}\n\nRaw:`, raw);
            throw ex;
        }
    }
    GetArray(value, creator) {
        const items = value?.map((x)=>creator(x));
        return items || [];
    }
    GetString(value) {
        return value || "";
    }
    GetNumber(value) {
        return +value || 0;
    }
    GetBool(value) {
        return !!value || false;
    }
    GetDate(date) {
        return date ? new Date(date) : new Date(0);
    }
}



class $ce85a2da75640367$export$c12b8c1beca20106 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, Dataset, ObjectId, Content){
        super("AddObject", {
            Database: Database,
            Dataset: Dataset,
            ObjectId: ObjectId,
            Content: Content
        });
    }
}



class $804cc7411a7d35d9$export$4df9e803b7373792 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, Dataset){
        super("ListObjects", {
            Database: Database,
            Dataset: Dataset
        });
    }
}



class $096817e3afb8207a$export$c63583173c519c11 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, Dataset, ObjectId, Content){
        super("UpdateObject", {
            Database: Database,
            Dataset: Dataset,
            ObjectId: ObjectId,
            Content: Content
        });
    }
}



class $c88a2226128c76ac$export$909394e50a5801cc extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, Dataset){
        super("ListObjectsIds", {
            Database: Database,
            Dataset: Dataset
        });
    }
}




class $e3183d94f6dbf053$export$1d3bda4c95d1bbeb {
    FromRaw(raw) {
        return raw;
    }
    ToRaw(item) {
        return item;
    }
}



class $cf2760f70c387ac3$export$7e9a3988c01bcb96 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, Dataset, ObjectId){
        super("GetObject", {
            Database: Database,
            Dataset: Dataset,
            ObjectId: ObjectId
        });
    }
}



class $fab5932668ba36df$export$d60592d05571c4ef extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, Dataset, ObjectId){
        super("DeleteObject", {
            Database: Database,
            Dataset: Dataset,
            ObjectId: ObjectId
        });
    }
}


class $75f1f7875a1df277$export$627789366574b89f extends (0, $6afb9edbb9c148cf$export$a9076aff4a6d0070) {
    _db;
    dataset;
    _converter;
    Type = (0, $d83b6b847cfe9f3e$export$69e133a2b31764a9).Object;
    constructor(_db, dataset, _converter = new (0, $e3183d94f6dbf053$export$1d3bda4c95d1bbeb)()){
        super(_db, dataset);
        this._db = _db;
        this.dataset = dataset;
        this._converter = _converter;
    }
    async GetOne(id) {
        this.Log(`Fetching "${id}"...`);
        const queryResult = await this._db.Send(new (0, $cf2760f70c387ac3$export$7e9a3988c01bcb96)(this._db.DatabaseDir, this.dataset, id));
        if (!queryResult.IsSuccess) throw new Error("Failed to get one object: " + queryResult.ErrorMessage);
        const rawItem = queryResult.Result;
        const item = this._converter.FromRaw(rawItem);
        this.Log(`Fetched "${id}" from "${this.DatasetPath}".`);
        return item;
    }
    async GetAll() {
        this.Log(`Fetching all from "${this.DatasetPath}"...`);
        const queryResult = await this._db.Send(new (0, $804cc7411a7d35d9$export$4df9e803b7373792)(this._db.DatabaseDir, this.dataset));
        if (!queryResult.IsSuccess) throw new Error("Failed to fetch all items: " + queryResult.ErrorMessage);
        const rawItems = queryResult.Result;
        const items = rawItems.map((raw)=>this._converter.FromRaw(raw));
        this.Log(`Fetched ${items.length} items from "${this.DatasetPath}".`);
        return items;
    }
    async GetAllIds() {
        this.Log(`Fetching all objects IDs from "${this.DatasetPath}"...`);
        const queryResult = await this._db.Send(new (0, $c88a2226128c76ac$export$909394e50a5801cc)(this._db.DatabaseDir, this.dataset));
        if (!queryResult.IsSuccess) throw new Error("Failed to fetch all objects ids: " + queryResult.ErrorMessage);
        const ids = queryResult.Result;
        this.Log(`Found ${ids.length} objects in "${this.DatasetPath}".`);
        return ids;
    }
    async Add(id, item) {
        this.Log(`Adding "${id}" to "${this.DatasetPath}"...`);
        const rawItem = this._converter.ToRaw(item);
        const result = await this._db.Send(new (0, $ce85a2da75640367$export$c12b8c1beca20106)(this._db.DatabaseDir, this.dataset, id, rawItem));
        if (!result.IsSuccess) throw new Error("Failed to add item: " + result.ErrorMessage);
        this.Log(`"${id}" added to "${this.DatasetPath}".`);
    }
    async Update(id, item) {
        this.Log(`Updating "${id}"...`);
        const rawItem = this._converter.ToRaw(item);
        const result = await this._db.Send(new (0, $096817e3afb8207a$export$c63583173c519c11)(this._db.DatabaseDir, this.dataset, id, rawItem));
        if (!result.IsSuccess) throw new Error("Failed to update item: " + result.ErrorMessage);
        this.Log(`"${id}" updated in "${this.DatasetPath}".`);
    }
    async Delete(id) {
        this.Log(`Deleting "${id}" from "${this.DatasetPath}"...`);
        const result = await this._db.Send(new (0, $fab5932668ba36df$export$d60592d05571c4ef)(this._db.DatabaseDir, this.dataset, id));
        if (!result.IsSuccess) throw new Error("Failed to delete object: " + result.ErrorMessage);
        this.Log(`Deleted "${id}" from "${this.DatasetPath}".`);
    }
}





class $a13627770c0f1192$export$2be762ff71c7d52d extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, Dataset, FileId, Content){
        super("AppendText", {
            Database: Database,
            Dataset: Dataset,
            FileId: FileId,
            Content: Content
        });
    }
}



class $03370006e4ef8576$export$3ce67f7a974b3d12 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, Dataset, FileId){
        super("Clear", {
            Database: Database,
            Dataset: Dataset,
            FileId: FileId
        });
    }
}



class $8e38a36ab188b89f$export$7a284a805e14b0be extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, Dataset, FileId){
        super("CreateFile", {
            Database: Database,
            Dataset: Dataset,
            FileId: FileId
        });
    }
}



class $7d97c736d7152af0$export$2ba25239d87f5d44 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, Dataset, FileId){
        super("DeleteFile", {
            Database: Database,
            Dataset: Dataset,
            FileId: FileId
        });
    }
}




class $62e770cff444bee8$export$6eb5d27576a6f8ce extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, Dataset, FileId, Offset = 0, Limit = 0){
        super("ReadText", {
            Database: Database,
            Dataset: Dataset,
            FileId: FileId,
            Offset: Offset,
            Limit: Limit
        });
    }
}



class $183ec87bb4e7b569$export$b76e0450f5b20591 extends (0, $6afb9edbb9c148cf$export$a9076aff4a6d0070) {
    _db;
    dataset;
    Type = (0, $d83b6b847cfe9f3e$export$69e133a2b31764a9).Text;
    constructor(_db, dataset){
        super(_db, dataset);
        this._db = _db;
        this.dataset = dataset;
    }
    async Read(id, offset = 0, limit = 0) {
        this.Log(`Reading "${id}" from "${this.DatasetPath}"...`);
        if (limit < 0) throw new Error("Limit cannot be negative number. 0 = no limit.");
        const queryResult = await this._db.Send(new (0, $62e770cff444bee8$export$6eb5d27576a6f8ce)(this._db.DatabaseDir, this.dataset, id, offset, limit));
        if (!queryResult.IsSuccess) throw new Error("Failed to read: " + queryResult.ErrorMessage);
        const content = queryResult.Result;
        this.Log(`Read ${content.length} characters from "${id}" in "${this.DatasetPath}".`);
        return content;
    }
    async GetAllIds() {
        this.Log(`Fetching all files IDs from "${this.DatasetPath}"...`);
        const queryResult = await this._db.Send(new (0, $c88a2226128c76ac$export$909394e50a5801cc)(this._db.DatabaseDir, this.dataset));
        if (!queryResult.IsSuccess) throw new Error("Failed to fetch all items ids: " + queryResult.ErrorMessage);
        const ids = queryResult.Result;
        this.Log(`Found ${ids.length} files in "${this.DatasetPath}".`);
        return ids;
    }
    async Create(id) {
        this.Log(`Creating "${id}" in "${this.DatasetPath}"...`);
        const result = await this._db.Send(new (0, $8e38a36ab188b89f$export$7a284a805e14b0be)(this._db.DatabaseDir, this.dataset, id));
        if (!result.IsSuccess) throw new Error("Failed to create item: " + result.ErrorMessage);
        this.Log(`"${id}" created in "${this.DatasetPath}".`);
    }
    async AppendText(id, text) {
        this.Log(`Appending ${text.length} characters to "${id}" in "${this.DatasetPath}"...`);
        const result = await this._db.Send(new (0, $a13627770c0f1192$export$2be762ff71c7d52d)(this._db.DatabaseDir, this.dataset, id, text));
        if (!result.IsSuccess) throw new Error("Failed to append: " + result.ErrorMessage);
        this.Log(`${text.length} characters appended to "${id}" in "${this.DatasetPath}".`);
    }
    async Clear(id) {
        this.Log(`Clearing "${id}" in "${this.DatasetPath}"...`);
        const result = await this._db.Send(new (0, $03370006e4ef8576$export$3ce67f7a974b3d12)(this._db.DatabaseDir, this.dataset, id));
        if (!result.IsSuccess) throw new Error("Failed to clear text file: " + result.ErrorMessage);
        this.Log(`"${id}" cleared in "${this.DatasetPath}".`);
    }
    async ReplaceText(id, text) {
        this.Log(`Replacing text in "${id}" in "${this.DatasetPath}"...`);
        await this.Clear(id);
        await this.AppendText(id, text);
        this.Log(`"${id}" replaced in "${this.DatasetPath}".`);
    }
    async AppendLine(id, line) {
        await this.AppendText(id, line + "\n");
    }
    async Delete(id) {
        this.Log(`Deleting "${id}" from "${this.DatasetPath}"...`);
        const result = await this._db.Send(new (0, $7d97c736d7152af0$export$2ba25239d87f5d44)(this._db.DatabaseDir, this.dataset, id));
        if (!result.IsSuccess) throw new Error("Failed to delete item: " + result.ErrorMessage);
        this.Log(`Deleted "${id}" from "${this.DatasetPath}".`);
    }
}


class $4d2da659f2458bd1$export$dc7fb1eb9fb3a3bd {
    ToLine(entry) {
        return JSON.stringify(entry);
    }
    ToEntry(line) {
        return JSON.parse(line);
    }
}



class $5a11653556197b99$export$b381a9c9206415ff extends (0, $183ec87bb4e7b569$export$b76e0450f5b20591) {
    _db;
    dataset;
    _converter;
    constructor(_db, dataset, _converter = new (0, $4d2da659f2458bd1$export$dc7fb1eb9fb3a3bd)()){
        super(_db, dataset);
        this._db = _db;
        this.dataset = dataset;
        this._converter = _converter;
    }
    async Load(id, offset = 0, limit = 0) {
        const lines = await super.Read(id, offset, limit);
        return lines.map((line)=>this._converter.ToEntry(line));
    }
    async Append(id, entry) {
        const line = this._converter.ToLine(entry);
        await super.AppendLine(id, line);
    }
}






class $a9292ba8af43c41c$export$9e95ed3bd9bab7b0 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, Dataset, PictureDir){
        super("DeletePicture", {
            Database: Database,
            Dataset: Dataset,
            PictureDir: PictureDir
        });
    }
}



class $be72006e758513b6$export$a5b3af442ea466b6 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Server, Database, Dataset){
        super("ListPictures", {
            Server: Server,
            Database: Database,
            Dataset: Dataset
        });
    }
}



class $fac5005b6116fcf9$export$205686f7b10194b7 {
    KeepSource = true;
    Sizes = {};
}




class $42b5462dd7f06646$export$7afdc3bd517797d extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, Dataset){
        super("ListPicturesIds", {
            Database: Database,
            Dataset: Dataset
        });
    }
}



class $02741148466c919f$export$a6fb71614acfa923 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Server, Database, Dataset, FileId){
        super("GetPicture", {
            Server: Server,
            Database: Database,
            Dataset: Dataset,
            FileId: FileId
        });
    }
}


class $5640e2e8de6d5b79$export$47f3bf415b3a0f78 extends (0, $6afb9edbb9c148cf$export$a9076aff4a6d0070) {
    _db;
    dataset;
    Type = (0, $d83b6b847cfe9f3e$export$69e133a2b31764a9).Picture;
    picsConfig = new (0, $fac5005b6116fcf9$export$205686f7b10194b7)();
    constructor(_db, dataset, config){
        super(_db, dataset);
        this._db = _db;
        this.dataset = dataset;
        if (config) this.picsConfig = {
            ...this.picsConfig,
            ...config
        };
    }
    SetConfig(config) {
        this.picsConfig = {
            ...this.picsConfig,
            ...config
        };
    }
    GetConfig() {
        return this.picsConfig;
    }
    async GetAllIds() {
        const result = await this._db.Send(new (0, $42b5462dd7f06646$export$7afdc3bd517797d)(this._db.DatabaseDir, this.dataset));
        if (!result.IsSuccess) throw new Error("Failed to list pictures ids: " + result.ErrorMessage);
        return result.Result;
    }
    async GetOne(pictureDir) {
        const result = await this._db.Send(new (0, $02741148466c919f$export$a6fb71614acfa923)(this._db.Server, this._db.DatabaseDir, this.dataset, pictureDir));
        if (!result.IsSuccess) throw new Error("Failed to get picture: " + result.ErrorMessage);
        return result.Result;
    }
    async GetAll() {
        const result = await this._db.Send(new (0, $be72006e758513b6$export$a5b3af442ea466b6)(this._db.Server, this._db.DatabaseDir, this.dataset));
        if (!result.IsSuccess) throw new Error("Failed to list picture packs: " + result.ErrorMessage);
        return result.Result;
    }
    async Add(files) {
        try {
            if (!files) throw new Error("No files provided");
            const formData = new FormData();
            for(let i = 0; i < files.length; i++)formData.append('files[]', files[i]); // Tak, te [] w nazwie zmiennej są konieczne! bez tego php (mimo że odbiera przez $_FILES["files"]) nie jest w stanie odebrać wielu plików xd
            formData.append('server', this._db.Server);
            formData.append('database', this._db.DatabaseDir);
            formData.append('dataset', this.dataset);
            formData.append('config', JSON.stringify(this.picsConfig));
            formData.append('userId', this._db.User.Id);
            let serverUrl = this._db.Server;
            if (serverUrl.endsWith("/")) serverUrl = serverUrl.slice(0, -1);
            const response = await fetch(serverUrl + "/pictures-upload", {
                method: 'POST',
                body: formData
            });
            if (!response.ok) throw new Error(`Request failed with status ${response.status}`);
            const result = await response.json();
            if (!result.IsSuccess) throw new Error("Failed to upload pictures: " + result.ErrorMessage);
            return result.Result ?? [];
        } catch (ex) {
            throw new Error(`Can not upload: ${ex.message}`);
        }
    }
    async Delete(pictureDir) {
        const result = await this._db.Send(new (0, $a9292ba8af43c41c$export$9e95ed3bd9bab7b0)(this._db.DatabaseDir, this.dataset, pictureDir));
        if (!result.IsSuccess) throw new Error("Failed to delete picture: " + result.ErrorMessage);
    }
}













class $5ef429f262eed9ae$export$9537075280f3c140 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Server, Database, Dataset){
        super("ListFiles", {
            Server: Server,
            Database: Database,
            Dataset: Dataset
        });
    }
}



class $ccf5f2a8c816a8d6$export$222972f50ef41123 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, Dataset){
        super("ListFilesIds", {
            Database: Database,
            Dataset: Dataset
        });
    }
}



class $407007f4e8a9cc47$export$47a715c3138de013 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Server, Database, Dataset, FileId){
        super("GetFile", {
            Server: Server,
            Database: Database,
            Dataset: Dataset,
            FileId: FileId
        });
    }
}



class $4b8a13f98b39bd48$export$3e5661d9f1dcca0e {
    MaxDatasetSize = 1073741824;
    SingleFileMaxSize = 104857600;
    AllowedExtensions = "any";
}


class $73db00c56adeadd0$export$30ac9230346b066 extends (0, $6afb9edbb9c148cf$export$a9076aff4a6d0070) {
    _db;
    dataset;
    Type = (0, $d83b6b847cfe9f3e$export$69e133a2b31764a9).File;
    config = new (0, $4b8a13f98b39bd48$export$3e5661d9f1dcca0e)();
    constructor(_db, dataset, config){
        super(_db, dataset);
        this._db = _db;
        this.dataset = dataset;
        if (config) this.config = {
            ...this.config,
            ...config
        };
    }
    SetConfig(config) {
        this.config = {
            ...this.config,
            ...config
        };
    }
    GetConfig() {
        return this.config;
    }
    async GetAllIds() {
        const result = await this._db.Send(new (0, $ccf5f2a8c816a8d6$export$222972f50ef41123)(this._db.DatabaseDir, this.dataset));
        if (!result.IsSuccess) throw new Error("Failed to list files ids: " + result.ErrorMessage);
        return result.Result;
    }
    async GetOne(fileId) {
        const result = await this._db.Send(new (0, $407007f4e8a9cc47$export$47a715c3138de013)(this._db.Server, this._db.DatabaseDir, this.dataset, fileId));
        if (!result.IsSuccess) throw new Error("Failed to get picture: " + result.ErrorMessage);
        return result.Result;
    }
    async GetAll() {
        const result = await this._db.Send(new (0, $5ef429f262eed9ae$export$9537075280f3c140)(this._db.Server, this._db.DatabaseDir, this.dataset));
        if (!result.IsSuccess) throw new Error("Failed to list file packs: " + result.ErrorMessage);
        return result.Result;
    }
    async Add(files) {
        try {
            if (!files) throw new Error("No files provided");
            const formData = new FormData();
            for(let i = 0; i < files.length; i++)formData.append('files[]', files[i]); // Tak, te [] w nazwie zmiennej są konieczne! bez tego php (mimo że odbiera przez $_FILES["files"]) nie jest w stanie odebrać wielu plików xd
            formData.append('server', this._db.Server);
            formData.append('database', this._db.DatabaseDir);
            formData.append('dataset', this.dataset);
            formData.append('userId', this._db.User.Id);
            formData.append('config', JSON.stringify(this.config));
            let serverUrl = this._db.Server;
            if (serverUrl.endsWith("/")) serverUrl = serverUrl.slice(0, -1);
            const response = await fetch(serverUrl + "/files-upload", {
                method: 'POST',
                body: formData
            });
            if (!response.ok) throw new Error(`Request failed with status ${response.status}`);
            const result = await response.json();
            if (!result.IsSuccess) throw new Error("Failed to upload files: " + result.ErrorMessage);
            return result.Result ?? [];
        } catch (ex) {
            throw new Error(`Can not upload file: ${ex.message}`);
        }
    }
    async Delete(fileId) {
        const result = await this._db.Send(new (0, $7d97c736d7152af0$export$2ba25239d87f5d44)(this._db.DatabaseDir, this.dataset, fileId));
        if (!result.IsSuccess) throw new Error("Failed to delete file: " + result.ErrorMessage);
    }
}







class $1d4431caad0a4ba2$export$8c36f96ba2ae5b0d {
    IsSuccess = false;
    ErrorMessage = "";
    ErrorCode = -1;
    Result = undefined;
    static Success(result) {
        const response = new $1d4431caad0a4ba2$export$8c36f96ba2ae5b0d();
        response.IsSuccess = true;
        response.Result = result;
        return response;
    }
    static Fault(errorCode, errorMessage) {
        const response = new $1d4431caad0a4ba2$export$8c36f96ba2ae5b0d();
        response.IsSuccess = false;
        response.Result = undefined;
        response.ErrorCode = errorCode || -1;
        response.ErrorMessage = errorMessage;
        return response;
    }
}


class $0ebd3f586870c7e9$export$fe2589e86ee56365 {
    serverUrl;
    sender;
    constructor(serverUrl, sender){
        this.serverUrl = serverUrl;
        this.sender = sender;
    }
    get Sender() {
        return this.sender;
    }
    SetSender(sender) {
        this.sender = sender;
        return this;
    }
    SetServer(server) {
        this.serverUrl = server;
        return this;
    }
    async SendMessage(message) {
        let messagePackage = {
            Sender: this.sender || {
                Id: "Anonymous"
            },
            Message: message
        };
        return await this.SendMessagePackage(messagePackage);
    }
    async PostJSON(data) {
        let httpResponse = {
            status: 0,
            data: undefined
        };
        const dataAsString = JSON.stringify(data);
        const response = await fetch(this.serverUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: dataAsString
        });
        httpResponse.status = response.status;
        const json = await response.json();
        httpResponse.data = json;
        return httpResponse;
    }
    async Ping() {
        try {
            const response = await fetch(this.serverUrl + "/ping", {
                method: "GET"
            });
            if (response.status != 200) return false;
            const body = await response.text();
            return body == "pong";
        } catch (ex) {
            return false;
        }
    }
    async SendMessagePackage(messagePackage) {
        try {
            const response = await this.PostJSON(messagePackage);
            if (response.status == 200 && response.data.IsSuccess == true) {
                const result = response.data;
                return (0, $1d4431caad0a4ba2$export$8c36f96ba2ae5b0d).Success(result.Result);
            } else if (response.status == 200 && response.data.IsSuccess == false) return (0, $1d4431caad0a4ba2$export$8c36f96ba2ae5b0d).Fault(response.status, response.data.ErrorMessage);
            return (0, $1d4431caad0a4ba2$export$8c36f96ba2ae5b0d).Fault(response.status, "Non-200 status");
        } catch (ex) {
            return (0, $1d4431caad0a4ba2$export$8c36f96ba2ae5b0d).Fault(ex.response?.status, ex.message);
        }
    }
}



class $01c7686b748260ee$export$9ab52704d0773c02 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, Type, Dataset){
        super("CreateDataset", {
            Database: Database,
            Type: Type,
            Dataset: Dataset
        });
    }
}



class $1e9c1748f4e80b89$export$3771dfdca41a73cb extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, Dataset){
        super("DatasetExists", {
            Database: Database,
            Dataset: Dataset
        });
    }
}



class $c69a319b14a3f741$export$fbcbdb743352704d extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, Dataset){
        super("RemoveDataset", {
            Database: Database,
            Dataset: Dataset
        });
    }
}




class $85b2ca0db3fcf386$export$c68a8fe67ac55f0a extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, ObjectId, Source, Target){
        super("MoveObject", {
            Database: Database,
            ObjectId: ObjectId,
            Source: Source,
            Target: Target
        });
    }
}



class $c7a20a66c26cd9cc$export$438b9770139752e8 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, Password, Login){
        super("LoginUser", {
            Database: Database,
            Password: Password,
            Login: Login
        });
    }
}



class $e6a3009419252341$export$e8eea69f349ac16b extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database){
        super("ListUsers", {
            Database: Database
        });
    }
}



class $d1217b689949d4b5$export$2fcccd4a7b9ac845 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, User){
        super("UpdateUser", {
            Database: Database,
            User: User
        });
    }
}



class $d53b721476fd0e13$export$daebbca9d9338bc extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, User){
        super("AddUser", {
            Database: Database,
            User: User
        });
    }
}



class $49ebf2e3c9d0414c$export$16745b1b4cbcf131 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, UserId){
        super("DeleteUser", {
            Database: Database,
            UserId: UserId
        });
    }
}



class $341fd7216a697b68$export$2c2cfb7ca1cbc644 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, UserId){
        super("GetUser", {
            Database: Database,
            UserId: UserId
        });
    }
}



class $017449eabfa9cc97$export$54e721faba08510a extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, Id){
        super("GetLog", {
            Database: Database,
            Id: Id
        });
    }
}



class $0b12de66db7fc647$export$f4bc86deee9ad8c extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database){
        super("ListLogsIds", {
            Database: Database
        });
    }
}



class $bfea829df9966a60$export$8306c05e5eceab13 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(){
        super("ListDatabases", {});
    }
}



class $8cd99d2756d53677$export$75790cd217c136b7 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database){
        super("CreateDatabase", {
            Database: Database
        });
    }
}



class $9e5c29a9040d7100$export$532f827abef81411 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database){
        super("ListDatasets", {
            Database: Database
        });
    }
}



class $1150d16d79392866$export$ae7689aec281aea8 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database){
        super("DeleteDatabase", {
            Database: Database
        });
    }
}






class $ae1a5cf54ffb33b6$export$5d991cdc62928edb {
    server;
    database;
    sender;
    ANONYMOUS_USER = {
        Id: "Anonymous"
    };
    user = this.ANONYMOUS_USER;
    logEnabled = false;
    _bus;
    onUserChange = [];
    USER_LOCAL_STORAGE_KEY_PREFIX = "OnlineStorage:User:";
    userLocalStorageKey = "";
    get Server() {
        return this.server;
    }
    get DatabaseDir() {
        return this.database;
    }
    get User() {
        return this.user;
    }
    constructor(server, database, sender = this.ANONYMOUS_USER, bus){
        this.server = server;
        this.database = database;
        this.sender = sender;
        this._bus = bus || new (0, $0ebd3f586870c7e9$export$fe2589e86ee56365)(server, sender);
        this.userLocalStorageKey = this.USER_LOCAL_STORAGE_KEY_PREFIX + this.database;
        if (this.LoadUserFromLocalStorage()) this.CallOnUserChanged(true);
    }
    SetServer(server) {
        this.server = server;
        this._bus.SetServer(server);
        return this;
    }
    SetDatabase(database) {
        this.database = database;
        this.userLocalStorageKey = this.USER_LOCAL_STORAGE_KEY_PREFIX + this.database;
        return this;
    }
    async ListDatasets() {
        const result = await this._bus.SendMessage(new (0, $9e5c29a9040d7100$export$532f827abef81411)(this.DatabaseDir));
        if (!result.IsSuccess) throw new Error(`Failed to list datasets: ${result.ErrorMessage}`);
        return result.Result;
    }
    async ListUsers() {
        const result = await this._bus.SendMessage(new (0, $e6a3009419252341$export$e8eea69f349ac16b)(this.DatabaseDir));
        if (!result.IsSuccess) throw new Error(`Failed to list users: ${result.ErrorMessage}`);
        return result.Result;
    }
    async GetUser(userId) {
        const result = await this._bus.SendMessage(new (0, $341fd7216a697b68$export$2c2cfb7ca1cbc644)(this.DatabaseDir, userId));
        if (!result.IsSuccess) throw new Error(`Failed to get user: ${result.ErrorMessage}`);
        return result.Result;
    }
    async AddUser(user) {
        this.Log(`Adding user "${user.Id}"...`);
        const result = await this._bus.SendMessage(new (0, $d53b721476fd0e13$export$daebbca9d9338bc)(this.DatabaseDir, user));
        if (!result.IsSuccess) throw new Error("Failed to add user: " + result.ErrorMessage);
        this.Log(`User "${user.Id}" added.`);
    }
    async UpdateUser(user) {
        this.Log(`Updating user "${user.Id}"...`);
        const result = await this._bus.SendMessage(new (0, $d1217b689949d4b5$export$2fcccd4a7b9ac845)(this.DatabaseDir, user));
        if (!result.IsSuccess) throw new Error("Failed to update user: " + result.ErrorMessage);
        this.Log(`User "${user.Id}" updated.`);
    }
    async DeleteUser(user) {
        this.Log(`Deleting user "${user.Id}"...`);
        const result = await this._bus.SendMessage(new (0, $49ebf2e3c9d0414c$export$16745b1b4cbcf131)(this.DatabaseDir, user.Id));
        if (!result.IsSuccess) throw new Error("Failed to delete user: " + result.ErrorMessage);
        this.Log(`User "${user.Id}" deleted.`);
    }
    GetObjectDataset(datasetName, converter) {
        return new (0, $75f1f7875a1df277$export$627789366574b89f)(this, datasetName, converter);
    }
    GetTextDataset(datasetName, converter) {
        return converter ? new (0, $5a11653556197b99$export$b381a9c9206415ff)(this, datasetName, converter) : new (0, $183ec87bb4e7b569$export$b76e0450f5b20591)(this, datasetName);
    }
    GetPictureDataset(datasetName, picsConfig) {
        return new (0, $5640e2e8de6d5b79$export$47f3bf415b3a0f78)(this, datasetName, picsConfig);
    }
    GetFileDataset(datasetName, config) {
        return new (0, $73db00c56adeadd0$export$30ac9230346b066)(this, datasetName, config);
    }
    IsBrowserEnvironment() {
        return typeof window !== "undefined" && typeof window.localStorage !== "undefined";
    }
    LoadUserFromLocalStorage() {
        if (this.IsBrowserEnvironment()) {
            const user = window.localStorage.getItem(this.userLocalStorageKey);
            if (user) {
                this.user = JSON.parse(user);
                this.SetUser(this.user || this.ANONYMOUS_USER);
                return true;
            }
        }
        return false;
    }
    async Login(password, login) {
        const result = await this._bus.SendMessage(new (0, $c7a20a66c26cd9cc$export$438b9770139752e8)(this.DatabaseDir, password, login));
        if (!result.IsSuccess) throw new Error("Failed to login: " + result.ErrorMessage);
        this.user = result.Result || this.ANONYMOUS_USER;
        this.SetUser(this.user);
        this.SaveUserInLocalStorage();
        this.CallOnUserChanged(false);
        return this.user;
    }
    SaveUserInLocalStorage() {
        if (this.IsBrowserEnvironment()) window.localStorage.setItem(this.userLocalStorageKey, JSON.stringify(this.user));
    }
    OnUserChange(handler) {
        this.onUserChange.push(handler);
        handler(this.user, this.IsAuthorized, true);
        return this;
    }
    //
    // UWAGA!!!!!!!!!! TAK NIE MOŻNA REJESTROWAĆ Privileges!!!!!! TO MUSI SIĘ ODBYWAĆ PRZEZ INNĄ METODE ALBO INNY MECHANIZM!!!!!!!
    // Użytkownik nie może sam sobie nadawać uprawnień xddd
    //
    //
    // public async Register(id: string, role: string, name: string,
    // 	login: string, password: string, email: string,
    // 	privileges: IStorageUserPrivileges,
    // 	icon?: string, tags?: string[]): Promise<IStorageUser>
    // {
    // 	const createdAt = new Date();
    // 	const result = await this._bus.SendMessage(new RegisterCommand(this.DatabaseDir, id, role, name, login, password, email, privileges, icon, tags, createdAt));
    // 	if (!result.IsSuccess)
    // 	{
    // 		throw new Error(`Could not register: ${result.ErrorMessage}`);
    // 	}
    // 	const user = result.Result as IStorageUser;
    // 	return user;
    // }
    Logout() {
        this.SetUser(this.ANONYMOUS_USER);
        this.SaveUserInLocalStorage();
        this.CallOnUserChanged(false);
        return this;
    }
    CallOnUserChanged(appStart) {
        this.onUserChange.forEach((handler)=>handler(this.user, this.IsAuthorized, appStart));
    }
    get IsAuthorized() {
        return this.user && this.user.Id !== this.ANONYMOUS_USER.Id;
    }
    get IsNotLoggedIn() {
        return !this.user || this.user.Id === this.ANONYMOUS_USER.Id;
    }
    SetUser(user) {
        this.user = user;
        this._bus.SetSender({
            Id: user.Id
        });
        return this;
    }
    EnableLog() {
        this.logEnabled = true;
        return this;
    }
    DisableLog() {
        this.logEnabled = false;
        return this;
    }
    Log(...message) {
        if (this.logEnabled) console.log('[OnlineStorage]', ...message);
    }
    async Ping() {
        return await this._bus.Ping();
    }
    async Send(message) {
        const result = await this._bus.SendMessage(message);
        if (!result.IsSuccess) throw new Error(`Message resulted with error: ${result.ErrorMessage}`);
        return result;
    }
    async CreateDataset(type, datasetName) {
        this.Log(`Creating dataset "${datasetName}" of ${type} type...`);
        const result = await this._bus.SendMessage(new (0, $01c7686b748260ee$export$9ab52704d0773c02)(this.DatabaseDir, type, datasetName));
        if (!result.IsSuccess) throw new Error(`Failed to add dataset: ${result.ErrorMessage}`);
        this.Log(`Dataset "${datasetName}" created.`);
    }
    async DatasetExists(datasetName) {
        this.Log(`Checking if dataset "${datasetName}" exists...`);
        const result = await this._bus.SendMessage(new (0, $1e9c1748f4e80b89$export$3771dfdca41a73cb)(this.DatabaseDir, datasetName));
        if (!result.IsSuccess) throw new Error(`Failed to check if dataset exists: ${result.ErrorMessage}`);
        this.Log(`Dataset "${datasetName}" ${result.Result ? "exists" : "does not exist"}.`);
        return result.Result;
    }
    async RemoveDataset(datasetName) {
        this.Log(`Removing dataset "${datasetName}"...`);
        const result = await this._bus.SendMessage(new (0, $c69a319b14a3f741$export$fbcbdb743352704d)(this.DatabaseDir, datasetName));
        if (!result.IsSuccess) throw new Error(`Failed to remove dataset: ${result.ErrorMessage}`);
        this.Log(`Dataset "${datasetName}" removed.`);
    }
    async Move(fileId, sourceDataset, targetDataset) {
        this.Log(`Moving "${fileId}" from "${sourceDataset.Name}" to "${targetDataset.Name}"...`);
        const result = await this._bus.SendMessage(new (0, $85b2ca0db3fcf386$export$c68a8fe67ac55f0a)(this.DatabaseDir, fileId, sourceDataset.Name, targetDataset.Name));
        if (!result.IsSuccess) throw new Error(`Failed to move "${fileId}" from "${sourceDataset.Name}" to "${targetDataset.Name}": ${result.ErrorMessage}`);
        this.Log(`"${fileId}" moved from "${sourceDataset.Name}" to "${targetDataset.Name}".`);
    }
    async GetLogsList() {
        const result = await this._bus.SendMessage(new (0, $0b12de66db7fc647$export$f4bc86deee9ad8c)(this.DatabaseDir));
        if (!result.IsSuccess) throw new Error(`Failed to get logs list: ${result.ErrorMessage}`);
        return result.Result;
    }
    async GetLog(id) {
        const result = await this._bus.SendMessage(new (0, $017449eabfa9cc97$export$54e721faba08510a)(this.DatabaseDir, id));
        if (!result.IsSuccess) throw new Error(`Failed to get log '${id}': ${result.ErrorMessage}`);
        return result.Result;
    }
    /*
        Search() USAGE:

        datasetId = storage.Search(fileId)
        file = dataset.GetOne(fileId)

        ;/   to jest bardziej problematyczne niż myślałem.....
        bo gdzieś przecież trzeba konwersji typu dokonać a sam search odbywa się na całej bazie
    */ // public async Search<T extends object>(fileId: string): Promise<Dataset<T>>
    // {
    // 	this.Log(`Searching for "${fileId}" in entire database...`);
    // 	const result = await this._bus.SendMessage(new SearchQuery(this.DatabaseDir, fileId));
    // 	if (!result.IsSuccess)
    // 	{
    // 		throw new Error(`Failed to find "${fileId}": ${result.ErrorMessage}`);
    // 	}
    // 	const datasetName = result.Result.Dataset;
    // 	const dataset = this.GetDataset<T>(datasetName, converter); ?????????
    // 	this.Log(`"${fileId}" found in "${dataset} dataset".`);
    // 	return result.Result;
    // }
    async ListDatabases() {
        const result = await this._bus.SendMessage(new (0, $bfea829df9966a60$export$8306c05e5eceab13)());
        if (!result.IsSuccess) throw new Error(`Failed to list databases: ${result.ErrorMessage}`);
        return result.Result;
    }
    async CreateDatabase(databaseDir) {
        const result = await this._bus.SendMessage(new (0, $8cd99d2756d53677$export$75790cd217c136b7)(databaseDir));
        if (!result.IsSuccess) throw new Error(`Failed to create database: ${result.ErrorMessage}`);
    }
    async DeleteDatabase(databaseDir) {
        const result = await this._bus.SendMessage(new (0, $1150d16d79392866$export$ae7689aec281aea8)(databaseDir));
        if (!result.IsSuccess) throw new Error(`Failed to delete database: ${result.ErrorMessage}`);
    }
    CanUser(action) {
        if (!this.User.Privileges) return false;
        if (typeof this.User.Privileges[action] === "boolean" && this.User.Privileges[action]) return !!this.User.Privileges[action];
        return false;
    }
}





var $2s69t = parcelRequire("2s69t");

var $2s69t = parcelRequire("2s69t");
class $e8b1084b28a2a5a4$export$aff4fc93593c3bcf extends (0, $2s69t.Div) {
    constructor(title, content, theme = "#a87603"){
        super();
        this.Style(`display: block; margin: 32px 0; text-align: center;`);
        this.Append(new (0, $2s69t.Div)().Style(`display: inline-block; padding: 16px; color: #222; text-align: left; border-left: 12px solid ${theme}`).Append(new (0, $2s69t.Div)().Text(title).TextAlignLeft().FontSize(20).MarginBottom(16).Color(theme), content));
    }
}


class $225750fe3a94dddc$export$6955bcca4cd3539f extends (0, $2s69t.Div) {
    constructor(pageTitle, cssClasses = ""){
        super(cssClasses), this.pageTitle = pageTitle;
        this.body = void 0;
        this.loader = new (0, $2s69t.Span)("\u0141adowanie strony...");
        this.onError = (ex)=>{
            return {
                header: "B\u0142\u0105d",
                body: ex.message
            };
        };
        this.SetTitle(this.pageTitle);
        this.body = new (0, $2s69t.Div)("");
        this.Append(new (0, $2s69t.Div)().WidthPercent(100).TextAlignCenter().Append(this.body));
    }
    SetTitle(title) {
        document.title = title instanceof (0, $2s69t.Ref) ? title.value : title || "specTeam.pl";
    }
    OnError(handler) {
        this.onError = handler;
    }
    async Content(content) {
        try {
            this.Append(this.loader);
            await content(this.body);
        } catch (ex) {
            console.error(ex);
            let problemHeader = "B\u0142\u0105d";
            let problemBody = ex.message;
            const msg = ex.message.toLowerCase();
            if (msg.includes("unauthorized")) {
                problemHeader = "Brak autoryzacji";
                problemBody = new (0, $2s69t.Button)("Zaloguj", ()=>window.location.hash = "login");
            } else if (msg.includes("failed to fetch")) {
                problemHeader = "Problem z po\u0142\u0105czeniem";
                problemBody = "Sprawd\u017A swoje po\u0142\u0105czenie z internetem i od\u015Bwie\u017C stron\u0119";
            } else {
                const onErrorResult = this.onError(ex);
                problemHeader = onErrorResult.header;
                problemBody = onErrorResult.body;
            }
            this.body.Append(new (0, $e8b1084b28a2a5a4$export$aff4fc93593c3bcf)(problemHeader, problemBody));
        } finally{
            this.loader.RemoveSelf();
        }
    }
}



var $2s69t = parcelRequire("2s69t");

var $45fvw = parcelRequire("45fvw");

var $2s69t = parcelRequire("2s69t");

var $2s69t = parcelRequire("2s69t");
var $c7471de08eaefbd0$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["Message"] = "message";
    ContentType["Pictures"] = "pictures";
    return ContentType;
}({});
class $c7471de08eaefbd0$export$ee8e9566ab2ec19f {
    constructor(id, time, userId, contentType, content){
        this.Id = "";
        this.Time = "";
        this.AuthorId = "";
        this.ContentType = "message";
        this.Content = "";
        this.Id = id;
        this.Time = time;
        this.AuthorId = userId;
        this.ContentType = contentType;
        this.Content = content;
    }
}
class $c7471de08eaefbd0$export$914d12de3ce6d893 extends $c7471de08eaefbd0$export$ee8e9566ab2ec19f {
    constructor(id, time, userId, content){
        super(id, time, userId, "message", content);
        this.Message = "";
    }
}
class $c7471de08eaefbd0$export$d29b85bfdd304094 extends $c7471de08eaefbd0$export$ee8e9566ab2ec19f {
    constructor(id, time, userId, content){
        super(id, time, userId, "pictures", content);
        this.Pictures = new (0, $2s69t.Collection)();
        const pictures = JSON.parse(content);
        this.Pictures.Load(...pictures);
    }
}



var $2s69t = parcelRequire("2s69t");

var $2s69t = parcelRequire("2s69t");
class $c6096eb82f4c4ef4$export$b59bdbef9ce70de2 extends (0, $2s69t.Div) {
    constructor(...elements){
        super();
        this.Style("display: flex; gap: 8px;");
        this.Append(...elements);
    }
}


class $653b1244c32187ac$export$d855636b6b96831d extends (0, $c6096eb82f4c4ef4$export$b59bdbef9ce70de2) {
    constructor(pictures){
        super(...pictures.Items.map((picture)=>new (0, $2s69t.Image)(picture.Files["thumbnail"]).OnClick(()=>window.open(picture.Files["big"] || picture.Files["source"], "_blank"))));
        this.Class("pictures-gallery");
    }
}


class $8a97396894c93f10$export$52499e2c5ea4b095 extends (0, $2s69t.Div) {
    constructor(type, entry){
        super("message " + type);
        const time = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(entry.Time).format(" \u2022 ddd \u2022 DD.MM.YYYY \u2022 HH:mm:ss");
        this.Append(new (0, $2s69t.Div)("message-user").Append(new (0, $2s69t.Span)(entry.AuthorId).Bold(), time), new (0, $2s69t.Div)("message-content").Append(this.DetermineMessageContent(entry)));
    }
    DetermineMessageContent(entry) {
        switch(entry.ContentType){
            case (0, $c7471de08eaefbd0$export$e2e108cbe2e4f865).Message:
                const messageEntry = entry;
                return new (0, $2s69t.Span)(messageEntry.Content);
            case (0, $c7471de08eaefbd0$export$e2e108cbe2e4f865).Pictures:
                const picturesEntry = entry;
                return new (0, $653b1244c32187ac$export$d855636b6b96831d)(picturesEntry.Pictures);
            default:
                return entry.Content;
        }
    }
}



var $2s69t = parcelRequire("2s69t");
class $3cde5f7b8664e2fd$export$5262858c2300edc1 extends (0, $2s69t.Div) {
    constructor(dataset){
        super("add-field-box");
        this.onSuccessfulUpload = void 0;
        const showUploader = new (0, $2s69t.RefBool)(false);
        this.Append(new (0, $2s69t.Button)("Dodaj zdj\u0119cia").OnClick(async ()=>showUploader.True()).Invisible(showUploader), new (0, $2s69t.MultipleFilesInput)(async (files)=>{
            try {
                new (0, $2s69t.Snack)("Rozpocz\u0119to wysy\u0142anie", files.length + " plik\xf3w");
                const uploadedPictures = await dataset.Add(files);
                this.onSuccessfulUpload?.(uploadedPictures);
                new (0, $2s69t.Snack)("Wysy\u0142anie zako\u0144czone", "\u2705 Sukces");
                showUploader.False();
            } catch (ex) {
                new (0, $2s69t.Snack)("Wysy\u0142anie zako\u0144czone", "\u274C B\u0142\u0105d: " + ex.message);
            }
        }).Visible(showUploader), new (0, $2s69t.Link)("\xd7").FontSize(20).Color("red").Bold().CursorPointer().Style(`transform: translate(-16px, -12px);`).OnClick(()=>showUploader.False()).Visible(showUploader));
    }
    OnSuccessfulUpload(onSuccessfulUpload) {
        this.onSuccessfulUpload = onSuccessfulUpload;
        return this;
    }
}


class $e56debccc88d7fec$export$161992225c9eddc extends (0, $2s69t.Div) {
    constructor(chat){
        super("chat-container"), this.chat = chat;
        this.newMessage = new (0, $2s69t.RefString)();
        this.printer = void 0;
        chat.Messages.OnChange(()=>{
            setTimeout(()=>{
                this.printer.ScrollToBottom();
            }, 100);
        });
        const sentOrReceived = (entry)=>entry.AuthorId == chat.UserId ? "sent" : "received";
        this.printer = new (0, $2s69t.CollectionPrinter)(chat.Messages, (entry)=>new (0, $8a97396894c93f10$export$52499e2c5ea4b095)(sentOrReceived(entry), entry));
        this.Append(this.printer.Class("chat-messages"), new (0, $2s69t.Span)("- Brak wiadomo\u015Bci -").Margin(32).Italic().VisibleWhen(chat.Messages.CountRef, (count)=>count == 0), // new ProgressBar(timer, "#ddd").Invert().Height(8),
        new (0, $2s69t.Div)("chat-input").Append(new (0, $3cde5f7b8664e2fd$export$5262858c2300edc1)(chat.PicturesDataset).OnSuccessfulUpload((pics)=>this.AddPictures(pics)), new (0, $2s69t.TextInput)(this.newMessage).Placeholder(`Piszesz jako ${chat.UserId}...`).OnEnterKeyPressed(async ()=>await this.SendMessage()), new (0, $2s69t.Button)("Wy\u015Blij").RemoveAllClasses().EnableWhen(this.newMessage, (msg)=>msg.length > 0).OnClick(async ()=>await this.SendMessage())));
    }
    async AddPictures(pics) {
        await this.chat.AddPictures(pics);
    }
    async SendMessage() {
        const text = this.newMessage.value;
        this.newMessage.value = "";
        await this.chat.AddMessage(text);
    }
}



var $2s69t = parcelRequire("2s69t");


class $b8cc28a602b31a1e$export$d2ae2e9ebe11d209 {
    constructor(){
        this.SPLITTER = "|";
    }
    ToLine(entry) {
        return `${entry.Id}${this.SPLITTER}${entry.Time}${this.SPLITTER}${entry.AuthorId}${this.SPLITTER}${entry.ContentType}${this.SPLITTER}${entry.Content}`;
    }
    ToEntry(line) {
        const elements = line.split(this.SPLITTER);
        const id = elements[0];
        const time = elements[1];
        const userId = elements[2];
        const contentType = elements[3];
        const content = elements[4];
        if (contentType === (0, $c7471de08eaefbd0$export$e2e108cbe2e4f865).Pictures) return new (0, $c7471de08eaefbd0$export$d29b85bfdd304094)(id, time, userId, content);
        else if (contentType === (0, $c7471de08eaefbd0$export$e2e108cbe2e4f865).Message) return new (0, $c7471de08eaefbd0$export$914d12de3ce6d893)(id, time, userId, content);
        throw new Error(`Invalid content type: ${contentType}`);
    }
}


class $0703d1bac916fec3$export$d49dffca20dba6f7 {
    get UserId() {
        return this._user.Id || "";
    }
    get PicturesDataset() {
        return this.picturesDataset;
    }
    constructor(_storage, _user, chatId){
        this._storage = _storage;
        this._user = _user;
        this.chatId = chatId;
        this.Messages = new (0, $2s69t.Collection)();
        this.messageIndex = 0;
        this.picturesDataset = void 0;
        this.textDataset = void 0;
        this.textDataset = this._storage.GetTextDataset("Chats", new (0, $b8cc28a602b31a1e$export$d2ae2e9ebe11d209)());
        this.picturesDataset = this._storage.GetPictureDataset("Pics", {
            KeepSource: false,
            Sizes: {
                "big": {
                    ResizeToHeight: 1024
                },
                "thumbnail": {
                    ResizeToHeight: 256
                }
            }
        });
    // let refreshCounter = 0;
    // let nextRefresh = 15;
    // if (0)
    // setInterval(async () =>
    // {
    //     if (refreshCounter > nextRefresh)
    //         {
    //             await this.Refresh();
    //             refreshCounter = 0;
    //             // if (nextRefresh < 60)
    //             //     nextRefresh += 10;
    //         }
    //         refreshCounter++;
    // }, 1000);
    }
    EnableAutoRefresh(interval) {
        setInterval(async ()=>{
            await this.Refresh();
        }, interval);
    }
    async Create() {
        await this.textDataset.Create(this.chatId);
    }
    async Load() {
        try {
            console.log("Loading chat...", new Date().toISOString());
            const numberOfLastMessages = 100;
            const messages = await this.textDataset.Load(this.chatId, -numberOfLastMessages);
            if (messages.length == 0) {
                console.log("No messages to load");
                return;
            }
            this.messageIndex = +messages[messages.length - 1].Id;
            this.Messages.Load(...messages);
            this.EnableAutoRefresh(15000);
        } catch (ex) {
            console.error(`Problem with chat: ${ex.message}`);
            throw new Error(`B\u{142}\u{119}dny adres chatu`);
        }
    }
    async Refresh() {
        try {
            console.log("Refreshing chat...", new Date().toISOString());
            const messages = await this.textDataset.Load(this.chatId, this.messageIndex);
            if (messages.length == 0) {
                console.log("No new messages");
                return;
            }
            this.messageIndex = +messages[messages.length - 1].Id;
            this.Messages.Add(...messages);
        } catch (ex) {
            console.error(`Problem with refreshing chat: ${ex.message}`);
            throw new Error(`Problem z od\u{15B}wie\u{17C}aniem wiadomo\u{15B}ci ${ex.message}`);
        }
    }
    async AddMessage(text) {
        this.messageIndex++;
        const entry = new (0, $c7471de08eaefbd0$export$914d12de3ce6d893)(this.messageIndex.toString(), new Date().toISOString(), this.UserId, text);
        this.Messages.Add(entry);
        await this.textDataset.Append(this.chatId, entry);
    }
    async AddPictures(pics) {
        this.messageIndex++;
        const entry = new (0, $c7471de08eaefbd0$export$d29b85bfdd304094)(this.messageIndex.toString(), new Date().toISOString(), this.UserId, JSON.stringify(pics));
        this.Messages.Add(entry);
        await this.textDataset.Append(this.chatId, entry);
    }
}


class $a7f7209a93ec1b06$export$bfa9586c766696c1 extends (0, $225750fe3a94dddc$export$6955bcca4cd3539f) {
    constructor(_storage, _user, chatId){
        super("Czat #" + chatId);
        if (!chatId) window.location.hash = "chat/new";
        this.Content(async (body)=>{
            const chat = new (0, $0703d1bac916fec3$export$d49dffca20dba6f7)(_storage, _user, chatId);
            await chat.Load();
            body.Append(new (0, $e56debccc88d7fec$export$161992225c9eddc)(chat));
        });
    }
}



var $2s69t = parcelRequire("2s69t");
var $7ffc1f94643dc7e4$var$randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $7ffc1f94643dc7e4$export$2e2bcd8739ae039 = {
    randomUUID: $7ffc1f94643dc7e4$var$randomUUID
};


// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var $568f4ee4022ba00e$var$getRandomValues;
var $568f4ee4022ba00e$var$rnds8 = new Uint8Array(16);
function $568f4ee4022ba00e$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$568f4ee4022ba00e$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $568f4ee4022ba00e$var$getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$568f4ee4022ba00e$var$getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
    return $568f4ee4022ba00e$var$getRandomValues($568f4ee4022ba00e$var$rnds8);
}


var $32c496bfb6c27b56$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;


function $46d323206dcbf256$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $32c496bfb6c27b56$export$2e2bcd8739ae039).test(uuid);
}
var $46d323206dcbf256$export$2e2bcd8739ae039 = $46d323206dcbf256$var$validate;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $1d0137947e8554ce$var$byteToHex = [];
for(var $1d0137947e8554ce$var$i = 0; $1d0137947e8554ce$var$i < 256; ++$1d0137947e8554ce$var$i)$1d0137947e8554ce$var$byteToHex.push(($1d0137947e8554ce$var$i + 0x100).toString(16).slice(1));
function $1d0137947e8554ce$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    //
    // Note to future-self: No, you can't remove the `toLowerCase()` call.
    // REF: https://github.com/uuidjs/uuid/pull/677#issuecomment-1757351351
    return ($1d0137947e8554ce$var$byteToHex[arr[offset + 0]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 1]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 2]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 3]] + '-' + $1d0137947e8554ce$var$byteToHex[arr[offset + 4]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 5]] + '-' + $1d0137947e8554ce$var$byteToHex[arr[offset + 6]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 7]] + '-' + $1d0137947e8554ce$var$byteToHex[arr[offset + 8]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 9]] + '-' + $1d0137947e8554ce$var$byteToHex[arr[offset + 10]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 11]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 12]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 13]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 14]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 15]]).toLowerCase();
}
function $1d0137947e8554ce$var$stringify(arr, offset = 0) {
    var uuid = $1d0137947e8554ce$export$8fb373d660548968(arr, offset);
    // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $46d323206dcbf256$export$2e2bcd8739ae039)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $1d0137947e8554ce$export$2e2bcd8739ae039 = $1d0137947e8554ce$var$stringify;


function $3fa3ae484854b431$var$v4(options, buf, offset) {
    if ((0, $7ffc1f94643dc7e4$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $7ffc1f94643dc7e4$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    var rnds = options.random || (options.rng || (0, $568f4ee4022ba00e$export$2e2bcd8739ae039))();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $1d0137947e8554ce$export$8fb373d660548968)(rnds);
}
var $3fa3ae484854b431$export$2e2bcd8739ae039 = $3fa3ae484854b431$var$v4;






var $2s69t = parcelRequire("2s69t");
class $d5372390156ec6d7$export$1f54913ccc4368b1 extends (0, $2s69t.Div) {
    constructor(...components){
        super();
        this.DisplayBlock().TextAlignCenter().FullWidth().Append(...components);
    }
}


class $7a08aa7fe5e5e183$export$54afac56558743a9 extends (0, $225750fe3a94dddc$export$6955bcca4cd3539f) {
    constructor(_storage, _user){
        super("Nowy czat");
        this.Content(async (body)=>{
            const userName = new (0, $2s69t.RefString)();
            body.Append("\n\nWpisz swoj\u0105 nazw\u0119 u\u017Cytkownika albo zostanie przydzielona losowa nazwa\n\n", new (0, $2s69t.TextInput)(userName).WidthAuto().Placeholder("Nazwa u\u017Cytkownika"), "\n", new (0, $2s69t.Button)("Utw\xf3rz nowy czat").Class("uk-button uk-button-primary").MarginTop(8).OnClick(async ()=>{
                try {
                    _user.Id = userName.value.trim().replaceAll(";", "_");
                    const randomId = (0, $3fa3ae484854b431$export$2e2bcd8739ae039)();
                    const newChatId = randomId.substring(0, 8).toUpperCase();
                    const chat = new (0, $0703d1bac916fec3$export$d49dffca20dba6f7)(_storage, _user, newChatId);
                    await chat.Create();
                    window.location.hash = `chat/${newChatId}`;
                } catch (ex) {
                    this.Clear().Append(new (0, $e8b1084b28a2a5a4$export$aff4fc93593c3bcf)("Nie uda\u0142o si\u0119 utworzy\u0107 czatu", ex.message), new (0, $d5372390156ec6d7$export$1f54913ccc4368b1)(new (0, $2s69t.Button)("Spr\xf3buj ponownie").Class("uk-button uk-button-primary").MarginTop(8).OnClick(async ()=>window.location.reload())));
                }
            }), "\n\nDo czata ma dost\u0119p ka\u017Cdy kto ma link i nikt poza tym.\nCzat nie od\u015Bwie\u017Ca si\u0119 automatycznie!");
        });
    }
}



var $2s69t = parcelRequire("2s69t");
class $2d8ee4d91196a390$export$88f24fd8fcfab6ca {
    constructor(){
        this.id = "";
    }
    set Id(value) {
        this.id = value;
        window.localStorage.setItem("unique-chat-user-id", this.id);
    }
    get Id() {
        if (this.id) return this.id;
        let uniqueClientId = window.localStorage.getItem("unique-chat-user-id") || "";
        if (!uniqueClientId) {
            uniqueClientId = "CU" + Math.random().toString(16).substring(2, 6).toUpperCase();
            window.localStorage.setItem("unique-chat-user-id", uniqueClientId);
        }
        this.id = uniqueClientId;
        return this.id;
    }
    get Info() {
        try {
            const info = {
                ua: navigator.userAgent,
                platform: navigator.platform,
                lang: navigator.language,
                tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
                screen: `${screen.width}x${screen.height}x${screen.colorDepth}`,
                viewport: `${window.innerWidth}x${window.innerHeight}@${window.devicePixelRatio}`,
                touch: navigator.maxTouchPoints || 0
            };
            return JSON.stringify(info);
        } catch (ex) {
            return "(no client info)";
        }
    }
}


(0, $2s69t.TextInput).DefaultCssClasses = "uk-input";
var $f43313d21d3fd8e2$export$6c0517834721cef7 = /*#__PURE__*/ function(Env) {
    Env["Local"] = "local";
    Env["Stage"] = "stage";
    Env["Prod"] = "prod";
    return Env;
}({});
class $f43313d21d3fd8e2$export$7bc334c5772eb68c {
    get Env() {
        // return Env.Prod;
        if (window.location.origin.includes("localhost")) return "local";
        else if (window.location.origin.includes("stage")) return "stage";
        else return "prod";
    }
    constructor(){
        console.log(`Assuming environment is ${this.Env} (window origin: ${window.location.origin})`);
    }
}
(async ()=>{
    const root = new (0, $2s69t.Root)("body");
    const hash = new (0, $2s69t.HashRef)();
    const _envDetector = new $f43313d21d3fd8e2$export$7bc334c5772eb68c();
    const storageUrl = new (0, $2s69t.Switch)(_envDetector.Env).Case("local", ()=>'http://localhost/storageV5/src/').Case("stage", ()=>'https://stage.storage.specteam.pl/v5/').Case("prod", ()=>'https://storage.specteam.pl/v5/').Default(()=>'https://storage.specteam.pl/v5/').Execute() || "";
    const db = "Chat";
    const _storage = new (0, $ae1a5cf54ffb33b6$export$5d991cdc62928edb)(storageUrl, db);
    const _user = new (0, $2d8ee4d91196a390$export$88f24fd8fcfab6ca)();
    const pagesSwitcher = new (0, $2s69t.DestroyingPatternContentSwitcher)(hash);
    pagesSwitcher.AddContent("chat/new", ()=>new (0, $7a08aa7fe5e5e183$export$54afac56558743a9)(_storage, _user)).AddContent("chat/:id", ({ id: id })=>new (0, $a7f7209a93ec1b06$export$bfa9586c766696c1)(_storage, _user, id)).AddDefaultContent(()=>new (0, $7a08aa7fe5e5e183$export$54afac56558743a9)(_storage, _user)).Refresh();
    root.Class("main").Append(new (0, $2s69t.Div)("main__container").Append(pagesSwitcher));
})();


//# sourceMappingURL=index.2507bb41.js.map
